function _typeof(e) {
    return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
            }
            : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
            })(e);
}
!(function (e, t) {
    "use strict";
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports)
        ? (module.exports = e.document
            ? t(e, !0)
            : function (e) {
                if (!e.document) throw new Error("jQuery requires a window with a document");
                return t(e);
            })
        : t(e);
})("undefined" != typeof window ? window : this, function (k, e) {
    "use strict";
    function g(e) {
        return null != e && e === e.window;
    }
    var t = [],
        i = Object.getPrototypeOf,
        a = t.slice,
        v = t.flat
            ? function (e) {
                return t.flat.call(e);
            }
            : function (e) {
                return t.concat.apply([], e);
            },
        l = t.push,
        o = t.indexOf,
        n = {},
        r = n.toString,
        m = n.hasOwnProperty,
        s = m.toString,
        c = s.call(Object),
        y = {},
        b = function (e) {
            return "function" == typeof e && "number" != typeof e.nodeType;
        },
        S = k.document,
        d = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function w(e, t, n) {
        var i,
            o,
            r = (n = n || S).createElement("script");
        if (((r.text = e), t)) for (i in d) (o = t[i] || (t.getAttribute && t.getAttribute(i))) && r.setAttribute(i, o);
        n.head.appendChild(r).parentNode.removeChild(r);
    }
    function x(e) {
        return null == e
            ? e + ""
            : "object" == _typeof(e) || "function" == typeof e
                ? n[r.call(e)] || "object"
                : _typeof(e);
    }
    var u = "3.5.1",
        C = function e(t, n) {
            return new e.fn.init(t, n);
        };
    function p(e) {
        var t = !!e && "length" in e && e.length,
            n = x(e);
        return !b(e) && !g(e) && ("array" === n || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
    }
    (C.fn = C.prototype =
    {
        jquery: u,
        constructor: C,
        length: 0,
        toArray: function () {
            return a.call(this);
        },
        get: function (e) {
            return null == e ? a.call(this) : e < 0 ? this[e + this.length] : this[e];
        },
        pushStack: function (e) {
            var t = C.merge(this.constructor(), e);
            return (t.prevObject = this), t;
        },
        each: function (e) {
            return C.each(this, e);
        },
        map: function (n) {
            return this.pushStack(
                C.map(this, function (e, t) {
                    return n.call(e, t, e);
                })
            );
        },
        slice: function () {
            return this.pushStack(a.apply(this, arguments));
        },
        first: function () {
            return this.eq(0);
        },
        last: function () {
            return this.eq(-1);
        },
        even: function () {
            return this.pushStack(
                C.grep(this, function (e, t) {
                    return (t + 1) % 2;
                })
            );
        },
        odd: function () {
            return this.pushStack(
                C.grep(this, function (e, t) {
                    return t % 2;
                })
            );
        },
        eq: function (e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : []);
        },
        end: function () {
            return this.prevObject || this.constructor();
        },
        push: l,
        sort: t.sort,
        splice: t.splice,
    }),
        (C.extend = C.fn.extend =
            function () {
                var e,
                    t,
                    n,
                    i,
                    o,
                    r,
                    s = arguments[0] || {},
                    a = 1,
                    l = arguments.length,
                    c = !1;
                for (
                    "boolean" == typeof s && ((c = s), (s = arguments[a] || {}), a++),
                    "object" == _typeof(s) || b(s) || (s = {}),
                    a === l && ((s = this), a--);
                    a < l;
                    a++
                )
                    if (null != (e = arguments[a]))
                        for (t in e)
                            (i = e[t]),
                                "__proto__" !== t &&
                                s !== i &&
                                (c && i && (C.isPlainObject(i) || (o = Array.isArray(i)))
                                    ? ((n = s[t]),
                                        (r = o && !Array.isArray(n) ? [] : o || C.isPlainObject(n) ? n : {}),
                                        (o = !1),
                                        (s[t] = C.extend(c, r, i)))
                                    : void 0 !== i && (s[t] = i));
                return s;
            }),
        C.extend({
            expando: "jQuery" + (u + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
                throw new Error(e);
            },
            noop: function () { },
            isPlainObject: function (e) {
                var t, n;
                return !(
                    !e ||
                    "[object Object]" !== r.call(e) ||
                    ((t = i(e)) && ("function" != typeof (n = m.call(t, "constructor") && t.constructor) || s.call(n) !== c))
                );
            },
            isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
            },
            globalEval: function (e, t, n) {
                w(e, { nonce: t && t.nonce }, n);
            },
            each: function (e, t) {
                var n,
                    i = 0;
                if (p(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                return e;
            },
            makeArray: function (e, t) {
                var n = t || [];
                return null != e && (p(Object(e)) ? C.merge(n, "string" == typeof e ? [e] : e) : l.call(n, e)), n;
            },
            inArray: function (e, t, n) {
                return null == t ? -1 : o.call(t, e, n);
            },
            merge: function (e, t) {
                for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
                return (e.length = o), e;
            },
            grep: function (e, t, n) {
                for (var i = [], o = 0, r = e.length, s = !n; o < r; o++) !t(e[o], o) != s && i.push(e[o]);
                return i;
            },
            map: function (e, t, n) {
                var i,
                    o,
                    r = 0,
                    s = [];
                if (p(e)) for (i = e.length; r < i; r++) null != (o = t(e[r], r, n)) && s.push(o);
                else for (r in e) null != (o = t(e[r], r, n)) && s.push(o);
                return v(s);
            },
            guid: 1,
            support: y,
        }),
        "function" == typeof Symbol && (C.fn[Symbol.iterator] = t[Symbol.iterator]),
        C.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            n["[object " + t + "]"] = t.toLowerCase();
        });
    var f = (function (n) {
        function u(e, t) {
            var n = "0x" + e.slice(1) - 65536;
            return t || (n < 0 ? String.fromCharCode(65536 + n) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320));
        }
        function o() {
            T();
        }
        var e,
            f,
            w,
            r,
            s,
            h,
            p,
            g,
            x,
            l,
            c,
            T,
            k,
            a,
            S,
            v,
            d,
            m,
            y,
            C = "sizzle" + +new Date(),
            b = n.document,
            $ = 0,
            i = 0,
            E = le(),
            A = le(),
            j = le(),
            L = le(),
            D = function (e, t) {
                return e === t && (c = !0), 0;
            },
            O = {}.hasOwnProperty,
            t = [],
            H = t.pop,
            N = t.push,
            P = t.push,
            q = t.slice,
            M = function (e, t) {
                for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
                return -1;
            },
            I =
                "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            z = "[\\x20\\t\\r\\n\\f]",
            W = "(?:\\\\[\\da-fA-F]{1,6}" + z + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            R =
                "\\[" +
                z +
                "*(" +
                W +
                ")(?:" +
                z +
                "*([*^$|!~]?=)" +
                z +
                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                W +
                "))|)" +
                z +
                "*\\]",
            F =
                ":(" +
                W +
                ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                R +
                ")*)|.*)\\)|)",
            _ = new RegExp(z + "+", "g"),
            B = new RegExp("^" + z + "+|((?:^|[^\\\\])(?:\\\\.)*)" + z + "+$", "g"),
            U = new RegExp("^" + z + "*," + z + "*"),
            X = new RegExp("^" + z + "*([>+~]|" + z + ")" + z + "*"),
            Y = new RegExp(z + "|>"),
            V = new RegExp(F),
            Q = new RegExp("^" + W + "$"),
            G = {
                ID: new RegExp("^#(" + W + ")"),
                CLASS: new RegExp("^\\.(" + W + ")"),
                TAG: new RegExp("^(" + W + "|[*])"),
                ATTR: new RegExp("^" + R),
                PSEUDO: new RegExp("^" + F),
                CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                    z +
                    "*(even|odd|(([+-]|)(\\d*)n|)" +
                    z +
                    "*(?:([+-]|)" +
                    z +
                    "*(\\d+)|))" +
                    z +
                    "*\\)|)",
                    "i"
                ),
                bool: new RegExp("^(?:" + I + ")$", "i"),
                needsContext: new RegExp(
                    "^" +
                    z +
                    "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                    z +
                    "*((?:-\\d)?\\d*)" +
                    z +
                    "*\\)|)(?=[^-]|$)",
                    "i"
                ),
            },
            K = /HTML$/i,
            Z = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            ee = /^[^{]+\{\s*\[native \w/,
            te = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ne = /[+~]/,
            ie = new RegExp("\\\\[\\da-fA-F]{1,6}" + z + "?|\\\\([^\\r\\n\\f])", "g"),
            oe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            re = function (e, t) {
                return t
                    ? "\0" === e
                        ? "�"
                        : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " "
                    : "\\" + e;
            },
            se = we(
                function (e) {
                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                },
                { dir: "parentNode", next: "legend" }
            );
        try {
            P.apply((t = q.call(b.childNodes)), b.childNodes), t[b.childNodes.length].nodeType;
        } catch (e) {
            P = {
                apply: t.length
                    ? function (e, t) {
                        N.apply(e, q.call(t));
                    }
                    : function (e, t) {
                        for (var n = e.length, i = 0; (e[n++] = t[i++]););
                        e.length = n - 1;
                    },
            };
        }
        function ae(e, t, n, i) {
            var o,
                r,
                s,
                a,
                l,
                c,
                d,
                u = t && t.ownerDocument,
                p = t ? t.nodeType : 9;
            if (((n = n || []), "string" != typeof e || !e || (1 !== p && 9 !== p && 11 !== p))) return n;
            if (!i && (T(t), (t = t || k), S)) {
                if (11 !== p && (l = te.exec(e)))
                    if ((o = l[1])) {
                        if (9 === p) {
                            if (!(s = t.getElementById(o))) return n;
                            if (s.id === o) return n.push(s), n;
                        } else if (u && (s = u.getElementById(o)) && y(t, s) && s.id === o) return n.push(s), n;
                    } else {
                        if (l[2]) return P.apply(n, t.getElementsByTagName(e)), n;
                        if ((o = l[3]) && f.getElementsByClassName && t.getElementsByClassName)
                            return P.apply(n, t.getElementsByClassName(o)), n;
                    }
                if (f.qsa && !L[e + " "] && (!v || !v.test(e)) && (1 !== p || "object" !== t.nodeName.toLowerCase())) {
                    if (((d = e), (u = t), 1 === p && (Y.test(e) || X.test(e)))) {
                        for (
                            ((u = (ne.test(e) && me(t.parentNode)) || t) === t && f.scope) ||
                            ((a = t.getAttribute("id")) ? (a = a.replace(oe, re)) : t.setAttribute("id", (a = C))),
                            r = (c = h(e)).length;
                            r--;

                        )
                            c[r] = (a ? "#" + a : ":scope") + " " + be(c[r]);
                        d = c.join(",");
                    }
                    try {
                        return P.apply(n, u.querySelectorAll(d)), n;
                    } catch (t) {
                        L(e, !0);
                    } finally {
                        a === C && t.removeAttribute("id");
                    }
                }
            }
            return g(e.replace(B, "$1"), t, n, i);
        }
        function le() {
            var i = [];
            return function e(t, n) {
                return i.push(t + " ") > w.cacheLength && delete e[i.shift()], (e[t + " "] = n);
            };
        }
        function ce(e) {
            return (e[C] = !0), e;
        }
        function de(e) {
            var t = k.createElement("fieldset");
            try {
                return !!e(t);
            } catch (e) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
        }
        function ue(e, t) {
            for (var n = e.split("|"), i = n.length; i--;) w.attrHandle[n[i]] = t;
        }
        function pe(e, t) {
            var n = t && e,
                i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (i) return i;
            if (n) for (; (n = n.nextSibling);) if (n === t) return -1;
            return e ? 1 : -1;
        }
        function fe(t) {
            return function (e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t;
            };
        }
        function he(n) {
            return function (e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === n;
            };
        }
        function ge(t) {
            return function (e) {
                return "form" in e
                    ? e.parentNode && !1 === e.disabled
                        ? "label" in e
                            ? "label" in e.parentNode
                                ? e.parentNode.disabled === t
                                : e.disabled === t
                            : e.isDisabled === t || (e.isDisabled !== !t && se(e) === t)
                        : e.disabled === t
                    : "label" in e && e.disabled === t;
            };
        }
        function ve(s) {
            return ce(function (r) {
                return (
                    (r = +r),
                    ce(function (e, t) {
                        for (var n, i = s([], e.length, r), o = i.length; o--;) e[(n = i[o])] && (e[n] = !(t[n] = e[n]));
                    })
                );
            });
        }
        function me(e) {
            return e && void 0 !== e.getElementsByTagName && e;
        }
        for (e in ((f = ae.support = {}),
            (s = ae.isXML =
                function (e) {
                    var t = e.namespaceURI,
                        n = (e.ownerDocument || e).documentElement;
                    return !K.test(t || (n && n.nodeName) || "HTML");
                }),
            (T = ae.setDocument =
                function (e) {
                    var t,
                        n,
                        i = e ? e.ownerDocument || e : b;
                    return (
                        i != k &&
                        9 === i.nodeType &&
                        i.documentElement &&
                        ((a = (k = i).documentElement),
                            (S = !s(k)),
                            b != k &&
                            (n = k.defaultView) &&
                            n.top !== n &&
                            (n.addEventListener
                                ? n.addEventListener("unload", o, !1)
                                : n.attachEvent && n.attachEvent("onunload", o)),
                            (f.scope = de(function (e) {
                                return (
                                    a.appendChild(e).appendChild(k.createElement("div")),
                                    void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                                );
                            })),
                            (f.attributes = de(function (e) {
                                return (e.className = "i"), !e.getAttribute("className");
                            })),
                            (f.getElementsByTagName = de(function (e) {
                                return e.appendChild(k.createComment("")), !e.getElementsByTagName("*").length;
                            })),
                            (f.getElementsByClassName = ee.test(k.getElementsByClassName)),
                            (f.getById = de(function (e) {
                                return (a.appendChild(e).id = C), !k.getElementsByName || !k.getElementsByName(C).length;
                            })),
                            f.getById
                                ? ((w.filter.ID = function (e) {
                                    var t = e.replace(ie, u);
                                    return function (e) {
                                        return e.getAttribute("id") === t;
                                    };
                                }),
                                    (w.find.ID = function (e, t) {
                                        if (void 0 !== t.getElementById && S) {
                                            var n = t.getElementById(e);
                                            return n ? [n] : [];
                                        }
                                    }))
                                : ((w.filter.ID = function (e) {
                                    var n = e.replace(ie, u);
                                    return function (e) {
                                        var t = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                        return t && t.value === n;
                                    };
                                }),
                                    (w.find.ID = function (e, t) {
                                        if (void 0 !== t.getElementById && S) {
                                            var n,
                                                i,
                                                o,
                                                r = t.getElementById(e);
                                            if (r) {
                                                if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                                                for (o = t.getElementsByName(e), i = 0; (r = o[i++]);)
                                                    if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                                            }
                                            return [];
                                        }
                                    })),
                            (w.find.TAG = f.getElementsByTagName
                                ? function (e, t) {
                                    return void 0 !== t.getElementsByTagName
                                        ? t.getElementsByTagName(e)
                                        : f.qsa
                                            ? t.querySelectorAll(e)
                                            : void 0;
                                }
                                : function (e, t) {
                                    var n,
                                        i = [],
                                        o = 0,
                                        r = t.getElementsByTagName(e);
                                    if ("*" !== e) return r;
                                    for (; (n = r[o++]);) 1 === n.nodeType && i.push(n);
                                    return i;
                                }),
                            (w.find.CLASS =
                                f.getElementsByClassName &&
                                function (e, t) {
                                    if (void 0 !== t.getElementsByClassName && S) return t.getElementsByClassName(e);
                                }),
                            (d = []),
                            (v = []),
                            (f.qsa = ee.test(k.querySelectorAll)) &&
                            (de(function (e) {
                                var t;
                                (a.appendChild(e).innerHTML =
                                    "<a id="&quot; +
                                    C +
                                    &quot;"></a><select id="&quot; +
                                    C +
                                    &quot;-\r\\" msallowcapture=""><option selected=""></option></select>"),
                                    e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + z + "*(?:''|\"\")"),
                                    e.querySelectorAll("[selected]").length || v.push("\\[" + z + "*(?:value|" + I + ")"),
                                    e.querySelectorAll("[id~=" + C + "-]").length || v.push("~="),
                                    (t = k.createElement("input")).setAttribute("name", ""),
                                    e.appendChild(t),
                                    e.querySelectorAll("[name='']").length || v.push("\\[" + z + "*name" + z + "*=" + z + "*(?:''|\"\")"),
                                    e.querySelectorAll(":checked").length || v.push(":checked"),
                                    e.querySelectorAll("a#" + C + "+*").length || v.push(".#.+[+~]"),
                                    e.querySelectorAll("\\\f"),
                                    v.push("[\\r\\n\\f]");
                            }),
                                de(function (e) {
                                    e.innerHTML = "<a href="" disabled="disabled"></a><select disabled="disabled"><option></option></select>";
                                    var t = k.createElement("input");
                                    t.setAttribute("type", "hidden"),
                                        e.appendChild(t).setAttribute("name", "D"),
                                        e.querySelectorAll("[name=d]").length && v.push("name" + z + "*[*^$|!~]?="),
                                        2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"),
                                        (a.appendChild(e).disabled = !0),
                                        2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"),
                                        e.querySelectorAll("*,:x"),
                                        v.push(",.*:");
                                })),
                            (f.matchesSelector = ee.test(
                                (m =
                                    a.matches ||
                                    a.webkitMatchesSelector ||
                                    a.mozMatchesSelector ||
                                    a.oMatchesSelector ||
                                    a.msMatchesSelector)
                            )) &&
                            de(function (e) {
                                (f.disconnectedMatch = m.call(e, "*")), m.call(e, "[s!='']:x"), d.push("!=", F);
                            }),
                            (v = v.length && new RegExp(v.join("|"))),
                            (d = d.length && new RegExp(d.join("|"))),
                            (t = ee.test(a.compareDocumentPosition)),
                            (y =
                                t || ee.test(a.contains)
                                    ? function (e, t) {
                                        var n = 9 === e.nodeType ? e.documentElement : e,
                                            i = t && t.parentNode;
                                        return (
                                            e === i ||
                                            !(
                                                !i ||
                                                1 !== i.nodeType ||
                                                !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i))
                                            )
                                        );
                                    }
                                    : function (e, t) {
                                        if (t) for (; (t = t.parentNode);) if (t === e) return !0;
                                        return !1;
                                    }),
                            (D = t
                                ? function (e, t) {
                                    if (e === t) return (c = !0), 0;
                                    var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                    return (
                                        n ||
                                        (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) ||
                                            (!f.sortDetached && t.compareDocumentPosition(e) === n)
                                            ? e == k || (e.ownerDocument == b && y(b, e))
                                                ? -1
                                                : t == k || (t.ownerDocument == b && y(b, t))
                                                    ? 1
                                                    : l
                                                        ? M(l, e) - M(l, t)
                                                        : 0
                                            : 4 & n
                                                ? -1
                                                : 1)
                                    );
                                }
                                : function (e, t) {
                                    if (e === t) return (c = !0), 0;
                                    var n,
                                        i = 0,
                                        o = e.parentNode,
                                        r = t.parentNode,
                                        s = [e],
                                        a = [t];
                                    if (!o || !r) return e == k ? -1 : t == k ? 1 : o ? -1 : r ? 1 : l ? M(l, e) - M(l, t) : 0;
                                    if (o === r) return pe(e, t);
                                    for (n = e; (n = n.parentNode);) s.unshift(n);
                                    for (n = t; (n = n.parentNode);) a.unshift(n);
                                    for (; s[i] === a[i];) i++;
                                    return i ? pe(s[i], a[i]) : s[i] == b ? -1 : a[i] == b ? 1 : 0;
                                })),
                        k
                    );
                }),
            (ae.matches = function (e, t) {
                return ae(e, null, null, t);
            }),
            (ae.matchesSelector = function (e, t) {
                if ((T(e), f.matchesSelector && S && !L[t + " "] && (!d || !d.test(t)) && (!v || !v.test(t))))
                    try {
                        var n = m.call(e, t);
                        if (n || f.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
                    } catch (e) {
                        L(t, !0);
                    }
                return 0 < ae(t, k, null, [e]).length;
            }),
            (ae.contains = function (e, t) {
                return (e.ownerDocument || e) != k && T(e), y(e, t);
            }),
            (ae.attr = function (e, t) {
                (e.ownerDocument || e) != k && T(e);
                var n = w.attrHandle[t.toLowerCase()],
                    i = n && O.call(w.attrHandle, t.toLowerCase()) ? n(e, t, !S) : void 0;
                return void 0 !== i
                    ? i
                    : f.attributes || !S
                        ? e.getAttribute(t)
                        : (i = e.getAttributeNode(t)) && i.specified
                            ? i.value
                            : null;
            }),
            (ae.escape = function (e) {
                return (e + "").replace(oe, re);
            }),
            (ae.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (ae.uniqueSort = function (e) {
                var t,
                    n = [],
                    i = 0,
                    o = 0;
                if (((c = !f.detectDuplicates), (l = !f.sortStable && e.slice(0)), e.sort(D), c)) {
                    for (; (t = e[o++]);) t === e[o] && (i = n.push(o));
                    for (; i--;) e.splice(n[i], 1);
                }
                return (l = null), e;
            }),
            (r = ae.getText =
                function (e) {
                    var t,
                        n = "",
                        i = 0,
                        o = e.nodeType;
                    if (o) {
                        if (1 === o || 9 === o || 11 === o) {
                            if ("string" == typeof e.textContent) return e.textContent;
                            for (e = e.firstChild; e; e = e.nextSibling) n += r(e);
                        } else if (3 === o || 4 === o) return e.nodeValue;
                    } else for (; (t = e[i++]);) n += r(t);
                    return n;
                }),
            ((w = ae.selectors =
            {
                cacheLength: 50,
                createPseudo: ce,
                match: G,
                attrHandle: {},
                find: {},
                relative: {
                    ">": { dir: "parentNode", first: !0 },
                    " ": { dir: "parentNode" },
                    "+": { dir: "previousSibling", first: !0 },
                    "~": { dir: "previousSibling" },
                },
                preFilter: {
                    ATTR: function (e) {
                        return (
                            (e[1] = e[1].replace(ie, u)),
                            (e[3] = (e[3] || e[4] || e[5] || "").replace(ie, u)),
                            "~=" === e[2] && (e[3] = " " + e[3] + " "),
                            e.slice(0, 4)
                        );
                    },
                    CHILD: function (e) {
                        return (
                            (e[1] = e[1].toLowerCase()),
                            "nth" === e[1].slice(0, 3)
                                ? (e[3] || ae.error(e[0]),
                                    (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))),
                                    (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                                : e[3] && ae.error(e[0]),
                            e
                        );
                    },
                    PSEUDO: function (e) {
                        var t,
                            n = !e[6] && e[2];
                        return G.CHILD.test(e[0])
                            ? null
                            : (e[3]
                                ? (e[2] = e[4] || e[5] || "")
                                : n &&
                                V.test(n) &&
                                (t = h(n, !0)) &&
                                (t = n.indexOf(")", n.length - t) - n.length) &&
                                ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                                e.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (e) {
                        var t = e.replace(ie, u).toLowerCase();
                        return "*" === e
                            ? function () {
                                return !0;
                            }
                            : function (e) {
                                return e.nodeName && e.nodeName.toLowerCase() === t;
                            };
                    },
                    CLASS: function (e) {
                        var t = E[e + " "];
                        return (
                            t ||
                            ((t = new RegExp("(^|" + z + ")" + e + "(" + z + "|$)")) &&
                                E(e, function (e) {
                                    return t.test(
                                        ("string" == typeof e.className && e.className) ||
                                        (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                                        ""
                                    );
                                }))
                        );
                    },
                    ATTR: function (n, i, o) {
                        return function (e) {
                            var t = ae.attr(e, n);
                            return null == t
                                ? "!=" === i
                                : !i ||
                                ((t += ""),
                                    "=" === i
                                        ? t === o
                                        : "!=" === i
                                            ? t !== o
                                            : "^=" === i
                                                ? o && 0 === t.indexOf(o)
                                                : "*=" === i
                                                    ? o && -1 < t.indexOf(o)
                                                    : "$=" === i
                                                        ? o && t.slice(-o.length) === o
                                                        : "~=" === i
                                                            ? -1 < (" " + t.replace(_, " ") + " ").indexOf(o)
                                                            : "|=" === i && (t === o || t.slice(0, o.length + 1) === o + "-"));
                        };
                    },
                    CHILD: function (h, e, t, g, v) {
                        var m = "nth" !== h.slice(0, 3),
                            y = "last" !== h.slice(-4),
                            b = "of-type" === e;
                        return 1 === g && 0 === v
                            ? function (e) {
                                return !!e.parentNode;
                            }
                            : function (e, t, n) {
                                var i,
                                    o,
                                    r,
                                    s,
                                    a,
                                    l,
                                    c = m != y ? "nextSibling" : "previousSibling",
                                    d = e.parentNode,
                                    u = b && e.nodeName.toLowerCase(),
                                    p = !n && !b,
                                    f = !1;
                                if (d) {
                                    if (m) {
                                        for (; c;) {
                                            for (s = e; (s = s[c]);) if (b ? s.nodeName.toLowerCase() === u : 1 === s.nodeType) return !1;
                                            l = c = "only" === h && !l && "nextSibling";
                                        }
                                        return !0;
                                    }
                                    if (((l = [y ? d.firstChild : d.lastChild]), y && p)) {
                                        for (
                                            f =
                                            (a =
                                                (i =
                                                    (o = (r = (s = d)[C] || (s[C] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[h] || [])[0] ===
                                                $ && i[1]) && i[2],
                                            s = a && d.childNodes[a];
                                            (s = (++a && s && s[c]) || (f = a = 0) || l.pop());

                                        )
                                            if (1 === s.nodeType && ++f && s === e) {
                                                o[h] = [$, a, f];
                                                break;
                                            }
                                    } else if (
                                        (p &&
                                            (f = a =
                                                (i =
                                                    (o = (r = (s = e)[C] || (s[C] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[h] || [])[0] ===
                                                $ && i[1]),
                                            !1 === f)
                                    )
                                        for (
                                            ;
                                            (s = (++a && s && s[c]) || (f = a = 0) || l.pop()) &&
                                            ((b ? s.nodeName.toLowerCase() !== u : 1 !== s.nodeType) ||
                                                !++f ||
                                                (p && ((o = (r = s[C] || (s[C] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[h] = [$, f]),
                                                    s !== e));

                                        );
                                    return (f -= v) === g || (f % g == 0 && 0 <= f / g);
                                }
                            };
                    },
                    PSEUDO: function (e, r) {
                        var t,
                            s = w.pseudos[e] || w.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
                        return s[C]
                            ? s(r)
                            : 1 < s.length
                                ? ((t = [e, e, "", r]),
                                    w.setFilters.hasOwnProperty(e.toLowerCase())
                                        ? ce(function (e, t) {
                                            for (var n, i = s(e, r), o = i.length; o--;) e[(n = M(e, i[o]))] = !(t[n] = i[o]);
                                        })
                                        : function (e) {
                                            return s(e, 0, t);
                                        })
                                : s;
                    },
                },
                pseudos: {
                    not: ce(function (e) {
                        var i = [],
                            o = [],
                            a = p(e.replace(B, "$1"));
                        return a[C]
                            ? ce(function (e, t, n, i) {
                                for (var o, r = a(e, null, i, []), s = e.length; s--;) (o = r[s]) && (e[s] = !(t[s] = o));
                            })
                            : function (e, t, n) {
                                return (i[0] = e), a(i, null, n, o), (i[0] = null), !o.pop();
                            };
                    }),
                    has: ce(function (t) {
                        return function (e) {
                            return 0 < ae(t, e).length;
                        };
                    }),
                    contains: ce(function (t) {
                        return (
                            (t = t.replace(ie, u)),
                            function (e) {
                                return -1 < (e.textContent || r(e)).indexOf(t);
                            }
                        );
                    }),
                    lang: ce(function (n) {
                        return (
                            Q.test(n || "") || ae.error("unsupported lang: " + n),
                            (n = n.replace(ie, u).toLowerCase()),
                            function (e) {
                                var t;
                                do {
                                    if ((t = S ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")))
                                        return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-");
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (e) {
                        var t = n.location && n.location.hash;
                        return t && t.slice(1) === e.id;
                    },
                    root: function (e) {
                        return e === a;
                    },
                    focus: function (e) {
                        return e === k.activeElement && (!k.hasFocus || k.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                    },
                    enabled: ge(!1),
                    disabled: ge(!0),
                    checked: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                    },
                    selected: function (e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                    },
                    empty: function (e) {
                        for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (e) {
                        return !w.pseudos.empty(e);
                    },
                    header: function (e) {
                        return J.test(e.nodeName);
                    },
                    input: function (e) {
                        return Z.test(e.nodeName);
                    },
                    button: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && "button" === e.type) || "button" === t;
                    },
                    text: function (e) {
                        var t;
                        return (
                            "input" === e.nodeName.toLowerCase() &&
                            "text" === e.type &&
                            (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                        );
                    },
                    first: ve(function () {
                        return [0];
                    }),
                    last: ve(function (e, t) {
                        return [t - 1];
                    }),
                    eq: ve(function (e, t, n) {
                        return [n < 0 ? n + t : n];
                    }),
                    even: ve(function (e, t) {
                        for (var n = 0; n < t; n += 2) e.push(n);
                        return e;
                    }),
                    odd: ve(function (e, t) {
                        for (var n = 1; n < t; n += 2) e.push(n);
                        return e;
                    }),
                    lt: ve(function (e, t, n) {
                        for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i;) e.push(i);
                        return e;
                    }),
                    gt: ve(function (e, t, n) {
                        for (var i = n < 0 ? n + t : n; ++i < t;) e.push(i);
                        return e;
                    }),
                },
            }).pseudos.nth = w.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            w.pseudos[e] = fe(e);
        for (e in { submit: !0, reset: !0 }) w.pseudos[e] = he(e);
        function ye() { }
        function be(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
            return i;
        }
        function we(a, e, t) {
            var l = e.dir,
                c = e.next,
                d = c || l,
                u = t && "parentNode" === d,
                p = i++;
            return e.first
                ? function (e, t, n) {
                    for (; (e = e[l]);) if (1 === e.nodeType || u) return a(e, t, n);
                    return !1;
                }
                : function (e, t, n) {
                    var i,
                        o,
                        r,
                        s = [$, p];
                    if (n) {
                        for (; (e = e[l]);) if ((1 === e.nodeType || u) && a(e, t, n)) return !0;
                    } else
                        for (; (e = e[l]);)
                            if (1 === e.nodeType || u)
                                if (
                                    ((o = (r = e[C] || (e[C] = {}))[e.uniqueID] || (r[e.uniqueID] = {})),
                                        c && c === e.nodeName.toLowerCase())
                                )
                                    e = e[l] || e;
                                else {
                                    if ((i = o[d]) && i[0] === $ && i[1] === p) return (s[2] = i[2]);
                                    if (((o[d] = s)[2] = a(e, t, n))) return !0;
                                }
                    return !1;
                };
        }
        function xe(o) {
            return 1 < o.length
                ? function (e, t, n) {
                    for (var i = o.length; i--;) if (!o[i](e, t, n)) return !1;
                    return !0;
                }
                : o[0];
        }
        function Te(e, t, n, i, o) {
            for (var r, s = [], a = 0, l = e.length, c = null != t; a < l; a++)
                (r = e[a]) && ((n && !n(r, i, o)) || (s.push(r), c && t.push(a)));
            return s;
        }
        function ke(f, h, g, v, m, e) {
            return (
                v && !v[C] && (v = ke(v)),
                m && !m[C] && (m = ke(m, e)),
                ce(function (e, t, n, i) {
                    var o,
                        r,
                        s,
                        a = [],
                        l = [],
                        c = t.length,
                        d =
                            e ||
                            (function (e, t, n) {
                                for (var i = 0, o = t.length; i < o; i++) ae(e, t[i], n);
                                return n;
                            })(h || "*", n.nodeType ? [n] : n, []),
                        u = !f || (!e && h) ? d : Te(d, a, f, n, i),
                        p = g ? (m || (e ? f : c || v) ? [] : t) : u;
                    if ((g && g(u, p, n, i), v))
                        for (o = Te(p, l), v(o, [], n, i), r = o.length; r--;) (s = o[r]) && (p[l[r]] = !(u[l[r]] = s));
                    if (e) {
                        if (m || f) {
                            if (m) {
                                for (o = [], r = p.length; r--;) (s = p[r]) && o.push((u[r] = s));
                                m(null, (p = []), o, i);
                            }
                            for (r = p.length; r--;) (s = p[r]) && -1 < (o = m ? M(e, s) : a[r]) && (e[o] = !(t[o] = s));
                        }
                    } else (p = Te(p === t ? p.splice(c, p.length) : p)), m ? m(null, t, p, i) : P.apply(t, p);
                })
            );
        }
        function Se(e) {
            for (
                var o,
                t,
                n,
                i = e.length,
                r = w.relative[e[0].type],
                s = r || w.relative[" "],
                a = r ? 1 : 0,
                l = we(
                    function (e) {
                        return e === o;
                    },
                    s,
                    !0
                ),
                c = we(
                    function (e) {
                        return -1 < M(o, e);
                    },
                    s,
                    !0
                ),
                d = [
                    function (e, t, n) {
                        var i = (!r && (n || t !== x)) || ((o = t).nodeType ? l : c)(e, t, n);
                        return (o = null), i;
                    },
                ];
                a < i;
                a++
            )
                if ((t = w.relative[e[a].type])) d = [we(xe(d), t)];
                else {
                    if ((t = w.filter[e[a].type].apply(null, e[a].matches))[C]) {
                        for (n = ++a; n < i && !w.relative[e[n].type]; n++);
                        return ke(
                            1 < a && xe(d),
                            1 < a && be(e.slice(0, a - 1).concat({ value: " " === e[a - 2].type ? "*" : "" })).replace(B, "$1"),
                            t,
                            a < n && Se(e.slice(a, n)),
                            n < i && Se((e = e.slice(n))),
                            n < i && be(e)
                        );
                    }
                    d.push(t);
                }
            return xe(d);
        }
        return (
            (ye.prototype = w.filters = w.pseudos),
            (w.setFilters = new ye()),
            (h = ae.tokenize =
                function (e, t) {
                    var n,
                        i,
                        o,
                        r,
                        s,
                        a,
                        l,
                        c = A[e + " "];
                    if (c) return t ? 0 : c.slice(0);
                    for (s = e, a = [], l = w.preFilter; s;) {
                        for (r in ((n && !(i = U.exec(s))) || (i && (s = s.slice(i[0].length) || s), a.push((o = []))),
                            (n = !1),
                            (i = X.exec(s)) &&
                            ((n = i.shift()), o.push({ value: n, type: i[0].replace(B, " ") }), (s = s.slice(n.length))),
                            w.filter))
                            !(i = G[r].exec(s)) ||
                                (l[r] && !(i = l[r](i))) ||
                                ((n = i.shift()), o.push({ value: n, type: r, matches: i }), (s = s.slice(n.length)));
                        if (!n) break;
                    }
                    return t ? s.length : s ? ae.error(e) : A(e, a).slice(0);
                }),
            (p = ae.compile =
                function (e, t) {
                    var n,
                        v,
                        m,
                        y,
                        b,
                        i,
                        o = [],
                        r = [],
                        s = j[e + " "];
                    if (!s) {
                        for (n = (t = t || h(e)).length; n--;) (s = Se(t[n]))[C] ? o.push(s) : r.push(s);
                        (s = j(
                            e,
                            ((v = r),
                                (y = 0 < (m = o).length),
                                (b = 0 < v.length),
                                (i = function (e, t, n, i, o) {
                                    var r,
                                        s,
                                        a,
                                        l = 0,
                                        c = "0",
                                        d = e && [],
                                        u = [],
                                        p = x,
                                        f = e || (b && w.find.TAG("*", o)),
                                        h = ($ += null == p ? 1 : Math.random() || 0.1),
                                        g = f.length;
                                    for (o && (x = t == k || t || o); c !== g && null != (r = f[c]); c++) {
                                        if (b && r) {
                                            for (s = 0, t || r.ownerDocument == k || (T(r), (n = !S)); (a = v[s++]);)
                                                if (a(r, t || k, n)) {
                                                    i.push(r);
                                                    break;
                                                }
                                            o && ($ = h);
                                        }
                                        y && ((r = !a && r) && l--, e && d.push(r));
                                    }
                                    if (((l += c), y && c !== l)) {
                                        for (s = 0; (a = m[s++]);) a(d, u, t, n);
                                        if (e) {
                                            if (0 < l) for (; c--;) d[c] || u[c] || (u[c] = H.call(i));
                                            u = Te(u);
                                        }
                                        P.apply(i, u), o && !e && 0 < u.length && 1 < l + m.length && ae.uniqueSort(i);
                                    }
                                    return o && (($ = h), (x = p)), d;
                                }),
                                y ? ce(i) : i)
                        )).selector = e;
                    }
                    return s;
                }),
            (g = ae.select =
                function (e, t, n, i) {
                    var o,
                        r,
                        s,
                        a,
                        l,
                        c = "function" == typeof e && e,
                        d = !i && h((e = c.selector || e));
                    if (((n = n || []), 1 === d.length)) {
                        if (
                            2 < (r = d[0] = d[0].slice(0)).length &&
                            "ID" === (s = r[0]).type &&
                            9 === t.nodeType &&
                            S &&
                            w.relative[r[1].type]
                        ) {
                            if (!(t = (w.find.ID(s.matches[0].replace(ie, u), t) || [])[0])) return n;
                            c && (t = t.parentNode), (e = e.slice(r.shift().value.length));
                        }
                        for (o = G.needsContext.test(e) ? 0 : r.length; o-- && ((s = r[o]), !w.relative[(a = s.type)]);)
                            if (
                                (l = w.find[a]) &&
                                (i = l(s.matches[0].replace(ie, u), (ne.test(r[0].type) && me(t.parentNode)) || t))
                            ) {
                                if ((r.splice(o, 1), !(e = i.length && be(r)))) return P.apply(n, i), n;
                                break;
                            }
                    }
                    return (c || p(e, d))(i, t, !S, n, !t || (ne.test(e) && me(t.parentNode)) || t), n;
                }),
            (f.sortStable = C.split("").sort(D).join("") === C),
            (f.detectDuplicates = !!c),
            T(),
            (f.sortDetached = de(function (e) {
                return 1 & e.compareDocumentPosition(k.createElement("fieldset"));
            })),
            de(function (e) {
                return (e.innerHTML = "<a href="#"></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
            ue("type|href|height|width", function (e, t, n) {
                if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
            }),
            (f.attributes &&
                de(function (e) {
                    return (
                        (e.innerHTML = "<input>"),
                        e.firstChild.setAttribute("value", ""),
                        "" === e.firstChild.getAttribute("value")
                    );
                })) ||
            ue("value", function (e, t, n) {
                if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
            }),
            de(function (e) {
                return null == e.getAttribute("disabled");
            }) ||
            ue(I, function (e, t, n) {
                var i;
                if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
            }),
            ae
        );
    })(k);
    (C.find = f),
        (C.expr = f.selectors),
        (C.expr[":"] = C.expr.pseudos),
        (C.uniqueSort = C.unique = f.uniqueSort),
        (C.text = f.getText),
        (C.isXMLDoc = f.isXML),
        (C.contains = f.contains),
        (C.escapeSelector = f.escape);
    function h(e, t, n) {
        for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;)
            if (1 === e.nodeType) {
                if (o && C(e).is(n)) break;
                i.push(e);
            }
        return i;
    }
    function T(e, t) {
        for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
        return n;
    }
    var $ = C.expr.match.needsContext;
    function E(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function j(e, n, i) {
        return b(n)
            ? C.grep(e, function (e, t) {
                return !!n.call(e, t, e) !== i;
            })
            : n.nodeType
                ? C.grep(e, function (e) {
                    return (e === n) !== i;
                })
                : "string" != typeof n
                    ? C.grep(e, function (e) {
                        return -1 < o.call(n, e) !== i;
                    })
                    : C.filter(n, e, i);
    }
    (C.filter = function (e, t, n) {
        var i = t[0];
        return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === i.nodeType
                ? C.find.matchesSelector(i, e)
                    ? [i]
                    : []
                : C.find.matches(
                    e,
                    C.grep(t, function (e) {
                        return 1 === e.nodeType;
                    })
                )
        );
    }),
        C.fn.extend({
            find: function (e) {
                var t,
                    n,
                    i = this.length,
                    o = this;
                if ("string" != typeof e)
                    return this.pushStack(
                        C(e).filter(function () {
                            for (t = 0; t < i; t++) if (C.contains(o[t], this)) return !0;
                        })
                    );
                for (n = this.pushStack([]), t = 0; t < i; t++) C.find(e, o[t], n);
                return 1 < i ? C.uniqueSort(n) : n;
            },
            filter: function (e) {
                return this.pushStack(j(this, e || [], !1));
            },
            not: function (e) {
                return this.pushStack(j(this, e || [], !0));
            },
            is: function (e) {
                return !!j(this, "string" == typeof e && $.test(e) ? C(e) : e || [], !1).length;
            },
        });
    var L,
        D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((C.fn.init = function (e, t, n) {
        var i, o;
        if (!e) return this;
        if (((n = n || L), "string" != typeof e))
            return e.nodeType
                ? ((this[0] = e), (this.length = 1), this)
                : b(e)
                    ? void 0 !== n.ready
                        ? n.ready(e)
                        : e(C)
                    : C.makeArray(e, this);
        if (!(i = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : D.exec(e)) || (!i[1] && t))
            return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
        if (i[1]) {
            if (
                ((t = t instanceof C ? t[0] : t),
                    C.merge(this, C.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : S, !0)),
                    A.test(i[1]) && C.isPlainObject(t))
            )
                for (i in t) b(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            return this;
        }
        return (o = S.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this;
    }).prototype = C.fn),
        (L = C(S));
    var O = /^(?:parents|prev(?:Until|All))/,
        H = { children: !0, contents: !0, next: !0, prev: !0 };
    function N(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType;);
        return e;
    }
    C.fn.extend({
        has: function (e) {
            var t = C(e, this),
                n = t.length;
            return this.filter(function () {
                for (var e = 0; e < n; e++) if (C.contains(this, t[e])) return !0;
            });
        },
        closest: function (e, t) {
            var n,
                i = 0,
                o = this.length,
                r = [],
                s = "string" != typeof e && C(e);
            if (!$.test(e))
                for (; i < o; i++)
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && C.find.matchesSelector(n, e))) {
                            r.push(n);
                            break;
                        }
            return this.pushStack(1 < r.length ? C.uniqueSort(r) : r);
        },
        index: function (e) {
            return e
                ? "string" == typeof e
                    ? o.call(C(e), this[0])
                    : o.call(this, e.jquery ? e[0] : e)
                : this[0] && this[0].parentNode
                    ? this.first().prevAll().length
                    : -1;
        },
        add: function (e, t) {
            return this.pushStack(C.uniqueSort(C.merge(this.get(), C(e, t))));
        },
        addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        },
    }),
        C.each(
            {
                parent: function (e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                    return h(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                    return h(e, "parentNode", n);
                },
                next: function (e) {
                    return N(e, "nextSibling");
                },
                prev: function (e) {
                    return N(e, "previousSibling");
                },
                nextAll: function (e) {
                    return h(e, "nextSibling");
                },
                prevAll: function (e) {
                    return h(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                    return h(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                    return h(e, "previousSibling", n);
                },
                siblings: function (e) {
                    return T((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                    return T(e.firstChild);
                },
                contents: function (e) {
                    return null != e.contentDocument && i(e.contentDocument)
                        ? e.contentDocument
                        : (E(e, "template") && (e = e.content || e), C.merge([], e.childNodes));
                },
            },
            function (i, o) {
                C.fn[i] = function (e, t) {
                    var n = C.map(this, o, e);
                    return (
                        "Until" !== i.slice(-5) && (t = e),
                        t && "string" == typeof t && (n = C.filter(t, n)),
                        1 < this.length && (H[i] || C.uniqueSort(n), O.test(i) && n.reverse()),
                        this.pushStack(n)
                    );
                };
            }
        );
    var P = /[^\x20\t\r\n\f]+/g;
    function q(e) {
        return e;
    }
    function M(e) {
        throw e;
    }
    function I(e, t, n, i) {
        var o;
        try {
            e && b((o = e.promise))
                ? o.call(e).done(t).fail(n)
                : e && b((o = e.then))
                    ? o.call(e, t, n)
                    : t.apply(void 0, [e].slice(i));
        } catch (e) {
            n.apply(void 0, [e]);
        }
    }
    (C.Callbacks = function (i) {
        var n;
        i =
            "string" == typeof i
                ? ((n = {}),
                    C.each(i.match(P) || [], function (e, t) {
                        n[t] = !0;
                    }),
                    n)
                : C.extend({}, i);
        function o() {
            for (s = s || i.once, t = r = !0; l.length; c = -1)
                for (e = l.shift(); ++c < a.length;)
                    !1 === a[c].apply(e[0], e[1]) && i.stopOnFalse && ((c = a.length), (e = !1));
            i.memory || (e = !1), (r = !1), s && (a = e ? [] : "");
        }
        var r,
            e,
            t,
            s,
            a = [],
            l = [],
            c = -1,
            d = {
                add: function () {
                    return (
                        a &&
                        (e && !r && ((c = a.length - 1), l.push(e)),
                            (function n(e) {
                                C.each(e, function (e, t) {
                                    b(t) ? (i.unique && d.has(t)) || a.push(t) : t && t.length && "string" !== x(t) && n(t);
                                });
                            })(arguments),
                            e && !r && o()),
                        this
                    );
                },
                remove: function () {
                    return (
                        C.each(arguments, function (e, t) {
                            for (var n; -1 < (n = C.inArray(t, a, n));) a.splice(n, 1), n <= c && c--;
                        }),
                        this
                    );
                },
                has: function (e) {
                    return e ? -1 < C.inArray(e, a) : 0 < a.length;
                },
                empty: function () {
                    return (a = a && []), this;
                },
                disable: function () {
                    return (s = l = []), (a = e = ""), this;
                },
                disabled: function () {
                    return !a;
                },
                lock: function () {
                    return (s = l = []), e || r || (a = e = ""), this;
                },
                locked: function () {
                    return !!s;
                },
                fireWith: function (e, t) {
                    return s || ((t = [e, (t = t || []).slice ? t.slice() : t]), l.push(t), r || o()), this;
                },
                fire: function () {
                    return d.fireWith(this, arguments), this;
                },
                fired: function () {
                    return !!t;
                },
            };
        return d;
    }),
        C.extend({
            Deferred: function (e) {
                var r = [
                    ["notify", "progress", C.Callbacks("memory"), C.Callbacks("memory"), 2],
                    ["resolve", "done", C.Callbacks("once memory"), C.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", C.Callbacks("once memory"), C.Callbacks("once memory"), 1, "rejected"],
                ],
                    o = "pending",
                    s = {
                        state: function () {
                            return o;
                        },
                        always: function () {
                            return a.done(arguments).fail(arguments), this;
                        },
                        catch: function (e) {
                            return s.then(null, e);
                        },
                        pipe: function () {
                            var o = arguments;
                            return C.Deferred(function (i) {
                                C.each(r, function (e, t) {
                                    var n = b(o[t[4]]) && o[t[4]];
                                    a[t[1]](function () {
                                        var e = n && n.apply(this, arguments);
                                        e && b(e.promise)
                                            ? e.promise().progress(i.notify).done(i.resolve).fail(i.reject)
                                            : i[t[0] + "With"](this, n ? [e] : arguments);
                                    });
                                }),
                                    (o = null);
                            }).promise();
                        },
                        then: function (t, n, i) {
                            var l = 0;
                            function c(o, r, s, a) {
                                return function () {
                                    function e() {
                                        var e, t;
                                        if (!(o < l)) {
                                            if ((e = s.apply(n, i)) === r.promise()) throw new TypeError("Thenable self-resolution");
                                            (t = e && ("object" == _typeof(e) || "function" == typeof e) && e.then),
                                                b(t)
                                                    ? a
                                                        ? t.call(e, c(l, r, q, a), c(l, r, M, a))
                                                        : (l++, t.call(e, c(l, r, q, a), c(l, r, M, a), c(l, r, q, r.notifyWith)))
                                                    : (s !== q && ((n = void 0), (i = [e])), (a || r.resolveWith)(n, i));
                                        }
                                    }
                                    var n = this,
                                        i = arguments,
                                        t = a
                                            ? e
                                            : function () {
                                                try {
                                                    e();
                                                } catch (e) {
                                                    C.Deferred.exceptionHook && C.Deferred.exceptionHook(e, t.stackTrace),
                                                        l <= o + 1 && (s !== M && ((n = void 0), (i = [e])), r.rejectWith(n, i));
                                                }
                                            };
                                    o ? t() : (C.Deferred.getStackHook && (t.stackTrace = C.Deferred.getStackHook()), k.setTimeout(t));
                                };
                            }
                            return C.Deferred(function (e) {
                                r[0][3].add(c(0, e, b(i) ? i : q, e.notifyWith)),
                                    r[1][3].add(c(0, e, b(t) ? t : q)),
                                    r[2][3].add(c(0, e, b(n) ? n : M));
                            }).promise();
                        },
                        promise: function (e) {
                            return null != e ? C.extend(e, s) : s;
                        },
                    },
                    a = {};
                return (
                    C.each(r, function (e, t) {
                        var n = t[2],
                            i = t[5];
                        (s[t[1]] = n.add),
                            i &&
                            n.add(
                                function () {
                                    o = i;
                                },
                                r[3 - e][2].disable,
                                r[3 - e][3].disable,
                                r[0][2].lock,
                                r[0][3].lock
                            ),
                            n.add(t[3].fire),
                            (a[t[0]] = function () {
                                return a[t[0] + "With"](this === a ? void 0 : this, arguments), this;
                            }),
                            (a[t[0] + "With"] = n.fireWith);
                    }),
                    s.promise(a),
                    e && e.call(a, a),
                    a
                );
            },
            when: function (e) {
                function t(t) {
                    return function (e) {
                        (o[t] = this), (r[t] = 1 < arguments.length ? a.call(arguments) : e), --n || s.resolveWith(o, r);
                    };
                }
                var n = arguments.length,
                    i = n,
                    o = Array(i),
                    r = a.call(arguments),
                    s = C.Deferred();
                if (n <= 1 && (I(e, s.done(t(i)).resolve, s.reject, !n), "pending" === s.state() || b(r[i] && r[i].then)))
                    return s.then();
                for (; i--;) I(r[i], t(i), s.reject);
                return s.promise();
            },
        });
    var z = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (C.Deferred.exceptionHook = function (e, t) {
        k.console &&
            k.console.warn &&
            e &&
            z.test(e.name) &&
            k.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
    }),
        (C.readyException = function (e) {
            k.setTimeout(function () {
                throw e;
            });
        });
    var W = C.Deferred();
    function R() {
        S.removeEventListener("DOMContentLoaded", R), k.removeEventListener("load", R), C.ready();
    }
    (C.fn.ready = function (e) {
        return (
            W.then(e).catch(function (e) {
                C.readyException(e);
            }),
            this
        );
    }),
        C.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (e) {
                (!0 === e ? --C.readyWait : C.isReady) ||
                    ((C.isReady = !0) !== e && 0 < --C.readyWait) ||
                    W.resolveWith(S, [C]);
            },
        }),
        (C.ready.then = W.then),
        "complete" === S.readyState || ("loading" !== S.readyState && !S.documentElement.doScroll)
            ? k.setTimeout(C.ready)
            : (S.addEventListener("DOMContentLoaded", R), k.addEventListener("load", R));
    function F(e, t, n, i, o, r, s) {
        var a = 0,
            l = e.length,
            c = null == n;
        if ("object" === x(n)) for (a in ((o = !0), n)) F(e, t, a, n[a], !0, r, s);
        else if (
            void 0 !== i &&
            ((o = !0),
                b(i) || (s = !0),
                c &&
                (t = s
                    ? (t.call(e, i), null)
                    : ((c = t),
                        function (e, t, n) {
                            return c.call(C(e), n);
                        })),
                t)
        )
            for (; a < l; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return o ? e : c ? t.call(e) : l ? t(e[0], n) : r;
    }
    var _ = /^-ms-/,
        B = /-([a-z])/g;
    function U(e, t) {
        return t.toUpperCase();
    }
    function X(e) {
        return e.replace(_, "ms-").replace(B, U);
    }
    function Y(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    }
    function V() {
        this.expando = C.expando + V.uid++;
    }
    (V.uid = 1),
        (V.prototype = {
            cache: function (e) {
                var t = e[this.expando];
                return (
                    t ||
                    ((t = {}),
                        Y(e) &&
                        (e.nodeType
                            ? (e[this.expando] = t)
                            : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
                    t
                );
            },
            set: function (e, t, n) {
                var i,
                    o = this.cache(e);
                if ("string" == typeof t) o[X(t)] = n;
                else for (i in t) o[X(i)] = t[i];
                return o;
            },
            get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)];
            },
            access: function (e, t, n) {
                return void 0 === t || (t && "string" == typeof t && void 0 === n)
                    ? this.get(e, t)
                    : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function (e, t) {
                var n,
                    i = e[this.expando];
                if (void 0 !== i) {
                    if (void 0 !== t) {
                        n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in i ? [t] : t.match(P) || []).length;
                        for (; n--;) delete i[t[n]];
                    }
                    (void 0 !== t && !C.isEmptyObject(i)) || (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
            },
            hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !C.isEmptyObject(t);
            },
        });
    var Q = new V(),
        G = new V(),
        K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        Z = /[A-Z]/g;
    function J(e, t, n) {
        var i, o;
        if (void 0 === n && 1 === e.nodeType)
            if (((i = "data-" + t.replace(Z, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(i)))) {
                try {
                    n =
                        "true" === (o = n) ||
                        ("false" !== o && ("null" === o ? null : o === +o + "" ? +o : K.test(o) ? JSON.parse(o) : o));
                } catch (e) { }
                G.set(e, t, n);
            } else n = void 0;
        return n;
    }
    C.extend({
        hasData: function (e) {
            return G.hasData(e) || Q.hasData(e);
        },
        data: function (e, t, n) {
            return G.access(e, t, n);
        },
        removeData: function (e, t) {
            G.remove(e, t);
        },
        _data: function (e, t, n) {
            return Q.access(e, t, n);
        },
        _removeData: function (e, t) {
            Q.remove(e, t);
        },
    }),
        C.fn.extend({
            data: function (n, e) {
                var t,
                    i,
                    o,
                    r = this[0],
                    s = r && r.attributes;
                if (void 0 !== n)
                    return "object" == _typeof(n)
                        ? this.each(function () {
                            G.set(this, n);
                        })
                        : F(
                            this,
                            function (e) {
                                var t;
                                if (r && void 0 === e) return void 0 !== (t = G.get(r, n)) || void 0 !== (t = J(r, n)) ? t : void 0;
                                this.each(function () {
                                    G.set(this, n, e);
                                });
                            },
                            null,
                            e,
                            1 < arguments.length,
                            null,
                            !0
                        );
                if (this.length && ((o = G.get(r)), 1 === r.nodeType && !Q.get(r, "hasDataAttrs"))) {
                    for (t = s.length; t--;)
                        s[t] && 0 === (i = s[t].name).indexOf("data-") && ((i = X(i.slice(5))), J(r, i, o[i]));
                    Q.set(r, "hasDataAttrs", !0);
                }
                return o;
            },
            removeData: function (e) {
                return this.each(function () {
                    G.remove(this, e);
                });
            },
        }),
        C.extend({
            queue: function (e, t, n) {
                var i;
                if (e)
                    return (
                        (t = (t || "fx") + "queue"),
                        (i = Q.get(e, t)),
                        n && (!i || Array.isArray(n) ? (i = Q.access(e, t, C.makeArray(n))) : i.push(n)),
                        i || []
                    );
            },
            dequeue: function (e, t) {
                t = t || "fx";
                var n = C.queue(e, t),
                    i = n.length,
                    o = n.shift(),
                    r = C._queueHooks(e, t);
                "inprogress" === o && ((o = n.shift()), i--),
                    o &&
                    ("fx" === t && n.unshift("inprogress"),
                        delete r.stop,
                        o.call(
                            e,
                            function () {
                                C.dequeue(e, t);
                            },
                            r
                        )),
                    !i && r && r.empty.fire();
            },
            _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                    Q.get(e, n) ||
                    Q.access(e, n, {
                        empty: C.Callbacks("once memory").add(function () {
                            Q.remove(e, [t + "queue", n]);
                        }),
                    })
                );
            },
        }),
        C.fn.extend({
            queue: function (t, n) {
                var e = 2;
                return (
                    "string" != typeof t && ((n = t), (t = "fx"), e--),
                    arguments.length < e
                        ? C.queue(this[0], t)
                        : void 0 === n
                            ? this
                            : this.each(function () {
                                var e = C.queue(this, t, n);
                                C._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && C.dequeue(this, t);
                            })
                );
            },
            dequeue: function (e) {
                return this.each(function () {
                    C.dequeue(this, e);
                });
            },
            clearQueue: function (e) {
                return this.queue(e || "fx", []);
            },
            promise: function (e, t) {
                function n() {
                    --o || r.resolveWith(s, [s]);
                }
                var i,
                    o = 1,
                    r = C.Deferred(),
                    s = this,
                    a = this.length;
                for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; a--;)
                    (i = Q.get(s[a], e + "queueHooks")) && i.empty && (o++, i.empty.add(n));
                return n(), r.promise(t);
            },
        });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
        ne = ["Top", "Right", "Bottom", "Left"],
        ie = S.documentElement,
        oe = function (e) {
            return C.contains(e.ownerDocument, e);
        },
        re = { composed: !0 };
    ie.getRootNode &&
        (oe = function (e) {
            return C.contains(e.ownerDocument, e) || e.getRootNode(re) === e.ownerDocument;
        });
    function se(e, t) {
        return "none" === (e = t || e).style.display || ("" === e.style.display && oe(e) && "none" === C.css(e, "display"));
    }
    function ae(e, t, n, i) {
        var o,
            r,
            s = 20,
            a = i
                ? function () {
                    return i.cur();
                }
                : function () {
                    return C.css(e, t, "");
                },
            l = a(),
            c = (n && n[3]) || (C.cssNumber[t] ? "" : "px"),
            d = e.nodeType && (C.cssNumber[t] || ("px" !== c && +l)) && te.exec(C.css(e, t));
        if (d && d[3] !== c) {
            for (l /= 2, c = c || d[3], d = +l || 1; s--;)
                C.style(e, t, d + c), (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0), (d /= r);
            (d *= 2), C.style(e, t, d + c), (n = n || []);
        }
        return (
            n &&
            ((d = +d || +l || 0),
                (o = n[1] ? d + (n[1] + 1) * n[2] : +n[2]),
                i && ((i.unit = c), (i.start = d), (i.end = o))),
            o
        );
    }
    var le = {};
    function ce(e, t) {
        for (var n, i, o, r, s, a, l = [], c = 0, d = e.length; c < d; c++)
            (i = e[c]).style &&
                ((n = i.style.display),
                    t
                        ? ("none" === n && ((l[c] = Q.get(i, "display") || null), l[c] || (i.style.display = "")),
                            "" === i.style.display &&
                            se(i) &&
                            (l[c] =
                                ((a = r = o = void 0),
                                    (r = i.ownerDocument),
                                    (s = i.nodeName),
                                    (a = le[s]) ||
                                    ((o = r.body.appendChild(r.createElement(s))),
                                        (a = C.css(o, "display")),
                                        o.parentNode.removeChild(o),
                                        "none" === a && (a = "block"),
                                        (le[s] = a)))))
                        : "none" !== n && ((l[c] = "none"), Q.set(i, "display", n)));
        for (c = 0; c < d; c++) null != l[c] && (e[c].style.display = l[c]);
        return e;
    }
    C.fn.extend({
        show: function () {
            return ce(this, !0);
        },
        hide: function () {
            return ce(this);
        },
        toggle: function (e) {
            return "boolean" == typeof e
                ? e
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                    se(this) ? C(this).show() : C(this).hide();
                });
        },
    });
    var de,
        ue,
        pe = /^(?:checkbox|radio)$/i,
        fe = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        he = /^$|^module$|\/(?:java|ecma)script/i;
    (de = S.createDocumentFragment().appendChild(S.createElement("div"))),
        (ue = S.createElement("input")).setAttribute("type", "radio"),
        ue.setAttribute("checked", "checked"),
        ue.setAttribute("name", "t"),
        de.appendChild(ue),
        (y.checkClone = de.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (de.innerHTML = "<textarea>x</textarea>"),
        (y.noCloneChecked = !!de.cloneNode(!0).lastChild.defaultValue),
        (de.innerHTML = "<option></option>"),
        (y.option = !!de.lastChild);
    var ge = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
    };
    function ve(e, t) {
        var n;
        return (
            (n =
                void 0 !== e.getElementsByTagName
                    ? e.getElementsByTagName(t || "*")
                    : void 0 !== e.querySelectorAll
                        ? e.querySelectorAll(t || "*")
                        : []),
            void 0 === t || (t && E(e, t)) ? C.merge([e], n) : n
        );
    }
    function me(e, t) {
        for (var n = 0, i = e.length; n < i; n++) Q.set(e[n], "globalEval", !t || Q.get(t[n], "globalEval"));
    }
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
        (ge.th = ge.td),
        y.option || (ge.optgroup = ge.option = [1, "<select multiple="multiple">", "</select>"]);
    var ye = /<|&#?\w+;/;
    function be(e, t, n, i, o) {
        for (var r, s, a, l, c, d, u = t.createDocumentFragment(), p = [], f = 0, h = e.length; f < h; f++)
            if ((r = e[f]) || 0 === r)
                if ("object" === x(r)) C.merge(p, r.nodeType ? [r] : r);
                else if (ye.test(r)) {
                    for (
                        s = s || u.appendChild(t.createElement("div")),
                        a = (fe.exec(r) || ["", ""])[1].toLowerCase(),
                        l = ge[a] || ge._default,
                        s.innerHTML = l[1] + C.htmlPrefilter(r) + l[2],
                        d = l[0];
                        d--;

                    )
                        s = s.lastChild;
                    C.merge(p, s.childNodes), ((s = u.firstChild).textContent = "");
                } else p.push(t.createTextNode(r));
        for (u.textContent = "", f = 0; (r = p[f++]);)
            if (i && -1 < C.inArray(r, i)) o && o.push(r);
            else if (((c = oe(r)), (s = ve(u.appendChild(r), "script")), c && me(s), n))
                for (d = 0; (r = s[d++]);) he.test(r.type || "") && n.push(r);
        return u;
    }
    var we = /^key/,
        xe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Te = /^([^.]*)(?:\.(.+)|)/;
    function ke() {
        return !0;
    }
    function Se() {
        return !1;
    }
    function Ce(e, t) {
        return (
            (e ===
                (function () {
                    try {
                        return S.activeElement;
                    } catch (e) { }
                })()) ==
            ("focus" === t)
        );
    }
    function $e(e, t, n, i, o, r) {
        var s, a;
        if ("object" == _typeof(t)) {
            for (a in ("string" != typeof n && ((i = i || n), (n = void 0)), t)) $e(e, a, n, i, t[a], r);
            return e;
        }
        if (
            (null == i && null == o
                ? ((o = n), (i = n = void 0))
                : null == o && ("string" == typeof n ? ((o = i), (i = void 0)) : ((o = i), (i = n), (n = void 0))),
                !1 === o)
        )
            o = Se;
        else if (!o) return e;
        return (
            1 === r &&
            ((s = o),
                ((o = function (e) {
                    return C().off(e), s.apply(this, arguments);
                }).guid = s.guid || (s.guid = C.guid++))),
            e.each(function () {
                C.event.add(this, t, o, i, n);
            })
        );
    }
    function Ee(e, o, r) {
        r
            ? (Q.set(e, o, !1),
                C.event.add(e, o, {
                    namespace: !1,
                    handler: function (e) {
                        var t,
                            n,
                            i = Q.get(this, o);
                        if (1 & e.isTrigger && this[o]) {
                            if (i.length) (C.event.special[o] || {}).delegateType && e.stopPropagation();
                            else if (
                                ((i = a.call(arguments)),
                                    Q.set(this, o, i),
                                    (t = r(this, o)),
                                    this[o](),
                                    i !== (n = Q.get(this, o)) || t ? Q.set(this, o, !1) : (n = {}),
                                    i !== n)
                            )
                                return e.stopImmediatePropagation(), e.preventDefault(), n.value;
                        } else
                            i.length &&
                                (Q.set(this, o, { value: C.event.trigger(C.extend(i[0], C.Event.prototype), i.slice(1), this) }),
                                    e.stopImmediatePropagation());
                    },
                }))
            : void 0 === Q.get(e, o) && C.event.add(e, o, ke);
    }
    (C.event = {
        global: {},
        add: function (t, e, n, i, o) {
            var r,
                s,
                a,
                l,
                c,
                d,
                u,
                p,
                f,
                h,
                g,
                v = Q.get(t);
            if (Y(t))
                for (
                    n.handler && ((n = (r = n).handler), (o = r.selector)),
                    o && C.find.matchesSelector(ie, o),
                    n.guid || (n.guid = C.guid++),
                    (l = v.events) || (l = v.events = Object.create(null)),
                    (s = v.handle) ||
                    (s = v.handle =
                        function (e) {
                            return void 0 !== C && C.event.triggered !== e.type ? C.event.dispatch.apply(t, arguments) : void 0;
                        }),
                    c = (e = (e || "").match(P) || [""]).length;
                    c--;

                )
                    (f = g = (a = Te.exec(e[c]) || [])[1]),
                        (h = (a[2] || "").split(".").sort()),
                        f &&
                        ((u = C.event.special[f] || {}),
                            (f = (o ? u.delegateType : u.bindType) || f),
                            (u = C.event.special[f] || {}),
                            (d = C.extend(
                                {
                                    type: f,
                                    origType: g,
                                    data: i,
                                    handler: n,
                                    guid: n.guid,
                                    selector: o,
                                    needsContext: o && C.expr.match.needsContext.test(o),
                                    namespace: h.join("."),
                                },
                                r
                            )),
                            (p = l[f]) ||
                            (((p = l[f] = []).delegateCount = 0),
                                (u.setup && !1 !== u.setup.call(t, i, h, s)) || (t.addEventListener && t.addEventListener(f, s))),
                            u.add && (u.add.call(t, d), d.handler.guid || (d.handler.guid = n.guid)),
                            o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                            (C.event.global[f] = !0));
        },
        remove: function (e, t, n, i, o) {
            var r,
                s,
                a,
                l,
                c,
                d,
                u,
                p,
                f,
                h,
                g,
                v = Q.hasData(e) && Q.get(e);
            if (v && (l = v.events)) {
                for (c = (t = (t || "").match(P) || [""]).length; c--;)
                    if (((f = g = (a = Te.exec(t[c]) || [])[1]), (h = (a[2] || "").split(".").sort()), f)) {
                        for (
                            u = C.event.special[f] || {},
                            p = l[(f = (i ? u.delegateType : u.bindType) || f)] || [],
                            a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                            s = r = p.length;
                            r--;

                        )
                            (d = p[r]),
                                (!o && g !== d.origType) ||
                                (n && n.guid !== d.guid) ||
                                (a && !a.test(d.namespace)) ||
                                (i && i !== d.selector && ("**" !== i || !d.selector)) ||
                                (p.splice(r, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                        s &&
                            !p.length &&
                            ((u.teardown && !1 !== u.teardown.call(e, h, v.handle)) || C.removeEvent(e, f, v.handle), delete l[f]);
                    } else for (f in l) C.event.remove(e, f + t[c], n, i, !0);
                C.isEmptyObject(l) && Q.remove(e, "handle events");
            }
        },
        dispatch: function (e) {
            var t,
                n,
                i,
                o,
                r,
                s,
                a = new Array(arguments.length),
                l = C.event.fix(e),
                c = (Q.get(this, "events") || Object.create(null))[l.type] || [],
                d = C.event.special[l.type] || {};
            for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
            if (((l.delegateTarget = this), !d.preDispatch || !1 !== d.preDispatch.call(this, l))) {
                for (s = C.event.handlers.call(this, l, c), t = 0; (o = s[t++]) && !l.isPropagationStopped();)
                    for (l.currentTarget = o.elem, n = 0; (r = o.handlers[n++]) && !l.isImmediatePropagationStopped();)
                        (l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace)) ||
                            ((l.handleObj = r),
                                (l.data = r.data),
                                void 0 !== (i = ((C.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a)) &&
                                !1 === (l.result = i) &&
                                (l.preventDefault(), l.stopPropagation()));
                return d.postDispatch && d.postDispatch.call(this, l), l.result;
            }
        },
        handlers: function (e, t) {
            var n,
                i,
                o,
                r,
                s,
                a = [],
                l = t.delegateCount,
                c = e.target;
            if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                        for (r = [], s = {}, n = 0; n < l; n++)
                            void 0 === s[(o = (i = t[n]).selector + " ")] &&
                                (s[o] = i.needsContext ? -1 < C(o, this).index(c) : C.find(o, this, null, [c]).length),
                                s[o] && r.push(i);
                        r.length && a.push({ elem: c, handlers: r });
                    }
            return (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a;
        },
        addProp: function (t, e) {
            Object.defineProperty(C.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: b(e)
                    ? function () {
                        if (this.originalEvent) return e(this.originalEvent);
                    }
                    : function () {
                        if (this.originalEvent) return this.originalEvent[t];
                    },
                set: function (e) {
                    Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
                },
            });
        },
        fix: function (e) {
            return e[C.expando] ? e : new C.Event(e);
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && E(t, "input") && Ee(t, "click", ke), !1;
                },
                trigger: function (e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && E(t, "input") && Ee(t, "click"), !0;
                },
                _default: function (e) {
                    var t = e.target;
                    return (pe.test(t.type) && t.click && E(t, "input") && Q.get(t, "click")) || E(t, "a");
                },
            },
            beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
            },
        },
    }),
        (C.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }),
        (C.Event = function (e, t) {
            if (!(this instanceof C.Event)) return new C.Event(e, t);
            e && e.type
                ? ((this.originalEvent = e),
                    (this.type = e.type),
                    (this.isDefaultPrevented =
                        e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? ke : Se),
                    (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                    (this.currentTarget = e.currentTarget),
                    (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && C.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[C.expando] = !0);
        }),
        (C.Event.prototype = {
            constructor: C.Event,
            isDefaultPrevented: Se,
            isPropagationStopped: Se,
            isImmediatePropagationStopped: Se,
            isSimulated: !1,
            preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = ke), e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = ke), e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = ke),
                    e && !this.isSimulated && e.stopImmediatePropagation(),
                    this.stopPropagation();
            },
        }),
        C.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (e) {
                    var t = e.button;
                    return null == e.which && we.test(e.type)
                        ? null != e.charCode
                            ? e.charCode
                            : e.keyCode
                        : !e.which && void 0 !== t && xe.test(e.type)
                            ? 1 & t
                                ? 1
                                : 2 & t
                                    ? 3
                                    : 4 & t
                                        ? 2
                                        : 0
                            : e.which;
                },
            },
            C.event.addProp
        ),
        C.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            C.event.special[e] = {
                setup: function () {
                    return Ee(this, e, Ce), !1;
                },
                trigger: function () {
                    return Ee(this, e), !0;
                },
                delegateType: t,
            };
        }),
        C.each(
            { mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" },
            function (e, o) {
                C.event.special[e] = {
                    delegateType: o,
                    bindType: o,
                    handle: function (e) {
                        var t,
                            n = e.relatedTarget,
                            i = e.handleObj;
                        return (
                            (n && (n === this || C.contains(this, n))) ||
                            ((e.type = i.origType), (t = i.handler.apply(this, arguments)), (e.type = o)),
                            t
                        );
                    },
                };
            }
        ),
        C.fn.extend({
            on: function (e, t, n, i) {
                return $e(this, e, t, n, i);
            },
            one: function (e, t, n, i) {
                return $e(this, e, t, n, i, 1);
            },
            off: function (e, t, n) {
                var i, o;
                if (e && e.preventDefault && e.handleObj)
                    return (
                        (i = e.handleObj),
                        C(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler),
                        this
                    );
                if ("object" != _typeof(e))
                    return (
                        (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                        !1 === n && (n = Se),
                        this.each(function () {
                            C.event.remove(this, e, n, t);
                        })
                    );
                for (o in e) this.off(o, t, e[o]);
                return this;
            },
        });
    var Ae = /<script|<style|<link i,="" je="/checked\s*(?:[^=]|=\s*.checked.)/i," Le="/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)">\s*$/g;
    function De(e, t) {
        return (E(e, "table") && E(11 !== t.nodeType ? t : t.firstChild, "tr") && C(e).children("tbody")[0]) || e;
    }
    function Oe(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function He(e) {
        return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
    }
    function Ne(e, t) {
        var n, i, o, r, s, a;
        if (1 === t.nodeType) {
            if (Q.hasData(e) && (a = Q.get(e).events))
                for (o in (Q.remove(t, "handle events"), a))
                    for (n = 0, i = a[o].length; n < i; n++) C.event.add(t, o, a[o][n]);
            G.hasData(e) && ((r = G.access(e)), (s = C.extend({}, r)), G.set(t, s));
        }
    }
    function Pe(n, i, o, r) {
        i = v(i);
        var e,
            t,
            s,
            a,
            l,
            c,
            d = 0,
            u = n.length,
            p = u - 1,
            f = i[0],
            h = b(f);
        if (h || (1 < u && "string" == typeof f && !y.checkClone && je.test(f)))
            return n.each(function (e) {
                var t = n.eq(e);
                h && (i[0] = f.call(this, e, t.html())), Pe(t, i, o, r);
            });
        if (
            u &&
            ((t = (e = be(i, n[0].ownerDocument, !1, n, r)).firstChild), 1 === e.childNodes.length && (e = t), t || r)
        ) {
            for (a = (s = C.map(ve(e, "script"), Oe)).length; d < u; d++)
                (l = e), d !== p && ((l = C.clone(l, !0, !0)), a && C.merge(s, ve(l, "script"))), o.call(n[d], l, d);
            if (a)
                for (c = s[s.length - 1].ownerDocument, C.map(s, He), d = 0; d < a; d++)
                    (l = s[d]),
                        he.test(l.type || "") &&
                        !Q.access(l, "globalEval") &&
                        C.contains(c, l) &&
                        (l.src && "module" !== (l.type || "").toLowerCase()
                            ? C._evalUrl && !l.noModule && C._evalUrl(l.src, { nonce: l.nonce || l.getAttribute("nonce") }, c)
                            : w(l.textContent.replace(Le, ""), l, c));
        }
        return n;
    }
    function qe(e, t, n) {
        for (var i, o = t ? C.filter(t, e) : e, r = 0; null != (i = o[r]); r++)
            n || 1 !== i.nodeType || C.cleanData(ve(i)),
                i.parentNode && (n && oe(i) && me(ve(i, "script")), i.parentNode.removeChild(i));
        return e;
    }
    C.extend({
        htmlPrefilter: function (e) {
            return e;
        },
        clone: function (e, t, n) {
            var i,
                o,
                r,
                s,
                a,
                l,
                c,
                d = e.cloneNode(!0),
                u = oe(e);
            if (!(y.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || C.isXMLDoc(e)))
                for (s = ve(d), i = 0, o = (r = ve(e)).length; i < o; i++)
                    (a = r[i]),
                        "input" === (c = (l = s[i]).nodeName.toLowerCase()) && pe.test(a.type)
                            ? (l.checked = a.checked)
                            : ("input" !== c && "textarea" !== c) || (l.defaultValue = a.defaultValue);
            if (t)
                if (n) for (r = r || ve(e), s = s || ve(d), i = 0, o = r.length; i < o; i++) Ne(r[i], s[i]);
                else Ne(e, d);
            return 0 < (s = ve(d, "script")).length && me(s, !u && ve(e, "script")), d;
        },
        cleanData: function (e) {
            for (var t, n, i, o = C.event.special, r = 0; void 0 !== (n = e[r]); r++)
                if (Y(n)) {
                    if ((t = n[Q.expando])) {
                        if (t.events) for (i in t.events) o[i] ? C.event.remove(n, i) : C.removeEvent(n, i, t.handle);
                        n[Q.expando] = void 0;
                    }
                    n[G.expando] && (n[G.expando] = void 0);
                }
        },
    }),
        C.fn.extend({
            detach: function (e) {
                return qe(this, e, !0);
            },
            remove: function (e) {
                return qe(this, e);
            },
            text: function (e) {
                return F(
                    this,
                    function (e) {
                        return void 0 === e
                            ? C.text(this)
                            : this.empty().each(function () {
                                (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                            });
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            append: function () {
                return Pe(this, arguments, function (e) {
                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || De(this, e).appendChild(e);
                });
            },
            prepend: function () {
                return Pe(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = De(this, e);
                        t.insertBefore(e, t.firstChild);
                    }
                });
            },
            before: function () {
                return Pe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            },
            after: function () {
                return Pe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            },
            empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++)
                    1 === e.nodeType && (C.cleanData(ve(e, !1)), (e.textContent = ""));
                return this;
            },
            clone: function (e, t) {
                return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                        return C.clone(this, e, t);
                    })
                );
            },
            html: function (e) {
                return F(
                    this,
                    function (e) {
                        var t = this[0] || {},
                            n = 0,
                            i = this.length;
                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                        if ("string" == typeof e && !Ae.test(e) && !ge[(fe.exec(e) || ["", ""])[1].toLowerCase()]) {
                            e = C.htmlPrefilter(e);
                            try {
                                for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (C.cleanData(ve(t, !1)), (t.innerHTML = e));
                                t = 0;
                            } catch (e) { }
                        }
                        t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            replaceWith: function () {
                var n = [];
                return Pe(
                    this,
                    arguments,
                    function (e) {
                        var t = this.parentNode;
                        C.inArray(this, n) < 0 && (C.cleanData(ve(this)), t && t.replaceChild(e, this));
                    },
                    n
                );
            },
        }),
        C.each(
            {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith",
            },
            function (e, s) {
                C.fn[e] = function (e) {
                    for (var t, n = [], i = C(e), o = i.length - 1, r = 0; r <= o; r++)
                        (t = r === o ? this : this.clone(!0)), C(i[r])[s](t), l.apply(n, t.get());
                    return this.pushStack(n);
                };
            }
        );
    function Me(e, t, n) {
        var i,
            o,
            r = {};
        for (o in t) (r[o] = e.style[o]), (e.style[o] = t[o]);
        for (o in ((i = n.call(e)), t)) e.style[o] = r[o];
        return i;
    }
    var Ie,
        ze,
        We,
        Re,
        Fe,
        _e,
        Be,
        Ue,
        Xe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
        Ye = function (e) {
            var t = e.ownerDocument.defaultView;
            return (t && t.opener) || (t = k), t.getComputedStyle(e);
        },
        Ve = new RegExp(ne.join("|"), "i");
    function Qe(e, t, n) {
        var i,
            o,
            r,
            s,
            a = e.style;
        return (
            (n = n || Ye(e)) &&
            ("" !== (s = n.getPropertyValue(t) || n[t]) || oe(e) || (s = C.style(e, t)),
                !y.pixelBoxStyles() &&
                Xe.test(s) &&
                Ve.test(t) &&
                ((i = a.width),
                    (o = a.minWidth),
                    (r = a.maxWidth),
                    (a.minWidth = a.maxWidth = a.width = s),
                    (s = n.width),
                    (a.width = i),
                    (a.minWidth = o),
                    (a.maxWidth = r))),
            void 0 !== s ? s + "" : s
        );
    }
    function Ge(e, t) {
        return {
            get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
            },
        };
    }
    function Ke() {
        if (Ue) {
            (Be.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                (Ue.style.cssText =
                    "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                ie.appendChild(Be).appendChild(Ue);
            var e = k.getComputedStyle(Ue);
            (Ie = "1%" !== e.top),
                (_e = 12 === Ze(e.marginLeft)),
                (Ue.style.right = "60%"),
                (Re = 36 === Ze(e.right)),
                (ze = 36 === Ze(e.width)),
                (Ue.style.position = "absolute"),
                (We = 12 === Ze(Ue.offsetWidth / 3)),
                ie.removeChild(Be),
                (Ue = null);
        }
    }
    function Ze(e) {
        return Math.round(parseFloat(e));
    }
    (Be = S.createElement("div")),
        (Ue = S.createElement("div")).style &&
        ((Ue.style.backgroundClip = "content-box"),
            (Ue.cloneNode(!0).style.backgroundClip = ""),
            (y.clearCloneStyle = "content-box" === Ue.style.backgroundClip),
            C.extend(y, {
                boxSizingReliable: function () {
                    return Ke(), ze;
                },
                pixelBoxStyles: function () {
                    return Ke(), Re;
                },
                pixelPosition: function () {
                    return Ke(), Ie;
                },
                reliableMarginLeft: function () {
                    return Ke(), _e;
                },
                scrollboxSize: function () {
                    return Ke(), We;
                },
                reliableTrDimensions: function () {
                    var e, t, n, i;
                    return (
                        null == Fe &&
                        ((e = S.createElement("table")),
                            (t = S.createElement("tr")),
                            (n = S.createElement("div")),
                            (e.style.cssText = "position:absolute;left:-11111px"),
                            (t.style.height = "1px"),
                            (n.style.height = "9px"),
                            ie.appendChild(e).appendChild(t).appendChild(n),
                            (i = k.getComputedStyle(t)),
                            (Fe = 3 < parseInt(i.height)),
                            ie.removeChild(e)),
                        Fe
                    );
                },
            }));
    var Je = ["Webkit", "Moz", "ms"],
        et = S.createElement("div").style,
        tt = {};
    function nt(e) {
        return (
            C.cssProps[e] ||
            tt[e] ||
            (e in et
                ? e
                : (tt[e] =
                    (function (e) {
                        for (var t = e[0].toUpperCase() + e.slice(1), n = Je.length; n--;) if ((e = Je[n] + t) in et) return e;
                    })(e) || e))
        );
    }
    var it = /^(none|table(?!-c[ea]).+)/,
        ot = /^--/,
        rt = { position: "absolute", visibility: "hidden", display: "block" },
        st = { letterSpacing: "0", fontWeight: "400" };
    function at(e, t, n) {
        var i = te.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
    }
    function lt(e, t, n, i, o, r) {
        var s = "width" === t ? 1 : 0,
            a = 0,
            l = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; s < 4; s += 2)
            "margin" === n && (l += C.css(e, n + ne[s], !0, o)),
                i
                    ? ("content" === n && (l -= C.css(e, "padding" + ne[s], !0, o)),
                        "margin" !== n && (l -= C.css(e, "border" + ne[s] + "Width", !0, o)))
                    : ((l += C.css(e, "padding" + ne[s], !0, o)),
                        "padding" !== n
                            ? (l += C.css(e, "border" + ne[s] + "Width", !0, o))
                            : (a += C.css(e, "border" + ne[s] + "Width", !0, o)));
        return (
            !i &&
            0 <= r &&
            (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5)) || 0),
            l
        );
    }
    function ct(e, t, n) {
        var i = Ye(e),
            o = (!y.boxSizingReliable() || n) && "border-box" === C.css(e, "boxSizing", !1, i),
            r = o,
            s = Qe(e, t, i),
            a = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Xe.test(s)) {
            if (!n) return s;
            s = "auto";
        }
        return (
            ((!y.boxSizingReliable() && o) ||
                (!y.reliableTrDimensions() && E(e, "tr")) ||
                "auto" === s ||
                (!parseFloat(s) && "inline" === C.css(e, "display", !1, i))) &&
            e.getClientRects().length &&
            ((o = "border-box" === C.css(e, "boxSizing", !1, i)), (r = a in e) && (s = e[a])),
            (s = parseFloat(s) || 0) + lt(e, t, n || (o ? "border" : "content"), r, i, s) + "px"
        );
    }
    function dt(e, t, n, i, o) {
        return new dt.prototype.init(e, t, n, i, o);
    }
    C.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        var n = Qe(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function (e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o,
                    r,
                    s,
                    a = X(t),
                    l = ot.test(t),
                    c = e.style;
                if ((l || (t = nt(a)), (s = C.cssHooks[t] || C.cssHooks[a]), void 0 === n))
                    return s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : c[t];
                "string" === (r = _typeof(n)) && (o = te.exec(n)) && o[1] && ((n = ae(e, t, o)), (r = "number")),
                    null != n &&
                    n == n &&
                    ("number" !== r || l || (n += (o && o[3]) || (C.cssNumber[a] ? "" : "px")),
                        y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                        (s && "set" in s && void 0 === (n = s.set(e, n, i))) || (l ? c.setProperty(t, n) : (c[t] = n)));
            }
        },
        css: function (e, t, n, i) {
            var o,
                r,
                s,
                a = X(t);
            return (
                ot.test(t) || (t = nt(a)),
                (s = C.cssHooks[t] || C.cssHooks[a]) && "get" in s && (o = s.get(e, !0, n)),
                void 0 === o && (o = Qe(e, t, i)),
                "normal" === o && t in st && (o = st[t]),
                "" === n || n ? ((r = parseFloat(o)), !0 === n || isFinite(r) ? r || 0 : o) : o
            );
        },
    }),
        C.each(["height", "width"], function (e, l) {
            C.cssHooks[l] = {
                get: function (e, t, n) {
                    if (t)
                        return !it.test(C.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                            ? ct(e, l, n)
                            : Me(e, rt, function () {
                                return ct(e, l, n);
                            });
                },
                set: function (e, t, n) {
                    var i,
                        o = Ye(e),
                        r = !y.scrollboxSize() && "absolute" === o.position,
                        s = (r || n) && "border-box" === C.css(e, "boxSizing", !1, o),
                        a = n ? lt(e, l, n, s, o) : 0;
                    return (
                        s &&
                        r &&
                        (a -= Math.ceil(
                            e["offset" + l[0].toUpperCase() + l.slice(1)] - parseFloat(o[l]) - lt(e, l, "border", !1, o) - 0.5
                        )),
                        a && (i = te.exec(t)) && "px" !== (i[3] || "px") && ((e.style[l] = t), (t = C.css(e, l))),
                        at(0, t, a)
                    );
                },
            };
        }),
        (C.cssHooks.marginLeft = Ge(y.reliableMarginLeft, function (e, t) {
            if (t)
                return (
                    (parseFloat(Qe(e, "marginLeft")) ||
                        e.getBoundingClientRect().left -
                        Me(e, { marginLeft: 0 }, function () {
                            return e.getBoundingClientRect().left;
                        })) + "px"
                );
        })),
        C.each({ margin: "", padding: "", border: "Width" }, function (o, r) {
            (C.cssHooks[o + r] = {
                expand: function (e) {
                    for (var t = 0, n = {}, i = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++)
                        n[o + ne[t] + r] = i[t] || i[t - 2] || i[0];
                    return n;
                },
            }),
                "margin" !== o && (C.cssHooks[o + r].set = at);
        }),
        C.fn.extend({
            css: function (e, t) {
                return F(
                    this,
                    function (e, t, n) {
                        var i,
                            o,
                            r = {},
                            s = 0;
                        if (Array.isArray(t)) {
                            for (i = Ye(e), o = t.length; s < o; s++) r[t[s]] = C.css(e, t[s], !1, i);
                            return r;
                        }
                        return void 0 !== n ? C.style(e, t, n) : C.css(e, t);
                    },
                    e,
                    t,
                    1 < arguments.length
                );
            },
        }),
        (((C.Tween = dt).prototype = {
            constructor: dt,
            init: function (e, t, n, i, o, r) {
                (this.elem = e),
                    (this.prop = n),
                    (this.easing = o || C.easing._default),
                    (this.options = t),
                    (this.start = this.now = this.cur()),
                    (this.end = i),
                    (this.unit = r || (C.cssNumber[n] ? "" : "px"));
            },
            cur: function () {
                var e = dt.propHooks[this.prop];
                return e && e.get ? e.get(this) : dt.propHooks._default.get(this);
            },
            run: function (e) {
                var t,
                    n = dt.propHooks[this.prop];
                return (
                    this.options.duration
                        ? (this.pos = t = C.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
                        : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : dt.propHooks._default.set(this),
                    this
                );
            },
        }).init.prototype = dt.prototype),
        ((dt.propHooks = {
            _default: {
                get: function (e) {
                    var t;
                    return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                        ? e.elem[e.prop]
                        : (t = C.css(e.elem, e.prop, "")) && "auto" !== t
                            ? t
                            : 0;
                },
                set: function (e) {
                    C.fx.step[e.prop]
                        ? C.fx.step[e.prop](e)
                        : 1 !== e.elem.nodeType || (!C.cssHooks[e.prop] && null == e.elem.style[nt(e.prop)])
                            ? (e.elem[e.prop] = e.now)
                            : C.style(e.elem, e.prop, e.now + e.unit);
                },
            },
        }).scrollTop = dt.propHooks.scrollLeft =
            {
                set: function (e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
            }),
        (C.easing = {
            linear: function (e) {
                return e;
            },
            swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (C.fx = dt.prototype.init),
        (C.fx.step = {});
    var ut,
        pt,
        ft,
        ht,
        gt = /^(?:toggle|show|hide)$/,
        vt = /queueHooks$/;
    function mt() {
        pt &&
            (!1 === S.hidden && k.requestAnimationFrame ? k.requestAnimationFrame(mt) : k.setTimeout(mt, C.fx.interval),
                C.fx.tick());
    }
    function yt() {
        return (
            k.setTimeout(function () {
                ut = void 0;
            }),
            (ut = Date.now())
        );
    }
    function bt(e, t) {
        var n,
            i = 0,
            o = { height: e };
        for (t = t ? 1 : 0; i < 4; i += 2 - t) o["margin" + (n = ne[i])] = o["padding" + n] = e;
        return t && (o.opacity = o.width = e), o;
    }
    function wt(e, t, n) {
        for (var i, o = (xt.tweeners[t] || []).concat(xt.tweeners["*"]), r = 0, s = o.length; r < s; r++)
            if ((i = o[r].call(n, t, e))) return i;
    }
    function xt(r, e, t) {
        var n,
            s,
            i = 0,
            o = xt.prefilters.length,
            a = C.Deferred().always(function () {
                delete l.elem;
            }),
            l = function () {
                if (s) return !1;
                for (
                    var e = ut || yt(),
                    t = Math.max(0, c.startTime + c.duration - e),
                    n = 1 - (t / c.duration || 0),
                    i = 0,
                    o = c.tweens.length;
                    i < o;
                    i++
                )
                    c.tweens[i].run(n);
                return (
                    a.notifyWith(r, [c, n, t]), n < 1 && o ? t : (o || a.notifyWith(r, [c, 1, 0]), a.resolveWith(r, [c]), !1)
                );
            },
            c = a.promise({
                elem: r,
                props: C.extend({}, e),
                opts: C.extend(!0, { specialEasing: {}, easing: C.easing._default }, t),
                originalProperties: e,
                originalOptions: t,
                startTime: ut || yt(),
                duration: t.duration,
                tweens: [],
                createTween: function (e, t) {
                    var n = C.Tween(r, c.opts, e, t, c.opts.specialEasing[e] || c.opts.easing);
                    return c.tweens.push(n), n;
                },
                stop: function (e) {
                    var t = 0,
                        n = e ? c.tweens.length : 0;
                    if (s) return this;
                    for (s = !0; t < n; t++) c.tweens[t].run(1);
                    return e ? (a.notifyWith(r, [c, 1, 0]), a.resolveWith(r, [c, e])) : a.rejectWith(r, [c, e]), this;
                },
            }),
            d = c.props;
        for (
            (function (e, t) {
                var n, i, o, r, s;
                for (n in e)
                    if (
                        ((o = t[(i = X(n))]),
                            (r = e[n]),
                            Array.isArray(r) && ((o = r[1]), (r = e[n] = r[0])),
                            n !== i && ((e[i] = r), delete e[n]),
                            (s = C.cssHooks[i]) && ("expand" in s))
                    )
                        for (n in ((r = s.expand(r)), delete e[i], r)) (n in e) || ((e[n] = r[n]), (t[n] = o));
                    else t[i] = o;
            })(d, c.opts.specialEasing);
            i < o;
            i++
        )
            if ((n = xt.prefilters[i].call(c, r, d, c.opts)))
                return b(n.stop) && (C._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)), n;
        return (
            C.map(d, wt, c),
            b(c.opts.start) && c.opts.start.call(r, c),
            c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
            C.fx.timer(C.extend(l, { elem: r, anim: c, queue: c.opts.queue })),
            c
        );
    }
    (C.Animation = C.extend(xt, {
        tweeners: {
            "*": [
                function (e, t) {
                    var n = this.createTween(e, t);
                    return ae(n.elem, e, te.exec(t), n), n;
                },
            ],
        },
        tweener: function (e, t) {
            for (var n, i = 0, o = (e = b(e) ? ((t = e), ["*"]) : e.match(P)).length; i < o; i++)
                (n = e[i]), (xt.tweeners[n] = xt.tweeners[n] || []), xt.tweeners[n].unshift(t);
        },
        prefilters: [
            function (e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    d,
                    u = "width" in t || "height" in t,
                    p = this,
                    f = {},
                    h = e.style,
                    g = e.nodeType && se(e),
                    v = Q.get(e, "fxshow");
                for (i in (n.queue ||
                    (null == (s = C._queueHooks(e, "fx")).unqueued &&
                        ((s.unqueued = 0),
                            (a = s.empty.fire),
                            (s.empty.fire = function () {
                                s.unqueued || a();
                            })),
                        s.unqueued++,
                        p.always(function () {
                            p.always(function () {
                                s.unqueued--, C.queue(e, "fx").length || s.empty.fire();
                            });
                        })),
                    t))
                    if (((o = t[i]), gt.test(o))) {
                        if ((delete t[i], (r = r || "toggle" === o), o === (g ? "hide" : "show"))) {
                            if ("show" !== o || !v || void 0 === v[i]) continue;
                            g = !0;
                        }
                        f[i] = (v && v[i]) || C.style(e, i);
                    }
                if ((l = !C.isEmptyObject(t)) || !C.isEmptyObject(f))
                    for (i in (u &&
                        1 === e.nodeType &&
                        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                            null == (c = v && v.display) && (c = Q.get(e, "display")),
                            "none" === (d = C.css(e, "display")) &&
                            (c ? (d = c) : (ce([e], !0), (c = e.style.display || c), (d = C.css(e, "display")), ce([e]))),
                            ("inline" === d || ("inline-block" === d && null != c)) &&
                            "none" === C.css(e, "float") &&
                            (l ||
                                (p.done(function () {
                                    h.display = c;
                                }),
                                    null == c && ((d = h.display), (c = "none" === d ? "" : d))),
                                (h.display = "inline-block"))),
                        n.overflow &&
                        ((h.overflow = "hidden"),
                            p.always(function () {
                                (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                            })),
                        (l = !1),
                        f))
                        l ||
                            (v ? "hidden" in v && (g = v.hidden) : (v = Q.access(e, "fxshow", { display: c })),
                                r && (v.hidden = !g),
                                g && ce([e], !0),
                                p.done(function () {
                                    for (i in (g || ce([e]), Q.remove(e, "fxshow"), f)) C.style(e, i, f[i]);
                                })),
                            (l = wt(g ? v[i] : 0, i, p)),
                            i in v || ((v[i] = l.start), g && ((l.end = l.start), (l.start = 0)));
            },
        ],
        prefilter: function (e, t) {
            t ? xt.prefilters.unshift(e) : xt.prefilters.push(e);
        },
    })),
        (C.speed = function (e, t, n) {
            var i =
                e && "object" == _typeof(e)
                    ? C.extend({}, e)
                    : { complete: n || (!n && t) || (b(e) && e), duration: e, easing: (n && t) || (t && !b(t) && t) };
            return (
                C.fx.off
                    ? (i.duration = 0)
                    : "number" != typeof i.duration &&
                    (i.duration in C.fx.speeds ? (i.duration = C.fx.speeds[i.duration]) : (i.duration = C.fx.speeds._default)),
                (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                (i.old = i.complete),
                (i.complete = function () {
                    b(i.old) && i.old.call(this), i.queue && C.dequeue(this, i.queue);
                }),
                i
            );
        }),
        C.fn.extend({
            fadeTo: function (e, t, n, i) {
                return this.filter(se).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
            },
            animate: function (t, e, n, i) {
                function o() {
                    var e = xt(this, C.extend({}, t), s);
                    (r || Q.get(this, "finish")) && e.stop(!0);
                }
                var r = C.isEmptyObject(t),
                    s = C.speed(e, n, i);
                return (o.finish = o), r || !1 === s.queue ? this.each(o) : this.queue(s.queue, o);
            },
            stop: function (o, e, r) {
                function s(e) {
                    var t = e.stop;
                    delete e.stop, t(r);
                }
                return (
                    "string" != typeof o && ((r = e), (e = o), (o = void 0)),
                    e && this.queue(o || "fx", []),
                    this.each(function () {
                        var e = !0,
                            t = null != o && o + "queueHooks",
                            n = C.timers,
                            i = Q.get(this);
                        if (t) i[t] && i[t].stop && s(i[t]);
                        else for (t in i) i[t] && i[t].stop && vt.test(t) && s(i[t]);
                        for (t = n.length; t--;)
                            n[t].elem !== this || (null != o && n[t].queue !== o) || (n[t].anim.stop(r), (e = !1), n.splice(t, 1));
                        (!e && r) || C.dequeue(this, o);
                    })
                );
            },
            finish: function (s) {
                return (
                    !1 !== s && (s = s || "fx"),
                    this.each(function () {
                        var e,
                            t = Q.get(this),
                            n = t[s + "queue"],
                            i = t[s + "queueHooks"],
                            o = C.timers,
                            r = n ? n.length : 0;
                        for (t.finish = !0, C.queue(this, s, []), i && i.stop && i.stop.call(this, !0), e = o.length; e--;)
                            o[e].elem === this && o[e].queue === s && (o[e].anim.stop(!0), o.splice(e, 1));
                        for (e = 0; e < r; e++) n[e] && n[e].finish && n[e].finish.call(this);
                        delete t.finish;
                    })
                );
            },
        }),
        C.each(["toggle", "show", "hide"], function (e, i) {
            var o = C.fn[i];
            C.fn[i] = function (e, t, n) {
                return null == e || "boolean" == typeof e ? o.apply(this, arguments) : this.animate(bt(i, !0), e, t, n);
            };
        }),
        C.each(
            {
                slideDown: bt("show"),
                slideUp: bt("hide"),
                slideToggle: bt("toggle"),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" },
            },
            function (e, i) {
                C.fn[e] = function (e, t, n) {
                    return this.animate(i, e, t, n);
                };
            }
        ),
        (C.timers = []),
        (C.fx.tick = function () {
            var e,
                t = 0,
                n = C.timers;
            for (ut = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || C.fx.stop(), (ut = void 0);
        }),
        (C.fx.timer = function (e) {
            C.timers.push(e), C.fx.start();
        }),
        (C.fx.interval = 13),
        (C.fx.start = function () {
            pt || ((pt = !0), mt());
        }),
        (C.fx.stop = function () {
            pt = null;
        }),
        (C.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (C.fn.delay = function (i, e) {
            return (
                (i = (C.fx && C.fx.speeds[i]) || i),
                (e = e || "fx"),
                this.queue(e, function (e, t) {
                    var n = k.setTimeout(e, i);
                    t.stop = function () {
                        k.clearTimeout(n);
                    };
                })
            );
        }),
        (ft = S.createElement("input")),
        (ht = S.createElement("select").appendChild(S.createElement("option"))),
        (ft.type = "checkbox"),
        (y.checkOn = "" !== ft.value),
        (y.optSelected = ht.selected),
        ((ft = S.createElement("input")).value = "t"),
        (ft.type = "radio"),
        (y.radioValue = "t" === ft.value);
    var Tt,
        kt = C.expr.attrHandle;
    C.fn.extend({
        attr: function (e, t) {
            return F(this, C.attr, e, t, 1 < arguments.length);
        },
        removeAttr: function (e) {
            return this.each(function () {
                C.removeAttr(this, e);
            });
        },
    }),
        C.extend({
            attr: function (e, t, n) {
                var i,
                    o,
                    r = e.nodeType;
                if (3 !== r && 8 !== r && 2 !== r)
                    return void 0 === e.getAttribute
                        ? C.prop(e, t, n)
                        : ((1 === r && C.isXMLDoc(e)) ||
                            (o = C.attrHooks[t.toLowerCase()] || (C.expr.match.bool.test(t) ? Tt : void 0)),
                            void 0 !== n
                                ? null === n
                                    ? void C.removeAttr(e, t)
                                    : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                        ? i
                                        : (e.setAttribute(t, n + ""), n)
                                : !(o && "get" in o && null !== (i = o.get(e, t))) && null == (i = C.find.attr(e, t))
                                    ? void 0
                                    : i);
            },
            attrHooks: {
                type: {
                    set: function (e, t) {
                        if (!y.radioValue && "radio" === t && E(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    },
                },
            },
            removeAttr: function (e, t) {
                var n,
                    i = 0,
                    o = t && t.match(P);
                if (o && 1 === e.nodeType) for (; (n = o[i++]);) e.removeAttribute(n);
            },
        }),
        (Tt = {
            set: function (e, t, n) {
                return !1 === t ? C.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
        }),
        C.each(C.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var s = kt[t] || C.find.attr;
            kt[t] = function (e, t, n) {
                var i,
                    o,
                    r = t.toLowerCase();
                return n || ((o = kt[r]), (kt[r] = i), (i = null != s(e, t, n) ? r : null), (kt[r] = o)), i;
            };
        });
    var St = /^(?:input|select|textarea|button)$/i,
        Ct = /^(?:a|area)$/i;
    function $t(e) {
        return (e.match(P) || []).join(" ");
    }
    function Et(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function At(e) {
        return Array.isArray(e) ? e : ("string" == typeof e && e.match(P)) || [];
    }
    C.fn.extend({
        prop: function (e, t) {
            return F(this, C.prop, e, t, 1 < arguments.length);
        },
        removeProp: function (e) {
            return this.each(function () {
                delete this[C.propFix[e] || e];
            });
        },
    }),
        C.extend({
            prop: function (e, t, n) {
                var i,
                    o,
                    r = e.nodeType;
                if (3 !== r && 8 !== r && 2 !== r)
                    return (
                        (1 === r && C.isXMLDoc(e)) || ((t = C.propFix[t] || t), (o = C.propHooks[t])),
                        void 0 !== n
                            ? o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                ? i
                                : (e[t] = n)
                            : o && "get" in o && null !== (i = o.get(e, t))
                                ? i
                                : e[t]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function (e) {
                        var t = C.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : St.test(e.nodeName) || (Ct.test(e.nodeName) && e.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        y.optSelected ||
        (C.propHooks.selected = {
            get: function (e) {
                var t = e.parentNode;
                return t && t.parentNode && t.parentNode.selectedIndex, null;
            },
            set: function (e) {
                var t = e.parentNode;
                t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
            },
        }),
        C.each(
            [
                "tabIndex",
                "readOnly",
                "maxLength",
                "cellSpacing",
                "cellPadding",
                "rowSpan",
                "colSpan",
                "useMap",
                "frameBorder",
                "contentEditable",
            ],
            function () {
                C.propFix[this.toLowerCase()] = this;
            }
        ),
        C.fn.extend({
            addClass: function (t) {
                var e,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;
                if (b(t))
                    return this.each(function (e) {
                        C(this).addClass(t.call(this, e, Et(this)));
                    });
                if ((e = At(t)).length)
                    for (; (n = this[l++]);)
                        if (((o = Et(n)), (i = 1 === n.nodeType && " " + $t(o) + " "))) {
                            for (s = 0; (r = e[s++]);) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                            o !== (a = $t(i)) && n.setAttribute("class", a);
                        }
                return this;
            },
            removeClass: function (t) {
                var e,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;
                if (b(t))
                    return this.each(function (e) {
                        C(this).removeClass(t.call(this, e, Et(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ((e = At(t)).length)
                    for (; (n = this[l++]);)
                        if (((o = Et(n)), (i = 1 === n.nodeType && " " + $t(o) + " "))) {
                            for (s = 0; (r = e[s++]);) for (; -1 < i.indexOf(" " + r + " ");) i = i.replace(" " + r + " ", " ");
                            o !== (a = $t(i)) && n.setAttribute("class", a);
                        }
                return this;
            },
            toggleClass: function (o, t) {
                var r = _typeof(o),
                    s = "string" === r || Array.isArray(o);
                return "boolean" == typeof t && s
                    ? t
                        ? this.addClass(o)
                        : this.removeClass(o)
                    : b(o)
                        ? this.each(function (e) {
                            C(this).toggleClass(o.call(this, e, Et(this), t), t);
                        })
                        : this.each(function () {
                            var e, t, n, i;
                            if (s)
                                for (t = 0, n = C(this), i = At(o); (e = i[t++]);) n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                            else
                                (void 0 !== o && "boolean" !== r) ||
                                    ((e = Et(this)) && Q.set(this, "__className__", e),
                                        this.setAttribute &&
                                        this.setAttribute("class", (!e && !1 !== o && Q.get(this, "__className__")) || ""));
                        });
            },
            hasClass: function (e) {
                var t,
                    n,
                    i = 0;
                for (t = " " + e + " "; (n = this[i++]);)
                    if (1 === n.nodeType && -1 < (" " + $t(Et(n)) + " ").indexOf(t)) return !0;
                return !1;
            },
        });
    var jt = /\r/g;
    C.fn.extend({
        val: function (n) {
            var i,
                e,
                o,
                t = this[0];
            return arguments.length
                ? ((o = b(n)),
                    this.each(function (e) {
                        var t;
                        1 === this.nodeType &&
                            (null == (t = o ? n.call(this, e, C(this).val()) : n)
                                ? (t = "")
                                : "number" == typeof t
                                    ? (t += "")
                                    : Array.isArray(t) &&
                                    (t = C.map(t, function (e) {
                                        return null == e ? "" : e + "";
                                    })),
                                ((i = C.valHooks[this.type] || C.valHooks[this.nodeName.toLowerCase()]) &&
                                    "set" in i &&
                                    void 0 !== i.set(this, t, "value")) ||
                                (this.value = t));
                    }))
                : t
                    ? (i = C.valHooks[t.type] || C.valHooks[t.nodeName.toLowerCase()]) &&
                        "get" in i &&
                        void 0 !== (e = i.get(t, "value"))
                        ? e
                        : "string" == typeof (e = t.value)
                            ? e.replace(jt, "")
                            : null == e
                                ? ""
                                : e
                    : void 0;
        },
    }),
        C.extend({
            valHooks: {
                option: {
                    get: function (e) {
                        var t = C.find.attr(e, "value");
                        return null != t ? t : $t(C.text(e));
                    },
                },
                select: {
                    get: function (e) {
                        var t,
                            n,
                            i,
                            o = e.options,
                            r = e.selectedIndex,
                            s = "select-one" === e.type,
                            a = s ? null : [],
                            l = s ? r + 1 : o.length;
                        for (i = r < 0 ? l : s ? r : 0; i < l; i++)
                            if (
                                ((n = o[i]).selected || i === r) &&
                                !n.disabled &&
                                (!n.parentNode.disabled || !E(n.parentNode, "optgroup"))
                            ) {
                                if (((t = C(n).val()), s)) return t;
                                a.push(t);
                            }
                        return a;
                    },
                    set: function (e, t) {
                        for (var n, i, o = e.options, r = C.makeArray(t), s = o.length; s--;)
                            ((i = o[s]).selected = -1 < C.inArray(C.valHooks.option.get(i), r)) && (n = !0);
                        return n || (e.selectedIndex = -1), r;
                    },
                },
            },
        }),
        C.each(["radio", "checkbox"], function () {
            (C.valHooks[this] = {
                set: function (e, t) {
                    if (Array.isArray(t)) return (e.checked = -1 < C.inArray(C(e).val(), t));
                },
            }),
                y.checkOn ||
                (C.valHooks[this].get = function (e) {
                    return null === e.getAttribute("value") ? "on" : e.value;
                });
        }),
        (y.focusin = "onfocusin" in k);
    function Lt(e) {
        e.stopPropagation();
    }
    var Dt = /^(?:focusinfocus|focusoutblur)$/;
    C.extend(C.event, {
        trigger: function (e, t, n, i) {
            var o,
                r,
                s,
                a,
                l,
                c,
                d,
                u,
                p = [n || S],
                f = m.call(e, "type") ? e.type : e,
                h = m.call(e, "namespace") ? e.namespace.split(".") : [];
            if (
                ((r = u = s = n = n || S),
                    3 !== n.nodeType &&
                    8 !== n.nodeType &&
                    !Dt.test(f + C.event.triggered) &&
                    (-1 < f.indexOf(".") && ((f = (h = f.split(".")).shift()), h.sort()),
                        (l = f.indexOf(":") < 0 && "on" + f),
                        ((e = e[C.expando] ? e : new C.Event(f, "object" == _typeof(e) && e)).isTrigger = i ? 2 : 3),
                        (e.namespace = h.join(".")),
                        (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                        (e.result = void 0),
                        e.target || (e.target = n),
                        (t = null == t ? [e] : C.makeArray(t, [e])),
                        (d = C.event.special[f] || {}),
                        i || !d.trigger || !1 !== d.trigger.apply(n, t)))
            ) {
                if (!i && !d.noBubble && !g(n)) {
                    for (a = d.delegateType || f, Dt.test(a + f) || (r = r.parentNode); r; r = r.parentNode) p.push(r), (s = r);
                    s === (n.ownerDocument || S) && p.push(s.defaultView || s.parentWindow || k);
                }
                for (o = 0; (r = p[o++]) && !e.isPropagationStopped();)
                    (u = r),
                        (e.type = 1 < o ? a : d.bindType || f),
                        (c = (Q.get(r, "events") || Object.create(null))[e.type] && Q.get(r, "handle")) && c.apply(r, t),
                        (c = l && r[l]) && c.apply && Y(r) && ((e.result = c.apply(r, t)), !1 === e.result && e.preventDefault());
                return (
                    (e.type = f),
                    i ||
                    e.isDefaultPrevented() ||
                    (d._default && !1 !== d._default.apply(p.pop(), t)) ||
                    !Y(n) ||
                    (l &&
                        b(n[f]) &&
                        !g(n) &&
                        ((s = n[l]) && (n[l] = null),
                            (C.event.triggered = f),
                            e.isPropagationStopped() && u.addEventListener(f, Lt),
                            n[f](),
                            e.isPropagationStopped() && u.removeEventListener(f, Lt),
                            (C.event.triggered = void 0),
                            s && (n[l] = s))),
                    e.result
                );
            }
        },
        simulate: function (e, t, n) {
            var i = C.extend(new C.Event(), n, { type: e, isSimulated: !0 });
            C.event.trigger(i, null, t);
        },
    }),
        C.fn.extend({
            trigger: function (e, t) {
                return this.each(function () {
                    C.event.trigger(e, t, this);
                });
            },
            triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return C.event.trigger(e, t, n, !0);
            },
        }),
        y.focusin ||
        C.each({ focus: "focusin", blur: "focusout" }, function (n, i) {
            function o(e) {
                C.event.simulate(i, e.target, C.event.fix(e));
            }
            C.event.special[i] = {
                setup: function () {
                    var e = this.ownerDocument || this.document || this,
                        t = Q.access(e, i);
                    t || e.addEventListener(n, o, !0), Q.access(e, i, (t || 0) + 1);
                },
                teardown: function () {
                    var e = this.ownerDocument || this.document || this,
                        t = Q.access(e, i) - 1;
                    t ? Q.access(e, i, t) : (e.removeEventListener(n, o, !0), Q.remove(e, i));
                },
            };
        });
    var Ot = k.location,
        Ht = { guid: Date.now() },
        Nt = /\?/;
    C.parseXML = function (e) {
        var t;
        if (!e || "string" != typeof e) return null;
        try {
            t = new k.DOMParser().parseFromString(e, "text/xml");
        } catch (e) {
            t = void 0;
        }
        return (t && !t.getElementsByTagName("parsererror").length) || C.error("Invalid XML: " + e), t;
    };
    var Pt = /\[\]$/,
        qt = /\r?\n/g,
        Mt = /^(?:submit|button|image|reset|file)$/i,
        It = /^(?:input|select|textarea|keygen)/i;
    function zt(n, e, i, o) {
        var t;
        if (Array.isArray(e))
            C.each(e, function (e, t) {
                i || Pt.test(n) ? o(n, t) : zt(n + "[" + ("object" == _typeof(t) && null != t ? e : "") + "]", t, i, o);
            });
        else if (i || "object" !== x(e)) o(n, e);
        else for (t in e) zt(n + "[" + t + "]", e[t], i, o);
    }
    (C.param = function (e, t) {
        function n(e, t) {
            var n = b(t) ? t() : t;
            o[o.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
        }
        var i,
            o = [];
        if (null == e) return "";
        if (Array.isArray(e) || (e.jquery && !C.isPlainObject(e)))
            C.each(e, function () {
                n(this.name, this.value);
            });
        else for (i in e) zt(i, e[i], t, n);
        return o.join("&");
    }),
        C.fn.extend({
            serialize: function () {
                return C.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    var e = C.prop(this, "elements");
                    return e ? C.makeArray(e) : this;
                })
                    .filter(function () {
                        var e = this.type;
                        return (
                            this.name &&
                            !C(this).is(":disabled") &&
                            It.test(this.nodeName) &&
                            !Mt.test(e) &&
                            (this.checked || !pe.test(e))
                        );
                    })
                    .map(function (e, t) {
                        var n = C(this).val();
                        return null == n
                            ? null
                            : Array.isArray(n)
                                ? C.map(n, function (e) {
                                    return { name: t.name, value: e.replace(qt, "\r\n") };
                                })
                                : { name: t.name, value: n.replace(qt, "\r\n") };
                    })
                    .get();
            },
        });
    var Wt = /%20/g,
        Rt = /#.*$/,
        Ft = /([?&])_=[^&]*/,
        _t = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Bt = /^(?:GET|HEAD)$/,
        Ut = /^\/\//,
        Xt = {},
        Yt = {},
        Vt = "*/".concat("*"),
        Qt = S.createElement("a");
    function Gt(r) {
        return function (e, t) {
            "string" != typeof e && ((t = e), (e = "*"));
            var n,
                i = 0,
                o = e.toLowerCase().match(P) || [];
            if (b(t))
                for (; (n = o[i++]);)
                    "+" === n[0] ? ((n = n.slice(1) || "*"), (r[n] = r[n] || []).unshift(t)) : (r[n] = r[n] || []).push(t);
        };
    }
    function Kt(t, o, r, s) {
        var a = {},
            l = t === Yt;
        function c(e) {
            var i;
            return (
                (a[e] = !0),
                C.each(t[e] || [], function (e, t) {
                    var n = t(o, r, s);
                    return "string" != typeof n || l || a[n] ? (l ? !(i = n) : void 0) : (o.dataTypes.unshift(n), c(n), !1);
                }),
                i
            );
        }
        return c(o.dataTypes[0]) || (!a["*"] && c("*"));
    }
    function Zt(e, t) {
        var n,
            i,
            o = C.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((o[n] ? e : (i = i || {}))[n] = t[n]);
        return i && C.extend(!0, e, i), e;
    }
    (Qt.href = Ot.href),
        C.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: Ot.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ot.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": Vt,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript",
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": C.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e, t) {
                return t ? Zt(Zt(e, C.ajaxSettings), t) : Zt(C.ajaxSettings, e);
            },
            ajaxPrefilter: Gt(Xt),
            ajaxTransport: Gt(Yt),
            ajax: function (e, t) {
                "object" == _typeof(e) && ((t = e), (e = void 0)), (t = t || {});
                var d,
                    u,
                    p,
                    n,
                    f,
                    i,
                    h,
                    g,
                    o,
                    r,
                    v = C.ajaxSetup({}, t),
                    m = v.context || v,
                    y = v.context && (m.nodeType || m.jquery) ? C(m) : C.event,
                    b = C.Deferred(),
                    w = C.Callbacks("once memory"),
                    x = v.statusCode || {},
                    s = {},
                    a = {},
                    l = "canceled",
                    T = {
                        readyState: 0,
                        getResponseHeader: function (e) {
                            var t;
                            if (h) {
                                if (!n)
                                    for (n = {}; (t = _t.exec(p));)
                                        n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                t = n[e.toLowerCase() + " "];
                            }
                            return null == t ? null : t.join(", ");
                        },
                        getAllResponseHeaders: function () {
                            return h ? p : null;
                        },
                        setRequestHeader: function (e, t) {
                            return null == h && ((e = a[e.toLowerCase()] = a[e.toLowerCase()] || e), (s[e] = t)), this;
                        },
                        overrideMimeType: function (e) {
                            return null == h && (v.mimeType = e), this;
                        },
                        statusCode: function (e) {
                            var t;
                            if (e)
                                if (h) T.always(e[T.status]);
                                else for (t in e) x[t] = [x[t], e[t]];
                            return this;
                        },
                        abort: function (e) {
                            var t = e || l;
                            return d && d.abort(t), c(0, t), this;
                        },
                    };
                if (
                    (b.promise(T),
                        (v.url = ((e || v.url || Ot.href) + "").replace(Ut, Ot.protocol + "//")),
                        (v.type = t.method || t.type || v.method || v.type),
                        (v.dataTypes = (v.dataType || "*").toLowerCase().match(P) || [""]),
                        null == v.crossDomain)
                ) {
                    i = S.createElement("a");
                    try {
                        (i.href = v.url),
                            (i.href = i.href),
                            (v.crossDomain = Qt.protocol + "//" + Qt.host != i.protocol + "//" + i.host);
                    } catch (e) {
                        v.crossDomain = !0;
                    }
                }
                if (
                    (v.data && v.processData && "string" != typeof v.data && (v.data = C.param(v.data, v.traditional)),
                        Kt(Xt, v, t, T),
                        h)
                )
                    return T;
                for (o in ((g = C.event && v.global) && 0 == C.active++ && C.event.trigger("ajaxStart"),
                    (v.type = v.type.toUpperCase()),
                    (v.hasContent = !Bt.test(v.type)),
                    (u = v.url.replace(Rt, "")),
                    v.hasContent
                        ? v.data &&
                        v.processData &&
                        0 === (v.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                        (v.data = v.data.replace(Wt, "+"))
                        : ((r = v.url.slice(u.length)),
                            v.data &&
                            (v.processData || "string" == typeof v.data) &&
                            ((u += (Nt.test(u) ? "&" : "?") + v.data), delete v.data),
                            !1 === v.cache && ((u = u.replace(Ft, "$1")), (r = (Nt.test(u) ? "&" : "?") + "_=" + Ht.guid++ + r)),
                            (v.url = u + r)),
                    v.ifModified &&
                    (C.lastModified[u] && T.setRequestHeader("If-Modified-Since", C.lastModified[u]),
                        C.etag[u] && T.setRequestHeader("If-None-Match", C.etag[u])),
                    ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) &&
                    T.setRequestHeader("Content-Type", v.contentType),
                    T.setRequestHeader(
                        "Accept",
                        v.dataTypes[0] && v.accepts[v.dataTypes[0]]
                            ? v.accepts[v.dataTypes[0]] + ("*" !== v.dataTypes[0] ? ", " + Vt + "; q=0.01" : "")
                            : v.accepts["*"]
                    ),
                    v.headers))
                    T.setRequestHeader(o, v.headers[o]);
                if (v.beforeSend && (!1 === v.beforeSend.call(m, T, v) || h)) return T.abort();
                if (((l = "abort"), w.add(v.complete), T.done(v.success), T.fail(v.error), (d = Kt(Yt, v, t, T)))) {
                    if (((T.readyState = 1), g && y.trigger("ajaxSend", [T, v]), h)) return T;
                    v.async &&
                        0 < v.timeout &&
                        (f = k.setTimeout(function () {
                            T.abort("timeout");
                        }, v.timeout));
                    try {
                        (h = !1), d.send(s, c);
                    } catch (e) {
                        if (h) throw e;
                        c(-1, e);
                    }
                } else c(-1, "No Transport");
                function c(e, t, n, i) {
                    var o,
                        r,
                        s,
                        a,
                        l,
                        c = t;
                    h ||
                        ((h = !0),
                            f && k.clearTimeout(f),
                            (d = void 0),
                            (p = i || ""),
                            (T.readyState = 0 < e ? 4 : 0),
                            (o = (200 <= e && e < 300) || 304 === e),
                            n &&
                            (a = (function (e, t, n) {
                                for (var i, o, r, s, a = e.contents, l = e.dataTypes; "*" === l[0];)
                                    l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (i)
                                    for (o in a)
                                        if (a[o] && a[o].test(i)) {
                                            l.unshift(o);
                                            break;
                                        }
                                if (l[0] in n) r = l[0];
                                else {
                                    for (o in n) {
                                        if (!l[0] || e.converters[o + " " + l[0]]) {
                                            r = o;
                                            break;
                                        }
                                        s = s || o;
                                    }
                                    r = r || s;
                                }
                                if (r) return r !== l[0] && l.unshift(r), n[r];
                            })(v, T, n)),
                            !o && -1 < C.inArray("script", v.dataTypes) && (v.converters["text script"] = function () { }),
                            (a = (function (e, t, n, i) {
                                var o,
                                    r,
                                    s,
                                    a,
                                    l,
                                    c = {},
                                    d = e.dataTypes.slice();
                                if (d[1]) for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
                                for (r = d.shift(); r;)
                                    if (
                                        (e.responseFields[r] && (n[e.responseFields[r]] = t),
                                            !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                                            (l = r),
                                            (r = d.shift()))
                                    )
                                        if ("*" === r) r = l;
                                        else if ("*" !== l && l !== r) {
                                            if (!(s = c[l + " " + r] || c["* " + r]))
                                                for (o in c)
                                                    if ((a = o.split(" "))[1] === r && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
                                                        !0 === s ? (s = c[o]) : !0 !== c[o] && ((r = a[0]), d.unshift(a[1]));
                                                        break;
                                                    }
                                            if (!0 !== s)
                                                if (s && e.throws) t = s(t);
                                                else
                                                    try {
                                                        t = s(t);
                                                    } catch (e) {
                                                        return { state: "parsererror", error: s ? e : "No conversion from " + l + " to " + r };
                                                    }
                                        }
                                return { state: "success", data: t };
                            })(v, a, T, o)),
                            o
                                ? (v.ifModified &&
                                    ((l = T.getResponseHeader("Last-Modified")) && (C.lastModified[u] = l),
                                        (l = T.getResponseHeader("etag")) && (C.etag[u] = l)),
                                    204 === e || "HEAD" === v.type
                                        ? (c = "nocontent")
                                        : 304 === e
                                            ? (c = "notmodified")
                                            : ((c = a.state), (r = a.data), (o = !(s = a.error))))
                                : ((s = c), (!e && c) || ((c = "error"), e < 0 && (e = 0))),
                            (T.status = e),
                            (T.statusText = (t || c) + ""),
                            o ? b.resolveWith(m, [r, c, T]) : b.rejectWith(m, [T, c, s]),
                            T.statusCode(x),
                            (x = void 0),
                            g && y.trigger(o ? "ajaxSuccess" : "ajaxError", [T, v, o ? r : s]),
                            w.fireWith(m, [T, c]),
                            g && (y.trigger("ajaxComplete", [T, v]), --C.active || C.event.trigger("ajaxStop")));
                }
                return T;
            },
            getJSON: function (e, t, n) {
                return C.get(e, t, n, "json");
            },
            getScript: function (e, t) {
                return C.get(e, void 0, t, "script");
            },
        }),
        C.each(["get", "post"], function (e, o) {
            C[o] = function (e, t, n, i) {
                return (
                    b(t) && ((i = i || n), (n = t), (t = void 0)),
                    C.ajax(C.extend({ url: e, type: o, dataType: i, data: t, success: n }, C.isPlainObject(e) && e))
                );
            };
        }),
        C.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
        }),
        (C._evalUrl = function (e, t, n) {
            return C.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () { } },
                dataFilter: function (e) {
                    C.globalEval(e, t, n);
                },
            });
        }),
        C.fn.extend({
            wrapAll: function (e) {
                var t;
                return (
                    this[0] &&
                    (b(e) && (e = e.call(this[0])),
                        (t = C(e, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t
                            .map(function () {
                                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                                return e;
                            })
                            .append(this)),
                    this
                );
            },
            wrapInner: function (n) {
                return b(n)
                    ? this.each(function (e) {
                        C(this).wrapInner(n.call(this, e));
                    })
                    : this.each(function () {
                        var e = C(this),
                            t = e.contents();
                        t.length ? t.wrapAll(n) : e.append(n);
                    });
            },
            wrap: function (t) {
                var n = b(t);
                return this.each(function (e) {
                    C(this).wrapAll(n ? t.call(this, e) : t);
                });
            },
            unwrap: function (e) {
                return (
                    this.parent(e)
                        .not("body")
                        .each(function () {
                            C(this).replaceWith(this.childNodes);
                        }),
                    this
                );
            },
        }),
        (C.expr.pseudos.hidden = function (e) {
            return !C.expr.pseudos.visible(e);
        }),
        (C.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
        }),
        (C.ajaxSettings.xhr = function () {
            try {
                return new k.XMLHttpRequest();
            } catch (e) { }
        });
    var Jt = { 0: 200, 1223: 204 },
        en = C.ajaxSettings.xhr();
    (y.cors = !!en && "withCredentials" in en),
        (y.ajax = en = !!en),
        C.ajaxTransport(function (o) {
            var r, s;
            if (y.cors || (en && !o.crossDomain))
                return {
                    send: function (e, t) {
                        var n,
                            i = o.xhr();
                        if ((i.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields))
                            for (n in o.xhrFields) i[n] = o.xhrFields[n];
                        for (n in (o.mimeType && i.overrideMimeType && i.overrideMimeType(o.mimeType),
                            o.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"),
                            e))
                            i.setRequestHeader(n, e[n]);
                        (r = function (e) {
                            return function () {
                                r &&
                                    ((r = s = i.onload = i.onerror = i.onabort = i.ontimeout = i.onreadystatechange = null),
                                        "abort" === e
                                            ? i.abort()
                                            : "error" === e
                                                ? "number" != typeof i.status
                                                    ? t(0, "error")
                                                    : t(i.status, i.statusText)
                                                : t(
                                                    Jt[i.status] || i.status,
                                                    i.statusText,
                                                    "text" !== (i.responseType || "text") || "string" != typeof i.responseText
                                                        ? { binary: i.response }
                                                        : { text: i.responseText },
                                                    i.getAllResponseHeaders()
                                                ));
                            };
                        }),
                            (i.onload = r()),
                            (s = i.onerror = i.ontimeout = r("error")),
                            void 0 !== i.onabort
                                ? (i.onabort = s)
                                : (i.onreadystatechange = function () {
                                    4 === i.readyState &&
                                        k.setTimeout(function () {
                                            r && s();
                                        });
                                }),
                            (r = r("abort"));
                        try {
                            i.send((o.hasContent && o.data) || null);
                        } catch (e) {
                            if (r) throw e;
                        }
                    },
                    abort: function () {
                        r && r();
                    },
                };
        }),
        C.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
        }),
        C.ajaxSetup({
            accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function (e) {
                    return C.globalEval(e), e;
                },
            },
        }),
        C.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }),
        C.ajaxTransport("script", function (n) {
            var i, o;
            if (n.crossDomain || n.scriptAttrs)
                return {
                    send: function (e, t) {
                        (i = C("<script>")
                            .attr(n.scriptAttrs || {})
                            .prop({ charset: n.scriptCharset, src: n.url })
                            .on(
                                "load error",
                                (o = function (e) {
                                    i.remove(), (o = null), e && t("error" === e.type ? 404 : 200, e.type);
                                })
                            )),
                            S.head.appendChild(i[0]);
                    },
                    abort: function () {
                        o && o();
                    },
                };
        });
    var tn,
        nn = [],
        on = /(=)\?(?=&|$)|\?\?/;
    C.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var e = nn.pop() || C.expando + "_" + Ht.guid++;
            return (this[e] = !0), e;
        },
    }),
        C.ajaxPrefilter("json jsonp", function (e, t, n) {
            var i,
                o,
                r,
                s =
                    !1 !== e.jsonp &&
                    (on.test(e.url)
                        ? "url"
                        : "string" == typeof e.data &&
                        0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                        on.test(e.data) &&
                        "data");
            if (s || "jsonp" === e.dataTypes[0])
                return (
                    (i = e.jsonpCallback = b(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                    s
                        ? (e[s] = e[s].replace(on, "$1" + i))
                        : !1 !== e.jsonp && (e.url += (Nt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
                    (e.converters["script json"] = function () {
                        return r || C.error(i + " was not called"), r[0];
                    }),
                    (e.dataTypes[0] = "json"),
                    (o = k[i]),
                    (k[i] = function () {
                        r = arguments;
                    }),
                    n.always(function () {
                        void 0 === o ? C(k).removeProp(i) : (k[i] = o),
                            e[i] && ((e.jsonpCallback = t.jsonpCallback), nn.push(i)),
                            r && b(o) && o(r[0]),
                            (r = o = void 0);
                    }),
                    "script"
                );
        }),
        (y.createHTMLDocument =
            (((tn = S.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"),
                2 === tn.childNodes.length)),
        (C.parseHTML = function (e, t, n) {
            return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                    t ||
                    (y.createHTMLDocument
                        ? (((i = (t = S.implementation.createHTMLDocument("")).createElement("base")).href = S.location.href),
                            t.head.appendChild(i))
                        : (t = S)),
                    (r = !n && []),
                    (o = A.exec(e))
                        ? [t.createElement(o[1])]
                        : ((o = be([e], t, r)), r && r.length && C(r).remove(), C.merge([], o.childNodes)));
            var i, o, r;
        }),
        (C.fn.load = function (e, t, n) {
            var i,
                o,
                r,
                s = this,
                a = e.indexOf(" ");
            return (
                -1 < a && ((i = $t(e.slice(a))), (e = e.slice(0, a))),
                b(t) ? ((n = t), (t = void 0)) : t && "object" == _typeof(t) && (o = "POST"),
                0 < s.length &&
                C.ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                    .done(function (e) {
                        (r = arguments), s.html(i ? C("<div>").append(C.parseHTML(e)).find(i) : e);
                    })
                    .always(
                        n &&
                        function (e, t) {
                            s.each(function () {
                                n.apply(this, r || [e.responseText, t, e]);
                            });
                        }
                    ),
                this
            );
        }),
        (C.expr.pseudos.animated = function (t) {
            return C.grep(C.timers, function (e) {
                return t === e.elem;
            }).length;
        }),
        (C.offset = {
            setOffset: function (e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c = C.css(e, "position"),
                    d = C(e),
                    u = {};
                "static" === c && (e.style.position = "relative"),
                    (a = d.offset()),
                    (r = C.css(e, "top")),
                    (l = C.css(e, "left")),
                    (o =
                        ("absolute" === c || "fixed" === c) && -1 < (r + l).indexOf("auto")
                            ? ((s = (i = d.position()).top), i.left)
                            : ((s = parseFloat(r) || 0), parseFloat(l) || 0)),
                    b(t) && (t = t.call(e, n, C.extend({}, a))),
                    null != t.top && (u.top = t.top - a.top + s),
                    null != t.left && (u.left = t.left - a.left + o),
                    "using" in t
                        ? t.using.call(e, u)
                        : ("number" == typeof u.top && (u.top += "px"), "number" == typeof u.left && (u.left += "px"), d.css(u));
            },
        }),
        C.fn.extend({
            offset: function (t) {
                if (arguments.length)
                    return void 0 === t
                        ? this
                        : this.each(function (e) {
                            C.offset.setOffset(this, t, e);
                        });
                var e,
                    n,
                    i = this[0];
                return i
                    ? i.getClientRects().length
                        ? ((e = i.getBoundingClientRect()),
                            (n = i.ownerDocument.defaultView),
                            { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset })
                        : { top: 0, left: 0 }
                    : void 0;
            },
            position: function () {
                if (this[0]) {
                    var e,
                        t,
                        n,
                        i = this[0],
                        o = { top: 0, left: 0 };
                    if ("fixed" === C.css(i, "position")) t = i.getBoundingClientRect();
                    else {
                        for (
                            t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement;
                            e && (e === n.body || e === n.documentElement) && "static" === C.css(e, "position");

                        )
                            e = e.parentNode;
                        e &&
                            e !== i &&
                            1 === e.nodeType &&
                            (((o = C(e).offset()).top += C.css(e, "borderTopWidth", !0)),
                                (o.left += C.css(e, "borderLeftWidth", !0)));
                    }
                    return { top: t.top - o.top - C.css(i, "marginTop", !0), left: t.left - o.left - C.css(i, "marginLeft", !0) };
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    for (var e = this.offsetParent; e && "static" === C.css(e, "position");) e = e.offsetParent;
                    return e || ie;
                });
            },
        }),
        C.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, o) {
            var r = "pageYOffset" === o;
            C.fn[t] = function (e) {
                return F(
                    this,
                    function (e, t, n) {
                        var i;
                        if ((g(e) ? (i = e) : 9 === e.nodeType && (i = e.defaultView), void 0 === n)) return i ? i[o] : e[t];
                        i ? i.scrollTo(r ? i.pageXOffset : n, r ? n : i.pageYOffset) : (e[t] = n);
                    },
                    t,
                    e,
                    arguments.length
                );
            };
        }),
        C.each(["top", "left"], function (e, n) {
            C.cssHooks[n] = Ge(y.pixelPosition, function (e, t) {
                if (t) return (t = Qe(e, n)), Xe.test(t) ? C(e).position()[n] + "px" : t;
            });
        }),
        C.each({ Height: "height", Width: "width" }, function (s, a) {
            C.each({ padding: "inner" + s, content: a, "": "outer" + s }, function (i, r) {
                C.fn[r] = function (e, t) {
                    var n = arguments.length && (i || "boolean" != typeof e),
                        o = i || (!0 === e || !0 === t ? "margin" : "border");
                    return F(
                        this,
                        function (e, t, n) {
                            var i;
                            return g(e)
                                ? 0 === r.indexOf("outer")
                                    ? e["inner" + s]
                                    : e.document.documentElement["client" + s]
                                : 9 === e.nodeType
                                    ? ((i = e.documentElement),
                                        Math.max(
                                            e.body["scroll" + s],
                                            i["scroll" + s],
                                            e.body["offset" + s],
                                            i["offset" + s],
                                            i["client" + s]
                                        ))
                                    : void 0 === n
                                        ? C.css(e, t, o)
                                        : C.style(e, t, n, o);
                        },
                        a,
                        n ? e : void 0,
                        n
                    );
                };
            });
        }),
        C.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            C.fn[t] = function (e) {
                return this.on(t, e);
            };
        }),
        C.fn.extend({
            bind: function (e, t, n) {
                return this.on(e, null, t, n);
            },
            unbind: function (e, t) {
                return this.off(e, null, t);
            },
            delegate: function (e, t, n, i) {
                return this.on(t, e, n, i);
            },
            undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            },
        }),
        C.each(
            "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                " "
            ),
            function (e, n) {
                C.fn[n] = function (e, t) {
                    return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n);
                };
            }
        );
    var rn = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (C.proxy = function (e, t) {
        var n, i, o;
        if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), b(e)))
            return (
                (i = a.call(arguments, 2)),
                ((o = function () {
                    return e.apply(t || this, i.concat(a.call(arguments)));
                }).guid = e.guid =
                    e.guid || C.guid++),
                o
            );
    }),
        (C.holdReady = function (e) {
            e ? C.readyWait++ : C.ready(!0);
        }),
        (C.isArray = Array.isArray),
        (C.parseJSON = JSON.parse),
        (C.nodeName = E),
        (C.isFunction = b),
        (C.isWindow = g),
        (C.camelCase = X),
        (C.type = x),
        (C.now = Date.now),
        (C.isNumeric = function (e) {
            var t = C.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
        }),
        (C.trim = function (e) {
            return null == e ? "" : (e + "").replace(rn, "");
        }),
        "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
            return C;
        });
    var sn = k.jQuery,
        an = k.$;
    return (
        (C.noConflict = function (e) {
            return k.$ === C && (k.$ = an), e && k.jQuery === C && (k.jQuery = sn), C;
        }),
        void 0 === e && (k.jQuery = k.$ = C),
        C
    );
}),
    (theme.jQuery = $),
    (function (e) {
        var t,
            n,
            d,
            l,
            c,
            u,
            p,
            f,
            h,
            g,
            v,
            m,
            y,
            b,
            w,
            x,
            T,
            k,
            S,
            r,
            i,
            s,
            a,
            C,
            $,
            E,
            A,
            j,
            L,
            D,
            O,
            H,
            N,
            P,
            q,
            M,
            I,
            o,
            z,
            W,
            R,
            F,
            _,
            B,
            U,
            X,
            Y,
            V,
            Q,
            G,
            K,
            Z,
            J,
            ee,
            te,
            ne,
            ie,
            oe,
            re,
            se,
            ae,
            le,
            ce;
        e = jQuery = e;
        function de(e, t, n) {
            var i = l.createElement(e);
            return t && (i.id = U + t), n && (i.style.cssText = n), d(i);
        }
        function ue() {
            return c.innerHeight ? c.innerHeight : d(c).height();
        }
        function pe(e, n) {
            n !== Object(n) && (n = {}),
                (this.cache = {}),
                (this.el = e),
                (this.value = function (e) {
                    var t;
                    return (
                        void 0 === this.cache[e] &&
                        (void 0 !== (t = d(this.el).attr("data-cbox-" + e))
                            ? (this.cache[e] = t)
                            : void 0 !== n[e]
                                ? (this.cache[e] = n[e])
                                : void 0 !== _[e] && (this.cache[e] = _[e])),
                        this.cache[e]
                    );
                }),
                (this.get = function (e) {
                    var t = this.value(e);
                    return d.isFunction(t) ? t.call(this.el, this) : t;
                });
        }
        function fe(e) {
            var t = b.length,
                n = (O + e) % t;
            return n < 0 ? t + n : n;
        }
        function he(e, t) {
            return Math.round((/%/.test(e) ? ("x" === t ? w.width() : ue()) / 100 : 1) * parseInt(e, 10));
        }
        function ge(e, t) {
            return e.get("photo") || e.get("photoRegex").test(t);
        }
        function ve(e, t) {
            return e.get("retinaUrl") && 1 < c.devicePixelRatio ? t.replace(e.get("photoRegex"), e.get("retinaSuffix")) : t;
        }
        function me(e) {
            "contains" in p[0] && !p[0].contains(e.target) && e.target !== u[0] && (e.stopPropagation(), p.focus());
        }
        function ye(e) {
            ye.str !== e && (p.add(u).removeClass(ye.str).addClass(e), (ye.str = e));
        }
        function be(e) {
            d(l).trigger(e), J.triggerHandler(e);
        }
        function we(e) {
            var t, n;
            if (!q) {
                if (
                    ((t = d(e).data(B)),
                        (E = new pe(e, t)),
                        (n = E.get("rel")),
                        (O = 0),
                        n && !1 !== n && "nofollow" !== n
                            ? ((b = d("." + X).filter(function () {
                                return new pe(this, d.data(this, B)).get("rel") === n;
                            })),
                                -1 === (O = b.index(E.el)) && ((b = b.add(E.el)), (O = b.length - 1)))
                            : (b = d(E.el)),
                        !N)
                ) {
                    (N = P = !0),
                        ye(E.get("className")),
                        p.css({ visibility: "hidden", display: "block", opacity: "" }),
                        (x = de(ee, "LoadedContent", "width:0; height:0; overflow:hidden; visibility:hidden")),
                        h.css({ width: "", height: "" }).append(x),
                        (A = g.height() + y.height() + h.outerHeight(!0) - h.height()),
                        (j = v.width() + m.width() + h.outerWidth(!0) - h.width()),
                        (L = x.outerHeight(!0)),
                        (D = x.outerWidth(!0));
                    var i = he(E.get("initialWidth"), "x"),
                        o = he(E.get("initialHeight"), "y"),
                        r = E.get("maxWidth"),
                        s = E.get("maxHeight");
                    (E.w = Math.max((!1 !== r ? Math.min(i, he(r, "x")) : i) - D - j, 0)),
                        (E.h = Math.max((!1 !== s ? Math.min(o, he(s, "y")) : o) - L - A, 0)),
                        x.css({ width: "", height: E.h }),
                        I.position(),
                        be(Y),
                        E.get("onOpen"),
                        $.add(S).hide(),
                        p.focus(),
                        E.get("trapFocus") &&
                        l.addEventListener &&
                        (l.addEventListener("focus", me, !0),
                            J.one(K, function () {
                                l.removeEventListener("focus", me, !0);
                            })),
                        E.get("returnFocus") &&
                        J.one(K, function () {
                            d(E.el).focus();
                        });
                }
                var a = parseFloat(E.get("opacity"));
                u
                    .css({ opacity: a == a ? a : "", cursor: E.get("overlayClose") ? "pointer" : "", visibility: "visible" })
                    .show(),
                    E.get("closeButton") ? C.html(E.get("close")).appendTo(h) : C.appendTo("<div/>"),
                    (function () {
                        var e,
                            t,
                            n,
                            i = I.prep,
                            o = ++te;
                        if (
                            ((H = !(P = !0)),
                                be(Z),
                                be(V),
                                E.get("onLoad"),
                                (E.h = E.get("height")
                                    ? he(E.get("height"), "y") - L - A
                                    : E.get("innerHeight") && he(E.get("innerHeight"), "y")),
                                (E.w = E.get("width")
                                    ? he(E.get("width"), "x") - D - j
                                    : E.get("innerWidth") && he(E.get("innerWidth"), "x")),
                                (E.mw = E.w),
                                (E.mh = E.h),
                                E.get("maxWidth") &&
                                ((E.mw = he(E.get("maxWidth"), "x") - D - j), (E.mw = E.w && E.w < E.mw ? E.w : E.mw)),
                                E.get("maxHeight") &&
                                ((E.mh = he(E.get("maxHeight"), "y") - L - A), (E.mh = E.h && E.h < E.mh ? E.h : E.mh)),
                                (e = E.get("href")),
                                (M = setTimeout(function () {
                                    k.show();
                                }, 100)),
                                E.get("inline"))
                        ) {
                            var r = d(e).eq(0);
                            (n = d("<div>").hide().insertBefore(r)),
                                J.one(Z, function () {
                                    n.replaceWith(r);
                                }),
                                i(r);
                        } else
                            E.get("iframe")
                                ? i(" ")
                                : E.get("html")
                                    ? i(E.get("html"))
                                    : ge(E, e)
                                        ? ((e = ve(E, e)),
                                            (H = E.get("createImg")),
                                            d(H)
                                                .addClass(U + "Photo")
                                                .bind("error." + U, function () {
                                                    i(de(ee, "Error").html(E.get("imgError")));
                                                })
                                                .one("load", function () {
                                                    o === te &&
                                                        setTimeout(function () {
                                                            var e;
                                                            E.get("retinaImage") &&
                                                                1 < c.devicePixelRatio &&
                                                                ((H.height = H.height / c.devicePixelRatio), (H.width = H.width / c.devicePixelRatio)),
                                                                E.get("scalePhotos") &&
                                                                ((t = function () {
                                                                    (H.height -= H.height * e), (H.width -= H.width * e);
                                                                }),
                                                                    E.mw && H.width > E.mw && ((e = (H.width - E.mw) / H.width), t()),
                                                                    E.mh && H.height > E.mh && ((e = (H.height - E.mh) / H.height), t())),
                                                                E.h && (H.style.marginTop = Math.max(E.mh - H.height, 0) / 2 + "px"),
                                                                b[1] &&
                                                                (E.get("loop") || b[O + 1]) &&
                                                                ((H.style.cursor = "pointer"),
                                                                    d(H).bind("click." + U, function () {
                                                                        I.next();
                                                                    })),
                                                                (H.style.width = H.width + "px"),
                                                                (H.style.height = H.height + "px"),
                                                                i(H);
                                                        }, 1);
                                                }),
                                            (H.src = e))
                                        : e &&
                                        T.load(e, E.get("data"), function (e, t) {
                                            o === te && i("error" === t ? de(ee, "Error").html(E.get("xhrError")) : d(this).contents());
                                        });
                    })();
            }
        }
        function xe() {
            p ||
                ((o = !1),
                    (w = d(c)),
                    (p = de(ee)
                        .attr({ id: B, class: !1 === d.support.opacity ? U + "IE" : "", role: "dialog", tabindex: "-1" })
                        .hide()),
                    (u = de(ee, "Overlay").hide()),
                    (k = d([de(ee, "LoadingOverlay")[0], de(ee, "LoadingGraphic")[0]])),
                    (f = de(ee, "Wrapper")),
                    (h = de(ee, "Content").append(
                        (S = de(ee, "Title")),
                        (r = de(ee, "Current")),
                        (a = d('<button type="button" aria-label="' + theme.strings.previous + '"/>').attr({ id: U + "Previous" })),
                        (s = d('<button type="button" aria-label="' + theme.strings.next + '"/>').attr({ id: U + "Next" })),
                        (i = d('<button type="button" aria-label="' + theme.strings.slideshow + '"/>').attr({ id: U + "Slideshow" })),
                        k
                    )),
                    (C = d('<button type="button" aria-label="' + theme.strings.close + '"/>').attr({ id: U + "Close" })),
                    f
                        .append(
                            de(ee).append(de(ee, "TopLeft"), (g = de(ee, "TopCenter")), de(ee, "TopRight")),
                            de(ee, !1, "clear:left").append((v = de(ee, "MiddleLeft")), h, (m = de(ee, "MiddleRight"))),
                            de(ee, !1, "clear:left").append(de(ee, "BottomLeft"), (y = de(ee, "BottomCenter")), de(ee, "BottomRight"))
                        )
                        .find("div div")
                        .css({ cssFloat: "left" }),
                    (T = de(ee, !1, "position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;")),
                    ($ = s.add(a).add(r).add(i))),
                l.body && !p.parent().length && d(l.body).append(u, p.append(f, T));
        }
        function Te() {
            clearTimeout(W);
        }
        function ke() {
            (E.get("loop") || b[O + 1]) && (Te(), (W = setTimeout(I.next, E.get("slideshowSpeed"))));
        }
        function Se() {
            i.html(E.get("slideshowStop")).unbind(F).one(F, Ce),
                J.bind(Q, ke).bind(V, Te),
                p.removeClass(R + "off").addClass(R + "on");
        }
        function Ce() {
            Te(),
                J.unbind(Q, ke).unbind(V, Te),
                i
                    .html(E.get("slideshowStart"))
                    .unbind(F)
                    .one(F, function () {
                        I.next(), Se();
                    }),
                p.removeClass(R + "on").addClass(R + "off");
        }
        function $e() {
            (z = !1), i.hide(), Te(), J.unbind(Q, ke).unbind(V, Te), p.removeClass(R + "off " + R + "on");
        }
        (function () {
            function e() { }
            function r(e, t) {
                for (var n = e.length; n--;) if (e[n].listener === t) return n;
                return -1;
            }
            function t(e) {
                return function () {
                    return this[e].apply(this, arguments);
                };
            }
            var n = e.prototype,
                i = this,
                o = i.EventEmitter;
            (n.getListeners = function (e) {
                var t,
                    n,
                    i = this._getEvents();
                if ("object" == _typeof(e)) for (n in ((t = {}), i)) i.hasOwnProperty(n) && e.test(n) && (t[n] = i[n]);
                else t = i[e] || (i[e] = []);
                return t;
            }),
                (n.flattenListeners = function (e) {
                    var t,
                        n = [];
                    for (t = 0; e.length > t; t += 1) n.push(e[t].listener);
                    return n;
                }),
                (n.getListenersAsObject = function (e) {
                    var t,
                        n = this.getListeners(e);
                    return n instanceof Array && ((t = {})[e] = n), t || n;
                }),
                (n.addListener = function (e, t) {
                    var n,
                        i = this.getListenersAsObject(e),
                        o = "object" == _typeof(t);
                    for (n in i) i.hasOwnProperty(n) && -1 === r(i[n], t) && i[n].push(o ? t : { listener: t, once: !1 });
                    return this;
                }),
                (n.on = t("addListener")),
                (n.addOnceListener = function (e, t) {
                    return this.addListener(e, { listener: t, once: !0 });
                }),
                (n.once = t("addOnceListener")),
                (n.defineEvent = function (e) {
                    return this.getListeners(e), this;
                }),
                (n.defineEvents = function (e) {
                    for (var t = 0; e.length > t; t += 1) this.defineEvent(e[t]);
                    return this;
                }),
                (n.removeListener = function (e, t) {
                    var n,
                        i,
                        o = this.getListenersAsObject(e);
                    for (i in o) o.hasOwnProperty(i) && -1 !== (n = r(o[i], t)) && o[i].splice(n, 1);
                    return this;
                }),
                (n.off = t("removeListener")),
                (n.addListeners = function (e, t) {
                    return this.manipulateListeners(!1, e, t);
                }),
                (n.removeListeners = function (e, t) {
                    return this.manipulateListeners(!0, e, t);
                }),
                (n.manipulateListeners = function (e, t, n) {
                    var i,
                        o,
                        r = e ? this.removeListener : this.addListener,
                        s = e ? this.removeListeners : this.addListeners;
                    if ("object" != _typeof(t) || t instanceof RegExp) for (i = n.length; i--;) r.call(this, t, n[i]);
                    else
                        for (i in t)
                            t.hasOwnProperty(i) && (o = t[i]) && ("function" == typeof o ? r.call(this, i, o) : s.call(this, i, o));
                    return this;
                }),
                (n.removeEvent = function (e) {
                    var t,
                        n = _typeof(e),
                        i = this._getEvents();
                    if ("string" === n) delete i[e];
                    else if ("object" === n) for (t in i) i.hasOwnProperty(t) && e.test(t) && delete i[t];
                    else delete this._events;
                    return this;
                }),
                (n.removeAllListeners = t("removeEvent")),
                (n.emitEvent = function (e, t) {
                    var n,
                        i,
                        o,
                        r = this.getListenersAsObject(e);
                    for (o in r)
                        if (r.hasOwnProperty(o))
                            for (i = r[o].length; i--;)
                                !0 === (n = r[o][i]).once && this.removeListener(e, n.listener),
                                    n.listener.apply(this, t || []) === this._getOnceReturnValue() && this.removeListener(e, n.listener);
                    return this;
                }),
                (n.trigger = t("emitEvent")),
                (n.emit = function (e) {
                    var t = Array.prototype.slice.call(arguments, 1);
                    return this.emitEvent(e, t);
                }),
                (n.setOnceReturnValue = function (e) {
                    return (this._onceReturnValue = e), this;
                }),
                (n._getOnceReturnValue = function () {
                    return !this.hasOwnProperty("_onceReturnValue") || this._onceReturnValue;
                }),
                (n._getEvents = function () {
                    return this._events || (this._events = {});
                }),
                (e.noConflict = function () {
                    return (i.EventEmitter = o), e;
                }),
                "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports
                    ? (module.exports = e)
                    : (this.EventEmitter = e);
        }.call(this),
            (function (n) {
                function i(e) {
                    var t = n.event;
                    return (t.target = t.target || t.srcElement || e), t;
                }
                var e = document.documentElement,
                    t = function () { };
                e.addEventListener
                    ? (t = function (e, t, n) {
                        e.addEventListener(t, n, !1);
                    })
                    : e.attachEvent &&
                    (t = function (t, e, n) {
                        (t[e + n] = n.handleEvent
                            ? function () {
                                var e = i(t);
                                n.handleEvent.call(n, e);
                            }
                            : function () {
                                var e = i(t);
                                n.call(t, e);
                            }),
                            t.attachEvent("on" + e, t[e + n]);
                    });
                var o = function () { };
                e.removeEventListener
                    ? (o = function (e, t, n) {
                        e.removeEventListener(t, n, !1);
                    })
                    : e.detachEvent &&
                    (o = function (t, n, i) {
                        t.detachEvent("on" + n, t[n + i]);
                        try {
                            delete t[n + i];
                        } catch (e) {
                            t[n + i] = void 0;
                        }
                    });
                var r = { bind: t, unbind: o };
                n.eventie = r;
            })(this),
            (t = window),
            (n = function (e, t, n) {
                function o(e, t) {
                    for (var n in t) e[n] = t[n];
                    return e;
                }
                function r(e) {
                    var t,
                        n = [];
                    if (((t = e), "[object Array]" === u.call(t))) n = e;
                    else if ("number" == typeof e.length) for (var i = 0, o = e.length; i < o; i++) n.push(e[i]);
                    else n.push(e);
                    return n;
                }
                function s(e, t, n) {
                    if (!(this instanceof s)) return new s(e, t);
                    "string" == typeof e && (e = document.querySelectorAll(e)),
                        (this.elements = r(e)),
                        (this.options = o({}, this.options)),
                        "function" == typeof t ? (n = t) : o(this.options, t),
                        n && this.on("always", n),
                        this.getImages(),
                        l && (this.jqDeferred = new l.Deferred());
                    var i = this;
                    setTimeout(function () {
                        i.check();
                    });
                }
                function i(e) {
                    this.img = e;
                }
                function a(e) {
                    (this.src = e), (p[e] = this);
                }
                var l = e.jQuery,
                    c = e.console,
                    d = void 0 !== c,
                    u = Object.prototype.toString;
                ((s.prototype = new t()).options = {}),
                    (s.prototype.getImages = function () {
                        this.images = [];
                        for (var e = 0, t = this.elements.length; e < t; e++) {
                            var n = this.elements[e];
                            "IMG" === n.nodeName && this.addImage(n);
                            var i = n.nodeType;
                            if (i && (1 === i || 9 === i || 11 === i))
                                for (var o = n.querySelectorAll("img"), r = 0, s = o.length; r < s; r++) {
                                    var a = o[r];
                                    this.addImage(a);
                                }
                        }
                    }),
                    (s.prototype.addImage = function (e) {
                        var t = new i(e);
                        this.images.push(t);
                    }),
                    (s.prototype.check = function () {
                        function e(e, t) {
                            return n.options.debug && d && c.log("confirm", e, t), n.progress(e), ++i === o && n.complete(), !0;
                        }
                        var n = this,
                            i = 0,
                            o = this.images.length;
                        if (((this.hasAnyBroken = !1), o))
                            for (var t = 0; t < o; t++) {
                                var r = this.images[t];
                                r.on("confirm", e), r.check();
                            }
                        else this.complete();
                    }),
                    (s.prototype.progress = function (e) {
                        this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded;
                        var t = this;
                        setTimeout(function () {
                            t.emit("progress", t, e), t.jqDeferred && t.jqDeferred.notify && t.jqDeferred.notify(t, e);
                        });
                    }),
                    (s.prototype.complete = function () {
                        var t = this.hasAnyBroken ? "fail" : "done";
                        this.isComplete = !0;
                        var n = this;
                        setTimeout(function () {
                            if ((n.emit(t, n), n.emit("always", n), n.jqDeferred)) {
                                var e = n.hasAnyBroken ? "reject" : "resolve";
                                n.jqDeferred[e](n);
                            }
                        });
                    }),
                    l &&
                    (l.fn.imagesLoaded = function (e, t) {
                        return new s(this, e, t).jqDeferred.promise(l(this));
                    }),
                    ((i.prototype = new t()).check = function () {
                        var e = p[this.img.src] || new a(this.img.src);
                        if (e.isConfirmed) this.confirm(e.isLoaded, "cached was confirmed");
                        else if (this.img.complete && void 0 !== this.img.naturalWidth)
                            this.confirm(0 !== this.img.naturalWidth, "naturalWidth");
                        else {
                            var n = this;
                            e.on("confirm", function (e, t) {
                                return n.confirm(e.isLoaded, t), !0;
                            }),
                                e.check();
                        }
                    }),
                    (i.prototype.confirm = function (e, t) {
                        (this.isLoaded = e), this.emit("confirm", this, t);
                    });
                var p = {};
                return (
                    ((a.prototype = new t()).check = function () {
                        if (!this.isChecked) {
                            var e = new Image();
                            n.bind(e, "load", this), n.bind(e, "error", this), (e.src = this.src), (this.isChecked = !0);
                        }
                    }),
                    (a.prototype.handleEvent = function (e) {
                        var t = "on" + e.type;
                        this[t] && this[t](e);
                    }),
                    (a.prototype.onload = function (e) {
                        this.confirm(!0, "onload"), this.unbindProxyEvents(e);
                    }),
                    (a.prototype.onerror = function (e) {
                        this.confirm(!1, "onerror"), this.unbindProxyEvents(e);
                    }),
                    (a.prototype.confirm = function (e, t) {
                        (this.isConfirmed = !0), (this.isLoaded = e), this.emit("confirm", this, t);
                    }),
                    (a.prototype.unbindProxyEvents = function (e) {
                        n.unbind(e.target, "load", this), n.unbind(e.target, "error", this);
                    }),
                    s
                );
            }),
            "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports))
                ? (module.exports = n(t, require("wolfy87-eventemitter"), require("eventie")))
                : (t.imagesLoaded = n(t, t.EventEmitter, t.eventie)),
            (function (e) {
                "use strict";
                "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
            })(function (c) {
                "use strict";
                var o,
                    s = window.Slick || {};
                (o = 0),
                    ((s = function (e, t) {
                        var n,
                            i = this;
                        (i.defaults = {
                            accessibility: !0,
                            adaptiveHeight: !1,
                            appendArrows: c(e),
                            appendDots: c(e),
                            arrows: !0,
                            asNavFor: null,
                            prevArrow:
                                '<button type="button" data-role="none" class="slick-prev" aria-label="' +
                                theme.strings.previous +
                                '" tabindex="0" role="button">' +
                                theme.strings.previous +
                                "</button>",
                            nextArrow:
                                '<button type="button" data-role="none" class="slick-next" aria-label="' +
                                theme.strings.next +
                                '" tabindex="0" role="button">' +
                                theme.strings.next +
                                "</button>",
                            autoplay: !1,
                            autoplaySpeed: 3e3,
                            centerMode: !1,
                            centerPadding: "50px",
                            cssEase: "ease",
                            customPaging: function (e, t) {
                                return c('<button type="button" data-role="none" role="button" tabindex="0" />').text(t + 1);
                            },
                            dots: !1,
                            dotsClass: "slick-dots",
                            draggable: !0,
                            easing: "linear",
                            edgeFriction: 0.35,
                            fade: !1,
                            focusOnSelect: !1,
                            infinite: !0,
                            initialSlide: 0,
                            lazyLoad: "ondemand",
                            mobileFirst: !1,
                            pauseOnHover: !0,
                            pauseOnFocus: !0,
                            pauseOnDotsHover: !1,
                            respondTo: "window",
                            responsive: null,
                            rows: 1,
                            rtl: !1,
                            slide: "",
                            slidesPerRow: 1,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 500,
                            swipe: !0,
                            swipeToSlide: !1,
                            touchMove: !0,
                            touchThreshold: 5,
                            useCSS: !0,
                            useTransform: !0,
                            variableWidth: !1,
                            vertical: !1,
                            verticalSwiping: !1,
                            waitForAnimate: !0,
                            zIndex: 1e3,
                        }),
                            (i.initials = {
                                animating: !1,
                                dragging: !1,
                                autoPlayTimer: null,
                                currentDirection: 0,
                                currentLeft: null,
                                currentSlide: 0,
                                direction: 1,
                                $dots: null,
                                listWidth: null,
                                listHeight: null,
                                loadIndex: 0,
                                $nextArrow: null,
                                $prevArrow: null,
                                slideCount: null,
                                slideWidth: null,
                                $slideTrack: null,
                                $slides: null,
                                sliding: !1,
                                slideOffset: 0,
                                swipeLeft: null,
                                $list: null,
                                touchObject: {},
                                transformsEnabled: !1,
                                unslicked: !1,
                            }),
                            c.extend(i, i.initials),
                            (i.activeBreakpoint = null),
                            (i.animType = null),
                            (i.animProp = null),
                            (i.breakpoints = []),
                            (i.breakpointSettings = []),
                            (i.cssTransitions = !1),
                            (i.focussed = !1),
                            (i.interrupted = !1),
                            (i.hidden = "hidden"),
                            (i.paused = !0),
                            (i.positionProp = null),
                            (i.respondTo = null),
                            (i.rowCount = 1),
                            (i.shouldClick = !0),
                            (i.$slider = c(e)),
                            (i.$slidesCache = null),
                            (i.transformType = null),
                            (i.transitionType = null),
                            (i.visibilityChange = "visibilitychange"),
                            (i.windowWidth = 0),
                            (i.windowTimer = null),
                            (n = c(e).data("slick") || {}),
                            (i.options = c.extend({}, i.defaults, t, n)),
                            (i.currentSlide = i.options.initialSlide),
                            (i.originalSettings = i.options),
                            void 0 !== document.mozHidden
                                ? ((i.hidden = "mozHidden"), (i.visibilityChange = "mozvisibilitychange"))
                                : void 0 !== document.webkitHidden &&
                                ((i.hidden = "webkitHidden"), (i.visibilityChange = "webkitvisibilitychange")),
                            (i.autoPlay = c.proxy(i.autoPlay, i)),
                            (i.autoPlayClear = c.proxy(i.autoPlayClear, i)),
                            (i.autoPlayIterator = c.proxy(i.autoPlayIterator, i)),
                            (i.changeSlide = c.proxy(i.changeSlide, i)),
                            (i.clickHandler = c.proxy(i.clickHandler, i)),
                            (i.selectHandler = c.proxy(i.selectHandler, i)),
                            (i.setPosition = c.proxy(i.setPosition, i)),
                            (i.swipeHandler = c.proxy(i.swipeHandler, i)),
                            (i.dragHandler = c.proxy(i.dragHandler, i)),
                            (i.keyHandler = c.proxy(i.keyHandler, i)),
                            (i.instanceUid = o++),
                            (i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                            i.registerBreakpoints(),
                            i.init(!0);
                    }).prototype.activateADA = function () {
                        this.$slideTrack
                            .find(".slick-active")
                            .attr({ "aria-hidden": "false" })
                            .find("a, input, button, select")
                            .attr({ tabindex: "0" });
                    }),
                    (s.prototype.addSlide = s.prototype.slickAdd =
                        function (e, t, n) {
                            var i = this;
                            if ("boolean" == typeof t) (n = t), (t = null);
                            else if (t < 0 || t >= i.slideCount) return !1;
                            i.unload(),
                                "number" == typeof t
                                    ? 0 === t && 0 === i.$slides.length
                                        ? c(e).appendTo(i.$slideTrack)
                                        : n
                                            ? c(e).insertBefore(i.$slides.eq(t))
                                            : c(e).insertAfter(i.$slides.eq(t))
                                    : !0 === n
                                        ? c(e).prependTo(i.$slideTrack)
                                        : c(e).appendTo(i.$slideTrack),
                                (i.$slides = i.$slideTrack.children(this.options.slide)),
                                i.$slideTrack.children(this.options.slide).detach(),
                                i.$slideTrack.append(i.$slides),
                                i.$slides.each(function (e, t) {
                                    c(t).attr("data-slick-index", e);
                                }),
                                (i.$slidesCache = i.$slides),
                                i.reinit();
                        }),
                    (s.prototype.animateHeight = function () {
                        var e = this;
                        if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                            e.$list.animate({ height: t }, e.options.speed);
                        }
                    }),
                    (s.prototype.animateSlide = function (e, t) {
                        var n = {},
                            i = this;
                        i.animateHeight(),
                            !0 === i.options.rtl && !1 === i.options.vertical && (e = -e),
                            !1 === i.transformsEnabled
                                ? !1 === i.options.vertical
                                    ? i.$slideTrack.animate({ left: e }, i.options.speed, i.options.easing, t)
                                    : i.$slideTrack.animate({ top: e }, i.options.speed, i.options.easing, t)
                                : !1 === i.cssTransitions
                                    ? (!0 === i.options.rtl && (i.currentLeft = -i.currentLeft),
                                        c({ animStart: i.currentLeft }).animate(
                                            { animStart: e },
                                            {
                                                duration: i.options.speed,
                                                easing: i.options.easing,
                                                step: function (e) {
                                                    (e = Math.ceil(e)),
                                                        !1 === i.options.vertical
                                                            ? (n[i.animType] = "translate(" + e + "px, 0px)")
                                                            : (n[i.animType] = "translate(0px," + e + "px)"),
                                                        i.$slideTrack.css(n);
                                                },
                                                complete: function () {
                                                    t && t.call();
                                                },
                                            }
                                        ))
                                    : (i.applyTransition(),
                                        (e = Math.ceil(e)),
                                        !1 === i.options.vertical
                                            ? (n[i.animType] = "translate3d(" + e + "px, 0px, 0px)")
                                            : (n[i.animType] = "translate3d(0px," + e + "px, 0px)"),
                                        i.$slideTrack.css(n),
                                        t &&
                                        setTimeout(function () {
                                            i.disableTransition(), t.call();
                                        }, i.options.speed));
                    }),
                    (s.prototype.getNavTarget = function () {
                        var e = this.options.asNavFor;
                        return e && null !== e && (e = c(e).not(this.$slider)), e;
                    }),
                    (s.prototype.asNavFor = function (t) {
                        var e = this.getNavTarget();
                        null !== e &&
                            "object" == _typeof(e) &&
                            e.each(function () {
                                var e = c(this).slick("getSlick");
                                e.unslicked || e.slideHandler(t, !0);
                            });
                    }),
                    (s.prototype.applyTransition = function (e) {
                        var t = this,
                            n = {};
                        !1 === t.options.fade
                            ? (n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase)
                            : (n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
                            !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
                    }),
                    (s.prototype.autoPlay = function () {
                        var e = this;
                        e.autoPlayClear(),
                            e.slideCount > e.options.slidesToShow &&
                            (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
                    }),
                    (s.prototype.autoPlayClear = function () {
                        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
                    }),
                    (s.prototype.autoPlayIterator = function () {
                        var e = this,
                            t = e.currentSlide + e.options.slidesToScroll;
                        e.paused ||
                            e.interrupted ||
                            e.focussed ||
                            (!1 === e.options.infinite &&
                                (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
                                    ? (e.direction = 0)
                                    : 0 === e.direction &&
                                    ((t = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 == 0 && (e.direction = 1))),
                                e.slideHandler(t));
                    }),
                    (s.prototype.buildArrows = function () {
                        var e = this;
                        !0 === e.options.arrows &&
                            ((e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow")),
                                (e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow")),
                                e.slideCount > e.options.slidesToShow
                                    ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                        e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                                        e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
                                        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
                                        !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                                    : e.$prevArrow
                                        .add(e.$nextArrow)
                                        .addClass("slick-hidden")
                                        .attr({ "aria-disabled": "true", tabindex: "-1" }));
                    }),
                    (s.prototype.buildDots = function () {
                        var e,
                            t,
                            n = this;
                        if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
                            for (
                                n.$slider.addClass("slick-dotted"), t = c("<ul />").addClass(n.options.dotsClass), e = 0;
                                e <= n.getDotCount();
                                e += 1
                            )
                                t.append(c("<li />").append(n.options.customPaging.call(this, n, e)));
                            (n.$dots = t.appendTo(n.options.appendDots)),
                                n.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
                        }
                    }),
                    (s.prototype.buildOut = function () {
                        var e = this;
                        (e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                            (e.slideCount = e.$slides.length),
                            e.$slides.each(function (e, t) {
                                c(t)
                                    .attr("data-slick-index", e)
                                    .data("originalStyling", c(t).attr("style") || "");
                            }),
                            e.$slider.addClass("slick-slider"),
                            (e.$slideTrack =
                                0 === e.slideCount
                                    ? c(
                                        '<div class="slick-track" aria-label="'.concat(
                                            theme.strings.imageSlider ? theme.strings.imageSlider : "",
                                            '"/>'
                                        )
                                    ).appendTo(e.$slider)
                                    : e.$slides
                                        .wrapAll(
                                            '<div class="slick-track" aria-label="'.concat(
                                                theme.strings.imageSlider ? theme.strings.imageSlider : "",
                                                '"/>'
                                            )
                                        )
                                        .parent()),
                            (e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
                            e.$slideTrack.css("opacity", 0),
                            (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) || (e.options.slidesToScroll = 1),
                            c("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
                            e.setupInfinite(),
                            e.buildArrows(),
                            e.buildDots(),
                            e.updateDots(),
                            e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                            !0 === e.options.draggable && e.$list.addClass("draggable");
                    }),
                    (s.prototype.buildRows = function () {
                        var e,
                            t,
                            n,
                            i,
                            o,
                            r,
                            s,
                            a = this;
                        if (((i = document.createDocumentFragment()), (r = a.$slider.children()), 1 < a.options.rows)) {
                            for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
                                var l = document.createElement("div");
                                for (t = 0; t < a.options.rows; t++) {
                                    var c = document.createElement("div");
                                    for (n = 0; n < a.options.slidesPerRow; n++) {
                                        var d = e * s + (t * a.options.slidesPerRow + n);
                                        r.get(d) && c.appendChild(r.get(d));
                                    }
                                    l.appendChild(c);
                                }
                                i.appendChild(l);
                            }
                            a.$slider.empty().append(i),
                                a.$slider
                                    .children()
                                    .children()
                                    .children()
                                    .css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
                        }
                    }),
                    (s.prototype.checkResponsive = function (e, t) {
                        var n,
                            i,
                            o,
                            r = this,
                            s = !1,
                            a = r.$slider.width(),
                            l = window.innerWidth || c(window).width();
                        if (
                            ("window" === r.respondTo
                                ? (o = l)
                                : "slider" === r.respondTo
                                    ? (o = a)
                                    : "min" === r.respondTo && (o = Math.min(l, a)),
                                r.options.responsive && r.options.responsive.length && null !== r.options.responsive)
                        ) {
                            for (n in ((i = null), r.breakpoints))
                                r.breakpoints.hasOwnProperty(n) &&
                                    (!1 === r.originalSettings.mobileFirst
                                        ? o < r.breakpoints[n] && (i = r.breakpoints[n])
                                        : o > r.breakpoints[n] && (i = r.breakpoints[n]));
                            null !== i
                                ? (null !== r.activeBreakpoint && i === r.activeBreakpoint && !t) ||
                                ((r.activeBreakpoint = i),
                                    "unslick" === r.breakpointSettings[i]
                                        ? r.unslick(i)
                                        : ((r.options = c.extend({}, r.originalSettings, r.breakpointSettings[i])),
                                            !0 === e && (r.currentSlide = r.options.initialSlide),
                                            r.refresh(e)),
                                    (s = i))
                                : null !== r.activeBreakpoint &&
                                ((r.activeBreakpoint = null),
                                    (r.options = r.originalSettings),
                                    !0 === e && (r.currentSlide = r.options.initialSlide),
                                    r.refresh(e),
                                    (s = i)),
                                e || !1 === s || r.$slider.trigger("breakpoint", [r, s]);
                        }
                    }),
                    (s.prototype.changeSlide = function (e, t) {
                        var n,
                            i,
                            o = this,
                            r = c(e.currentTarget);
                        switch (
                        (r.is("a") && e.preventDefault(),
                            r.is("li") || (r = r.closest("li")),
                            (n =
                                o.slideCount % o.options.slidesToScroll != 0
                                    ? 0
                                    : (o.slideCount - o.currentSlide) % o.options.slidesToScroll),
                            e.data.message)
                        ) {
                            case "previous":
                                (i = 0 == n ? o.options.slidesToScroll : o.options.slidesToShow - n),
                                    o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - i, !1, t);
                                break;
                            case "next":
                                (i = 0 == n ? o.options.slidesToScroll : n),
                                    o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + i, !1, t);
                                break;
                            case "index":
                                var s = 0 === e.data.index ? 0 : e.data.index || r.index() * o.options.slidesToScroll;
                                o.slideHandler(o.checkNavigable(s), !1, t), r.children().trigger("focus");
                                break;
                            default:
                                return;
                        }
                    }),
                    (s.prototype.checkNavigable = function (e) {
                        var t, n;
                        if (((n = 0), e > (t = this.getNavigableIndexes())[t.length - 1])) e = t[t.length - 1];
                        else
                            for (var i in t) {
                                if (e < t[i]) {
                                    e = n;
                                    break;
                                }
                                n = t[i];
                            }
                        return e;
                    }),
                    (s.prototype.cleanUpEvents = function () {
                        var e = this;
                        e.options.dots &&
                            null !== e.$dots &&
                            c("li", e.$dots)
                                .off("click.slick", e.changeSlide)
                                .off("mouseenter.slick", c.proxy(e.interrupt, e, !0))
                                .off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
                            e.$slider.off("focus.slick blur.slick"),
                            !0 === e.options.arrows &&
                            e.slideCount > e.options.slidesToShow &&
                            (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
                                e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
                            e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                            e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                            e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                            e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                            e.$list.off("click.slick", e.clickHandler),
                            c(document).off(e.visibilityChange, e.visibility),
                            e.cleanUpSlideEvents(),
                            !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
                            !0 === e.options.focusOnSelect && c(e.$slideTrack).children().off("click.slick", e.selectHandler),
                            c(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
                            c(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                            c("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
                            c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
                            c(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
                    }),
                    (s.prototype.cleanUpSlideEvents = function () {
                        var e = this;
                        e.$list.off("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
                            e.$list.off("mouseleave.slick", c.proxy(e.interrupt, e, !1));
                    }),
                    (s.prototype.cleanUpRows = function () {
                        var e;
                        1 < this.options.rows &&
                            ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e));
                    }),
                    (s.prototype.clickHandler = function (e) {
                        !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
                    }),
                    (s.prototype.destroy = function (e) {
                        var t = this;
                        t.autoPlayClear(),
                            (t.touchObject = {}),
                            t.cleanUpEvents(),
                            c(".slick-cloned", t.$slider).detach(),
                            t.$dots && t.$dots.remove(),
                            t.$prevArrow &&
                            t.$prevArrow.length &&
                            (t.$prevArrow
                                .removeClass("slick-disabled slick-arrow slick-hidden")
                                .removeAttr("aria-hidden aria-disabled tabindex")
                                .css("display", ""),
                                t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
                            t.$nextArrow &&
                            t.$nextArrow.length &&
                            (t.$nextArrow
                                .removeClass("slick-disabled slick-arrow slick-hidden")
                                .removeAttr("aria-hidden aria-disabled tabindex")
                                .css("display", ""),
                                t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
                            t.$slides &&
                            (t.$slides
                                .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                                .removeAttr("aria-hidden")
                                .removeAttr("data-slick-index")
                                .each(function () {
                                    c(this).attr("style", c(this).data("originalStyling"));
                                }),
                                t.$slideTrack.children(this.options.slide).detach(),
                                t.$slideTrack.detach(),
                                t.$list.detach(),
                                t.$slider.append(t.$slides)),
                            t.cleanUpRows(),
                            t.$slider.removeClass("slick-slider"),
                            t.$slider.removeClass("slick-initialized"),
                            t.$slider.removeClass("slick-dotted"),
                            (t.unslicked = !0),
                            e || t.$slider.trigger("destroy", [t]);
                    }),
                    (s.prototype.disableTransition = function (e) {
                        var t = {};
                        (t[this.transitionType] = ""),
                            !1 === this.options.fade ? this.$slideTrack.css(t) : this.$slides.eq(e).css(t);
                    }),
                    (s.prototype.fadeSlide = function (e, t) {
                        var n = this;
                        !1 === n.cssTransitions
                            ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }),
                                n.$slides.eq(e).animate({ opacity: 1 }, n.options.speed, n.options.easing, t))
                            : (n.applyTransition(e),
                                n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
                                t &&
                                setTimeout(function () {
                                    n.disableTransition(e), t.call();
                                }, n.options.speed));
                    }),
                    (s.prototype.fadeSlideOut = function (e) {
                        var t = this;
                        !1 === t.cssTransitions
                            ? t.$slides.eq(e).animate({ opacity: 0, zIndex: t.options.zIndex - 2 }, t.options.speed, t.options.easing)
                            : (t.applyTransition(e), t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
                    }),
                    (s.prototype.filterSlides = s.prototype.slickFilter =
                        function (e) {
                            var t = this;
                            null !== e &&
                                ((t.$slidesCache = t.$slides),
                                    t.unload(),
                                    t.$slideTrack.children(this.options.slide).detach(),
                                    t.$slidesCache.filter(e).appendTo(t.$slideTrack),
                                    t.reinit());
                        }),
                    (s.prototype.focusHandler = function () {
                        var n = this;
                        n.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (e) {
                            var t = c(this);
                            setTimeout(function () {
                                n.options.pauseOnFocus && ((n.focussed = t.is(":focus")), n.autoPlay());
                            }, 0);
                        });
                    }),
                    (s.prototype.getCurrent = s.prototype.slickCurrentSlide =
                        function () {
                            return this.currentSlide;
                        }),
                    (s.prototype.getDotCount = function () {
                        var e = this,
                            t = 0,
                            n = 0,
                            i = 0;
                        if (!0 === e.options.infinite)
                            for (; t < e.slideCount;)
                                ++i,
                                    (t = n + e.options.slidesToScroll),
                                    (n +=
                                        e.options.slidesToScroll <= e.options.slidesToShow
                                            ? e.options.slidesToScroll
                                            : e.options.slidesToShow);
                        else if (!0 === e.options.centerMode) i = e.slideCount;
                        else if (e.options.asNavFor)
                            for (; t < e.slideCount;)
                                ++i,
                                    (t = n + e.options.slidesToScroll),
                                    (n +=
                                        e.options.slidesToScroll <= e.options.slidesToShow
                                            ? e.options.slidesToScroll
                                            : e.options.slidesToShow);
                        else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                        return i - 1;
                    }),
                    (s.prototype.getLeft = function (e) {
                        var t,
                            n,
                            i,
                            o = this,
                            r = 0;
                        return (
                            (o.slideOffset = 0),
                            (n = o.$slides.first().outerHeight(!0)),
                            !0 === o.options.infinite
                                ? (o.slideCount > o.options.slidesToShow &&
                                    ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1),
                                        (r = n * o.options.slidesToShow * -1)),
                                    o.slideCount % o.options.slidesToScroll != 0 &&
                                    e + o.options.slidesToScroll > o.slideCount &&
                                    o.slideCount > o.options.slidesToShow &&
                                    (r =
                                        e > o.slideCount
                                            ? ((o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1),
                                                (o.options.slidesToShow - (e - o.slideCount)) * n * -1)
                                            : ((o.slideOffset = (o.slideCount % o.options.slidesToScroll) * o.slideWidth * -1),
                                                (o.slideCount % o.options.slidesToScroll) * n * -1)))
                                : e + o.options.slidesToShow > o.slideCount &&
                                ((o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth),
                                    (r = (e + o.options.slidesToShow - o.slideCount) * n)),
                            o.slideCount <= o.options.slidesToShow && (r = o.slideOffset = 0),
                            !0 === o.options.centerMode && !0 === o.options.infinite
                                ? (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth)
                                : !0 === o.options.centerMode &&
                                ((o.slideOffset = 0), (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
                            (t = !1 === o.options.vertical ? e * o.slideWidth * -1 + o.slideOffset : e * n * -1 + r),
                            !0 === o.options.variableWidth &&
                            ((i =
                                o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite
                                    ? o.$slideTrack.children(".slick-slide").eq(e)
                                    : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow)),
                                (t =
                                    !0 === o.options.rtl
                                        ? i[0]
                                            ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width())
                                            : 0
                                        : i[0]
                                            ? -1 * i[0].offsetLeft
                                            : 0),
                                !0 === o.options.centerMode &&
                                ((i =
                                    o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite
                                        ? o.$slideTrack.children(".slick-slide").eq(e)
                                        : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1)),
                                    (t =
                                        !0 === o.options.rtl
                                            ? i[0]
                                                ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width())
                                                : 0
                                            : i[0]
                                                ? -1 * i[0].offsetLeft
                                                : 0),
                                    (t += (o.$list.width() - i.outerWidth()) / 2))),
                            t
                        );
                    }),
                    (s.prototype.getOption = s.prototype.slickGetOption =
                        function (e) {
                            return this.options[e];
                        }),
                    (s.prototype.getNavigableIndexes = function () {
                        var e,
                            t = this,
                            n = 0,
                            i = 0,
                            o = [];
                        for (
                            e =
                            !1 === t.options.infinite
                                ? t.slideCount
                                : ((n = -1 * t.options.slidesToScroll), (i = -1 * t.options.slidesToScroll), 2 * t.slideCount);
                            n < e;

                        )
                            o.push(n),
                                (n = i + t.options.slidesToScroll),
                                (i +=
                                    t.options.slidesToScroll <= t.options.slidesToShow
                                        ? t.options.slidesToScroll
                                        : t.options.slidesToShow);
                        return o;
                    }),
                    (s.prototype.getSlick = function () {
                        return this;
                    }),
                    (s.prototype.getSlideCount = function () {
                        var n,
                            i,
                            o = this;
                        return (
                            (i = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0),
                            !0 === o.options.swipeToSlide
                                ? (o.$slideTrack.find(".slick-slide").each(function (e, t) {
                                    return t.offsetLeft - i + c(t).outerWidth() / 2 > -1 * o.swipeLeft ? ((n = t), !1) : void 0;
                                }),
                                    Math.abs(c(n).attr("data-slick-index") - o.currentSlide) || 1)
                                : o.options.slidesToScroll
                        );
                    }),
                    (s.prototype.goTo = s.prototype.slickGoTo =
                        function (e, t) {
                            this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
                        }),
                    (s.prototype.init = function (e) {
                        var t = this;
                        c(t.$slider).hasClass("slick-initialized") ||
                            (c(t.$slider).addClass("slick-initialized"),
                                t.buildRows(),
                                t.buildOut(),
                                t.setProps(),
                                t.startLoad(),
                                t.loadSlider(),
                                t.initializeEvents(),
                                t.updateArrows(),
                                t.updateDots(),
                                t.checkResponsive(!0),
                                t.focusHandler()),
                            e && t.$slider.trigger("init", [t]),
                            !0 === t.options.accessibility && t.initADA(),
                            t.options.autoplay && ((t.paused = !1), t.autoPlay());
                    }),
                    (s.prototype.initADA = function () {
                        var t = this;
                        t.$slides
                            .add(t.$slideTrack.find(".slick-cloned"))
                            .attr({ "aria-hidden": "true", tabindex: "-1" })
                            .find("a, input, button, select")
                            .attr({ tabindex: "-1" }),
                            t.$slideTrack.attr("role", "listbox"),
                            t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (e) {
                                c(this).attr({ role: "option" });
                            }),
                            null !== t.$dots &&
                            t.$dots
                                .attr("aria-hidden", "true")
                                .find("li")
                                .each(function (e) {
                                    c(this).attr({
                                        role: "presentation",
                                        "aria-selected": "false",
                                        "aria-controls": "navigation" + t.instanceUid + e,
                                        id: "slick-slide" + t.instanceUid + e,
                                    });
                                })
                                .first()
                                .attr("aria-selected", "true")
                                .end()
                                .find("button")
                                .attr("role", "button")
                                .end()
                                .closest("div")
                                .attr("role", "toolbar"),
                            t.activateADA();
                    }),
                    (s.prototype.initArrowEvents = function () {
                        var e = this;
                        !0 === e.options.arrows &&
                            e.slideCount > e.options.slidesToShow &&
                            (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide),
                                e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide));
                    }),
                    (s.prototype.initDotEvents = function () {
                        var e = this;
                        !0 === e.options.dots &&
                            e.slideCount > e.options.slidesToShow &&
                            c("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide),
                            !0 === e.options.dots &&
                            !0 === e.options.pauseOnDotsHover &&
                            c("li", e.$dots)
                                .on("mouseenter.slick", c.proxy(e.interrupt, e, !0))
                                .on("mouseleave.slick", c.proxy(e.interrupt, e, !1));
                    }),
                    (s.prototype.initSlideEvents = function () {
                        var e = this;
                        e.options.pauseOnHover &&
                            (e.$list.on("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
                                e.$list.on("mouseleave.slick", c.proxy(e.interrupt, e, !1)));
                    }),
                    (s.prototype.initializeEvents = function () {
                        var e = this;
                        e.initArrowEvents(),
                            e.initDotEvents(),
                            e.initSlideEvents(),
                            e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler),
                            e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler),
                            e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler),
                            e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler),
                            e.$list.on("click.slick", e.clickHandler),
                            c(document).on(e.visibilityChange, c.proxy(e.visibility, e)),
                            !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
                            !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler),
                            c(window).on("orientationchange.slick.slick-" + e.instanceUid, c.proxy(e.orientationChange, e)),
                            c(window).on("resize.slick.slick-" + e.instanceUid, c.proxy(e.resize, e)),
                            c("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
                            c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
                            c(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
                    }),
                    (s.prototype.initUI = function () {
                        var e = this;
                        !0 === e.options.arrows &&
                            e.slideCount > e.options.slidesToShow &&
                            (e.$prevArrow.show(), e.$nextArrow.show()),
                            !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show();
                    }),
                    (s.prototype.keyHandler = function (e) {
                        var t = this;
                        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                            (37 === e.keyCode && !0 === t.options.accessibility
                                ? t.changeSlide({ data: { message: !0 === t.options.rtl ? "next" : "previous" } })
                                : 39 === e.keyCode &&
                                !0 === t.options.accessibility &&
                                t.changeSlide({ data: { message: !0 === t.options.rtl ? "previous" : "next" } }));
                    }),
                    (s.prototype.lazyLoad = function () {
                        function e(e) {
                            c("img[data-lazy]", e).each(function () {
                                var e = c(this),
                                    t = c(this).attr("data-lazy"),
                                    n = document.createElement("img");
                                (n.onload = function () {
                                    e.animate({ opacity: 0 }, 100, function () {
                                        e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                                            e.removeAttr("data-lazy").removeClass("slick-loading");
                                        }),
                                            i.$slider.trigger("lazyLoaded", [i, e, t]);
                                    });
                                }),
                                    (n.onerror = function () {
                                        e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                                            i.$slider.trigger("lazyLoadError", [i, e, t]);
                                    }),
                                    (n.src = t);
                            });
                        }
                        var t,
                            n,
                            i = this;
                        !0 === i.options.centerMode
                            ? (n =
                                !0 === i.options.infinite
                                    ? (t = i.currentSlide + (i.options.slidesToShow / 2 + 1)) + i.options.slidesToShow + 2
                                    : ((t = Math.max(0, i.currentSlide - (i.options.slidesToShow / 2 + 1))),
                                        i.options.slidesToShow / 2 + 1 + 2 + i.currentSlide))
                            : ((t = i.options.infinite ? i.options.slidesToShow + i.currentSlide : i.currentSlide),
                                (n = Math.ceil(t + i.options.slidesToShow)),
                                !0 === i.options.fade && (0 < t && t--, n <= i.slideCount && n++)),
                            e(i.$slider.find(".slick-slide").slice(t, n)),
                            i.slideCount <= i.options.slidesToShow
                                ? e(i.$slider.find(".slick-slide"))
                                : i.currentSlide >= i.slideCount - i.options.slidesToShow
                                    ? e(i.$slider.find(".slick-cloned").slice(0, i.options.slidesToShow))
                                    : 0 === i.currentSlide && e(i.$slider.find(".slick-cloned").slice(-1 * i.options.slidesToShow));
                    }),
                    (s.prototype.loadSlider = function () {
                        var e = this;
                        e.setPosition(),
                            e.$slideTrack.css({ opacity: 1 }),
                            e.$slider.removeClass("slick-loading"),
                            e.initUI(),
                            "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
                    }),
                    (s.prototype.next = s.prototype.slickNext =
                        function () {
                            this.changeSlide({ data: { message: "next" } });
                        }),
                    (s.prototype.orientationChange = function () {
                        this.checkResponsive(), this.setPosition();
                    }),
                    (s.prototype.pause = s.prototype.slickPause =
                        function () {
                            this.autoPlayClear(), (this.paused = !0);
                        }),
                    (s.prototype.play = s.prototype.slickPlay =
                        function () {
                            var e = this;
                            e.autoPlay(), (e.options.autoplay = !0), (e.paused = !1), (e.focussed = !1), (e.interrupted = !1);
                        }),
                    (s.prototype.postSlide = function (e) {
                        var t = this;
                        t.unslicked ||
                            (t.$slider.trigger("afterChange", [t, e]),
                                (t.animating = !1),
                                t.setPosition(),
                                (t.swipeLeft = null),
                                t.options.autoplay && t.autoPlay(),
                                !0 === t.options.accessibility && t.initADA());
                    }),
                    (s.prototype.prev = s.prototype.slickPrev =
                        function () {
                            this.changeSlide({ data: { message: "previous" } });
                        }),
                    (s.prototype.preventDefault = function (e) {
                        e.preventDefault();
                    }),
                    (s.prototype.progressiveLazyLoad = function (e) {
                        e = e || 1;
                        var t,
                            n,
                            i,
                            o = this,
                            r = c("img[data-lazy]", o.$slider);
                        r.length
                            ? ((t = r.first()),
                                (n = t.attr("data-lazy")),
                                ((i = document.createElement("img")).onload = function () {
                                    t.attr("src", n).removeAttr("data-lazy").removeClass("slick-loading"),
                                        !0 === o.options.adaptiveHeight && o.setPosition(),
                                        o.$slider.trigger("lazyLoaded", [o, t, n]),
                                        o.progressiveLazyLoad();
                                }),
                                (i.onerror = function () {
                                    e < 3
                                        ? setTimeout(function () {
                                            o.progressiveLazyLoad(e + 1);
                                        }, 500)
                                        : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                                            o.$slider.trigger("lazyLoadError", [o, t, n]),
                                            o.progressiveLazyLoad());
                                }),
                                (i.src = n))
                            : o.$slider.trigger("allImagesLoaded", [o]);
                    }),
                    (s.prototype.refresh = function (e) {
                        var t,
                            n,
                            i = this;
                        (n = i.slideCount - i.options.slidesToShow),
                            !i.options.infinite && i.currentSlide > n && (i.currentSlide = n),
                            i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
                            (t = i.currentSlide),
                            i.destroy(!0),
                            c.extend(i, i.initials, { currentSlide: t }),
                            i.init(),
                            e || i.changeSlide({ data: { message: "index", index: t } }, !1);
                    }),
                    (s.prototype.registerBreakpoints = function () {
                        var e,
                            t,
                            n,
                            i = this,
                            o = i.options.responsive || null;
                        if ("array" === c.type(o) && o.length) {
                            for (e in ((i.respondTo = i.options.respondTo || "window"), o))
                                if (((n = i.breakpoints.length - 1), (t = o[e].breakpoint), o.hasOwnProperty(e))) {
                                    for (; 0 <= n;) i.breakpoints[n] && i.breakpoints[n] === t && i.breakpoints.splice(n, 1), n--;
                                    i.breakpoints.push(t), (i.breakpointSettings[t] = o[e].settings);
                                }
                            i.breakpoints.sort(function (e, t) {
                                return i.options.mobileFirst ? e - t : t - e;
                            });
                        }
                    }),
                    (s.prototype.reinit = function () {
                        var e = this;
                        (e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide")),
                            (e.slideCount = e.$slides.length),
                            e.currentSlide >= e.slideCount &&
                            0 !== e.currentSlide &&
                            (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
                            e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                            e.registerBreakpoints(),
                            e.setProps(),
                            e.setupInfinite(),
                            e.buildArrows(),
                            e.updateArrows(),
                            e.initArrowEvents(),
                            e.buildDots(),
                            e.updateDots(),
                            e.initDotEvents(),
                            e.cleanUpSlideEvents(),
                            e.initSlideEvents(),
                            e.checkResponsive(!1, !0),
                            !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler),
                            e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                            e.setPosition(),
                            e.focusHandler(),
                            (e.paused = !e.options.autoplay),
                            e.autoPlay(),
                            e.$slider.trigger("reInit", [e]);
                    }),
                    (s.prototype.resize = function () {
                        var e = this;
                        c(window).width() !== e.windowWidth &&
                            (clearTimeout(e.windowDelay),
                                (e.windowDelay = window.setTimeout(function () {
                                    (e.windowWidth = c(window).width()), e.checkResponsive(), e.unslicked || e.setPosition();
                                }, 50)));
                    }),
                    (s.prototype.removeSlide = s.prototype.slickRemove =
                        function (e, t, n) {
                            var i = this;
                            return (
                                (e = "boolean" == typeof e ? (!0 === (t = e) ? 0 : i.slideCount - 1) : !0 === t ? --e : e),
                                !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) &&
                                (i.unload(),
                                    !0 === n
                                        ? i.$slideTrack.children().remove()
                                        : i.$slideTrack.children(this.options.slide).eq(e).remove(),
                                    (i.$slides = i.$slideTrack.children(this.options.slide)),
                                    i.$slideTrack.children(this.options.slide).detach(),
                                    i.$slideTrack.append(i.$slides),
                                    (i.$slidesCache = i.$slides),
                                    void i.reinit())
                            );
                        }),
                    (s.prototype.setCSS = function (e) {
                        var t,
                            n,
                            i = this,
                            o = {};
                        !0 === i.options.rtl && (e = -e),
                            (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                            (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                            (o[i.positionProp] = e),
                            !1 === i.transformsEnabled ||
                            (!(o = {}) === i.cssTransitions
                                ? (o[i.animType] = "translate(" + t + ", " + n + ")")
                                : (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)")),
                            i.$slideTrack.css(o);
                    }),
                    (s.prototype.setDimensions = function () {
                        var e = this;
                        !1 === e.options.vertical
                            ? !0 === e.options.centerMode && e.$list.css({ padding: "0px " + e.options.centerPadding })
                            : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow),
                                !0 === e.options.centerMode && e.$list.css({ padding: e.options.centerPadding + " 0px" })),
                            (e.listWidth = e.$list.width()),
                            (e.listHeight = e.$list.height()),
                            !1 === e.options.vertical && !1 === e.options.variableWidth
                                ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
                                    e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length)))
                                : !0 === e.options.variableWidth
                                    ? e.$slideTrack.width(5e3 * e.slideCount)
                                    : ((e.slideWidth = Math.ceil(e.listWidth)),
                                        e.$slideTrack.height(
                                            Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)
                                        ));
                        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                        !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
                    }),
                    (s.prototype.setFade = function () {
                        var n,
                            i = this;
                        i.$slides.each(function (e, t) {
                            (n = i.slideWidth * e * -1),
                                !0 === i.options.rtl
                                    ? c(t).css({ position: "relative", right: n, top: 0, zIndex: i.options.zIndex - 2, opacity: 0 })
                                    : c(t).css({ position: "relative", left: n, top: 0, zIndex: i.options.zIndex - 2, opacity: 0 });
                        }),
                            i.$slides.eq(i.currentSlide).css({ zIndex: i.options.zIndex - 1, opacity: 1 });
                    }),
                    (s.prototype.setHeight = function () {
                        var e = this;
                        if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                            e.$list.css("height", t);
                        }
                    }),
                    (s.prototype.setOption = s.prototype.slickSetOption =
                        function () {
                            var e,
                                t,
                                n,
                                i,
                                o,
                                r = this,
                                s = !1;
                            if (
                                ("object" === c.type(arguments[0])
                                    ? ((n = arguments[0]), (s = arguments[1]), (o = "multiple"))
                                    : "string" === c.type(arguments[0]) &&
                                    ((i = arguments[1]),
                                        (s = arguments[2]),
                                        "responsive" === (n = arguments[0]) && "array" === c.type(arguments[1])
                                            ? (o = "responsive")
                                            : void 0 !== arguments[1] && (o = "single")),
                                    "single" === o)
                            )
                                r.options[n] = i;
                            else if ("multiple" === o)
                                c.each(n, function (e, t) {
                                    r.options[e] = t;
                                });
                            else if ("responsive" === o)
                                for (t in i)
                                    if ("array" !== c.type(r.options.responsive)) r.options.responsive = [i[t]];
                                    else {
                                        for (e = r.options.responsive.length - 1; 0 <= e;)
                                            r.options.responsive[e].breakpoint === i[t].breakpoint && r.options.responsive.splice(e, 1), e--;
                                        r.options.responsive.push(i[t]);
                                    }
                            s && (r.unload(), r.reinit());
                        }),
                    (s.prototype.setPosition = function () {
                        var e = this;
                        e.setDimensions(),
                            e.setHeight(),
                            !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(),
                            e.$slider.trigger("setPosition", [e]);
                    }),
                    (s.prototype.setProps = function () {
                        var e = this,
                            t = document.body.style;
                        (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
                            "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                            (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) ||
                            !0 !== e.options.useCSS ||
                            (e.cssTransitions = !0),
                            e.options.fade &&
                            ("number" == typeof e.options.zIndex
                                ? e.options.zIndex < 3 && (e.options.zIndex = 3)
                                : (e.options.zIndex = e.defaults.zIndex)),
                            void 0 !== t.OTransform &&
                            ((e.animType = "OTransform"),
                                (e.transformType = "-o-transform"),
                                (e.transitionType = "OTransition"),
                                void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                            void 0 !== t.MozTransform &&
                            ((e.animType = "MozTransform"),
                                (e.transformType = "-moz-transform"),
                                (e.transitionType = "MozTransition"),
                                void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                            void 0 !== t.webkitTransform &&
                            ((e.animType = "webkitTransform"),
                                (e.transformType = "-webkit-transform"),
                                (e.transitionType = "webkitTransition"),
                                void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                            void 0 !== t.msTransform &&
                            ((e.animType = "msTransform"),
                                (e.transformType = "-ms-transform"),
                                (e.transitionType = "msTransition"),
                                void 0 === t.msTransform && (e.animType = !1)),
                            void 0 !== t.transform &&
                            !1 !== e.animType &&
                            ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                            (e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType);
                    }),
                    (s.prototype.setSlideClasses = function (e) {
                        var t,
                            n,
                            i,
                            o,
                            r = this;
                        (n = r.$slider
                            .find(".slick-slide")
                            .removeClass("slick-active slick-center slick-current")
                            .attr("aria-hidden", "true")),
                            r.$slides.eq(e).addClass("slick-current"),
                            !0 === r.options.centerMode
                                ? ((t = Math.floor(r.options.slidesToShow / 2)),
                                    !0 === r.options.infinite &&
                                    (t <= e && e <= r.slideCount - 1 - t
                                        ? r.$slides
                                            .slice(e - t, e + t + 1)
                                            .addClass("slick-active")
                                            .attr("aria-hidden", "false")
                                        : ((i = r.options.slidesToShow + e),
                                            n
                                                .slice(i - t + 1, i + t + 2)
                                                .addClass("slick-active")
                                                .attr("aria-hidden", "false")),
                                        0 === e
                                            ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center")
                                            : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")),
                                    r.$slides.eq(e).addClass("slick-center"))
                                : 0 <= e && e <= r.slideCount - r.options.slidesToShow
                                    ? r.$slides
                                        .slice(e, e + r.options.slidesToShow)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")
                                    : n.length <= r.options.slidesToShow
                                        ? n.addClass("slick-active").attr("aria-hidden", "false")
                                        : ((o = r.slideCount % r.options.slidesToShow),
                                            (i = !0 === r.options.infinite ? r.options.slidesToShow + e : e),
                                            r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow
                                                ? n
                                                    .slice(i - (r.options.slidesToShow - o), i + o)
                                                    .addClass("slick-active")
                                                    .attr("aria-hidden", "false")
                                                : n
                                                    .slice(i, i + r.options.slidesToShow)
                                                    .addClass("slick-active")
                                                    .attr("aria-hidden", "false")),
                            "ondemand" === r.options.lazyLoad && r.lazyLoad();
                    }),
                    (s.prototype.setupInfinite = function () {
                        var e,
                            t,
                            n,
                            i = this;
                        if (
                            (!0 === i.options.fade && (i.options.centerMode = !1),
                                !0 === i.options.infinite && !1 === i.options.fade && ((t = null), i.slideCount > i.options.slidesToShow))
                        ) {
                            for (
                                n = !0 === i.options.centerMode ? i.options.slidesToShow + 1 : i.options.slidesToShow, e = i.slideCount;
                                e > i.slideCount - n;
                                --e
                            )
                                (t = e - 1),
                                    c(i.$slides[t])
                                        .clone(!0)
                                        .attr("id", "")
                                        .attr("data-slick-index", t - i.slideCount)
                                        .prependTo(i.$slideTrack)
                                        .addClass("slick-cloned");
                            for (e = 0; e < n; e += 1)
                                (t = e),
                                    c(i.$slides[t])
                                        .clone(!0)
                                        .attr("id", "")
                                        .attr("data-slick-index", t + i.slideCount)
                                        .appendTo(i.$slideTrack)
                                        .addClass("slick-cloned");
                            i.$slideTrack
                                .find(".slick-cloned")
                                .find("[id]")
                                .each(function () {
                                    c(this).attr("id", "");
                                });
                        }
                    }),
                    (s.prototype.interrupt = function (e) {
                        e || this.autoPlay(), (this.interrupted = e);
                    }),
                    (s.prototype.selectHandler = function (e) {
                        var t = this,
                            n = c(e.target).is(".slick-slide") ? c(e.target) : c(e.target).parents(".slick-slide"),
                            i = parseInt(n.attr("data-slick-index"));
                        return (
                            (i = i || 0),
                            t.slideCount <= t.options.slidesToShow
                                ? (t.setSlideClasses(i), void t.asNavFor(i))
                                : void t.slideHandler(i)
                        );
                    }),
                    (s.prototype.slideHandler = function (e, t, n) {
                        var i,
                            o,
                            r,
                            s,
                            a,
                            l = null,
                            c = this;
                        return (
                            (t = t || !1),
                            (!0 === c.animating && !0 === c.options.waitForAnimate) ||
                                (!0 === c.options.fade && c.currentSlide === e) ||
                                c.slideCount <= c.options.slidesToShow
                                ? void 0
                                : (!1 === t && c.asNavFor(e),
                                    (i = e),
                                    (l = c.getLeft(i)),
                                    (s = c.getLeft(c.currentSlide)),
                                    (c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft),
                                    (!1 === c.options.infinite &&
                                        !1 === c.options.centerMode &&
                                        (e < 0 || e > c.getDotCount() * c.options.slidesToScroll)) ||
                                        (!1 === c.options.infinite &&
                                            !0 === c.options.centerMode &&
                                            (e < 0 || e > c.slideCount - c.options.slidesToScroll))
                                        ? void (
                                            !1 === c.options.fade &&
                                            ((i = c.currentSlide),
                                                !0 !== n
                                                    ? c.animateSlide(s, function () {
                                                        c.postSlide(i);
                                                    })
                                                    : c.postSlide(i))
                                        )
                                        : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                                            (o =
                                                i < 0
                                                    ? c.slideCount % c.options.slidesToScroll != 0
                                                        ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                                                        : c.slideCount + i
                                                    : i >= c.slideCount
                                                        ? c.slideCount % c.options.slidesToScroll != 0
                                                            ? 0
                                                            : i - c.slideCount
                                                        : i),
                                            (c.animating = !0),
                                            c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                                            (r = c.currentSlide),
                                            (c.currentSlide = o),
                                            c.setSlideClasses(c.currentSlide),
                                            c.options.asNavFor &&
                                            (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow &&
                                            a.setSlideClasses(c.currentSlide),
                                            c.updateDots(),
                                            c.updateArrows(),
                                            !0 === c.options.fade
                                                ? (!0 !== n
                                                    ? (c.fadeSlideOut(r),
                                                        c.fadeSlide(o, function () {
                                                            c.postSlide(o);
                                                        }))
                                                    : c.postSlide(o),
                                                    void c.animateHeight())
                                                : void (!0 !== n
                                                    ? c.animateSlide(l, function () {
                                                        c.postSlide(o);
                                                    })
                                                    : c.postSlide(o))))
                        );
                    }),
                    (s.prototype.startLoad = function () {
                        var e = this;
                        !0 === e.options.arrows &&
                            e.slideCount > e.options.slidesToShow &&
                            (e.$prevArrow.hide(), e.$nextArrow.hide()),
                            !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                            e.$slider.addClass("slick-loading");
                    }),
                    (s.prototype.swipeDirection = function () {
                        var e,
                            t,
                            n,
                            i,
                            o = this;
                        return (
                            (e = o.touchObject.startX - o.touchObject.curX),
                            (t = o.touchObject.startY - o.touchObject.curY),
                            (n = Math.atan2(t, e)),
                            (i = Math.round((180 * n) / Math.PI)) < 0 && (i = 360 - Math.abs(i)),
                            (i <= 45 && 0 <= i) || (i <= 360 && 315 <= i)
                                ? !1 === o.options.rtl
                                    ? "left"
                                    : "right"
                                : 135 <= i && i <= 225
                                    ? !1 === o.options.rtl
                                        ? "right"
                                        : "left"
                                    : !0 === o.options.verticalSwiping
                                        ? 35 <= i && i <= 135
                                            ? "down"
                                            : "up"
                                        : "vertical"
                        );
                    }),
                    (s.prototype.swipeEnd = function (e) {
                        var t,
                            n,
                            i = this;
                        if (
                            ((i.dragging = !1),
                                (i.interrupted = !1),
                                (i.shouldClick = !(10 < i.touchObject.swipeLength)),
                                void 0 === i.touchObject.curX)
                        )
                            return !1;
                        if (
                            (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]),
                                i.touchObject.swipeLength >= i.touchObject.minSwipe)
                        ) {
                            switch ((n = i.swipeDirection())) {
                                case "left":
                                case "down":
                                    (t = i.options.swipeToSlide
                                        ? i.checkNavigable(i.currentSlide + i.getSlideCount())
                                        : i.currentSlide + i.getSlideCount()),
                                        (i.currentDirection = 0);
                                    break;
                                case "right":
                                case "up":
                                    (t = i.options.swipeToSlide
                                        ? i.checkNavigable(i.currentSlide - i.getSlideCount())
                                        : i.currentSlide - i.getSlideCount()),
                                        (i.currentDirection = 1);
                            }
                            "vertical" != n && (i.slideHandler(t), (i.touchObject = {}), i.$slider.trigger("swipe", [i, n]));
                        } else
                            i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), (i.touchObject = {}));
                    }),
                    (s.prototype.swipeHandler = function (e) {
                        var t = this;
                        if (
                            !(
                                !1 === t.options.swipe ||
                                ("ontouchend" in document && !1 === t.options.swipe) ||
                                (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
                            )
                        )
                            switch (
                            ((t.touchObject.fingerCount =
                                e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1),
                                (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
                                !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
                                e.data.action)
                            ) {
                                case "start":
                                    t.swipeStart(e);
                                    break;
                                case "move":
                                    t.swipeMove(e);
                                    break;
                                case "end":
                                    t.swipeEnd(e);
                            }
                    }),
                    (s.prototype.swipeMove = function (e) {
                        var t,
                            n,
                            i,
                            o,
                            r,
                            s = this;
                        return (
                            (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
                            !(!s.dragging || (r && 1 !== r.length)) &&
                            ((t = s.getLeft(s.currentSlide)),
                                (s.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
                                (s.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
                                (s.touchObject.swipeLength = Math.round(
                                    Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))
                                )),
                                !0 === s.options.verticalSwiping &&
                                (s.touchObject.swipeLength = Math.round(
                                    Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2))
                                )),
                                "vertical" !== (n = s.swipeDirection())
                                    ? (void 0 !== e.originalEvent && 4 < s.touchObject.swipeLength && e.preventDefault(),
                                        (o = (!1 === s.options.rtl ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1)),
                                        !0 === s.options.verticalSwiping && (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
                                        (i = s.touchObject.swipeLength),
                                        (s.touchObject.edgeHit = !1) === s.options.infinite &&
                                        ((0 === s.currentSlide && "right" === n) ||
                                            (s.currentSlide >= s.getDotCount() && "left" === n)) &&
                                        ((i = s.touchObject.swipeLength * s.options.edgeFriction), (s.touchObject.edgeHit = !0)),
                                        !1 === s.options.vertical
                                            ? (s.swipeLeft = t + i * o)
                                            : (s.swipeLeft = t + i * (s.$list.height() / s.listWidth) * o),
                                        !0 === s.options.verticalSwiping && (s.swipeLeft = t + i * o),
                                        !0 !== s.options.fade &&
                                        !1 !== s.options.touchMove &&
                                        (!0 === s.animating ? ((s.swipeLeft = null), !1) : void s.setCSS(s.swipeLeft)))
                                    : void 0)
                        );
                    }),
                    (s.prototype.swipeStart = function (e) {
                        var t,
                            n = this;
                        return (
                            (n.interrupted = !0),
                            1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow
                                ? !(n.touchObject = {})
                                : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                                    (n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                                    (n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                                    void (n.dragging = !0))
                        );
                    }),
                    (s.prototype.unfilterSlides = s.prototype.slickUnfilter =
                        function () {
                            var e = this;
                            null !== e.$slidesCache &&
                                (e.unload(),
                                    e.$slideTrack.children(this.options.slide).detach(),
                                    e.$slidesCache.appendTo(e.$slideTrack),
                                    e.reinit());
                        }),
                    (s.prototype.unload = function () {
                        var e = this;
                        c(".slick-cloned", e.$slider).remove(),
                            e.$dots && e.$dots.remove(),
                            e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
                            e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
                            e.$slides
                                .removeClass("slick-slide slick-active slick-visible slick-current")
                                .attr("aria-hidden", "true")
                                .css("width", "");
                    }),
                    (s.prototype.unslick = function (e) {
                        this.$slider.trigger("unslick", [this, e]), this.destroy();
                    }),
                    (s.prototype.updateArrows = function () {
                        var e = this;
                        Math.floor(e.options.slidesToShow / 2),
                            !0 === e.options.arrows &&
                            e.slideCount > e.options.slidesToShow &&
                            !e.options.infinite &&
                            (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                                0 === e.currentSlide
                                    ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                                        e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                                    : ((e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode) ||
                                        (e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode)) &&
                                    (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                                        e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
                    }),
                    (s.prototype.updateDots = function () {
                        var e = this;
                        null !== e.$dots &&
                            (e.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
                                e.$dots
                                    .find("li")
                                    .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false"));
                    }),
                    (s.prototype.visibility = function () {
                        this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
                    }),
                    (c.fn.slick = function () {
                        var e,
                            t,
                            n = this,
                            i = arguments[0],
                            o = Array.prototype.slice.call(arguments, 1),
                            r = n.length;
                        for (e = 0; e < r; e++)
                            if (
                                ("object" == _typeof(i) || void 0 === i
                                    ? (n[e].slick = new s(n[e], i))
                                    : (t = n[e].slick[i].apply(n[e].slick, o)),
                                    void 0 !== t)
                            )
                                return t;
                        return n;
                    });
            }),
            (d = jQuery),
            (l = document),
            (c = window),
            (_ = {
                html: !1,
                photo: !1,
                iframe: !1,
                inline: !1,
                transition: "elastic",
                speed: 300,
                fadeOut: 300,
                width: !1,
                initialWidth: "600",
                innerWidth: !1,
                maxWidth: !1,
                height: !1,
                initialHeight: "450",
                innerHeight: !1,
                maxHeight: !1,
                scalePhotos: !0,
                scrolling: !0,
                opacity: 0.9,
                preloading: !0,
                className: !1,
                overlayClose: !0,
                escKey: !0,
                arrowKey: !0,
                top: !1,
                bottom: !1,
                left: !1,
                right: !1,
                fixed: !1,
                data: void 0,
                closeButton: !0,
                fastIframe: !0,
                open: !1,
                reposition: !0,
                loop: !0,
                slideshow: !1,
                slideshowAuto: !0,
                slideshowSpeed: 2500,
                slideshowStart: "start slideshow",
                slideshowStop: "stop slideshow",
                photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,
                retinaImage: !1,
                retinaUrl: !1,
                retinaSuffix: "@2x.$1",
                current: "image {current} of {total}",
                previous: "previous",
                next: "next",
                close: "close",
                xhrError: "This content failed to load.",
                imgError: "This image failed to load.",
                returnFocus: !0,
                trapFocus: !0,
                onOpen: !1,
                onLoad: !1,
                onComplete: !1,
                onCleanup: !1,
                onClosed: !1,
                rel: function () {
                    return this.rel;
                },
                href: function () {
                    return d(this).attr("href");
                },
                title: function () {
                    return this.title;
                },
                createImg: function () {
                    var n = new Image(),
                        e = d(this).data("cbox-img-attrs");
                    return (
                        "object" == _typeof(e) &&
                        d.each(e, function (e, t) {
                            n[e] = t;
                        }),
                        n
                    );
                },
                createIframe: function () {
                    var n = l.createElement("iframe"),
                        e = d(this).data("cbox-iframe-attrs");
                    return (
                        "object" == _typeof(e) &&
                        d.each(e, function (e, t) {
                            n[e] = t;
                        }),
                        "frameBorder" in n && (n.frameBorder = 0),
                        "allowTransparency" in n && (n.allowTransparency = "true"),
                        (n.name = new Date().getTime()),
                        (n.allowFullscreen = !0),
                        n
                    );
                },
            }),
            (B = "colorbox"),
            (X = (U = "cbox") + "Element"),
            (Y = U + "_open"),
            (V = U + "_load"),
            (Q = U + "_complete"),
            (G = U + "_cleanup"),
            (K = U + "_closed"),
            (Z = U + "_purge"),
            (J = d("<a/>")),
            (ee = "div"),
            (te = 0),
            (ne = {}),
            (R = U + "Slideshow_"),
            (F = "click." + U),
            (ie = function () {
                z
                    ? E.get("slideshow") || (J.unbind(G, $e), $e())
                    : E.get("slideshow") && b[1] && ((z = !0), J.one(G, $e), (E.get("slideshowAuto") ? Se : Ce)(), i.show());
            }),
            d[B] ||
            (d(xe),
                ((I =
                    d.fn[B] =
                    d[B] =
                    function (t, e) {
                        var n = this;
                        return (
                            (t = t || {}),
                            d.isFunction(n) && ((n = d("<a/>")), (t.open = !0)),
                            n[0] &&
                            (xe(),
                                p &&
                                (o ||
                                    ((o = !0),
                                        s.click(function () {
                                            I.next();
                                        }),
                                        a.click(function () {
                                            I.prev();
                                        }),
                                        C.click(function () {
                                            I.close();
                                        }),
                                        u.click(function () {
                                            E.get("overlayClose") && I.close();
                                        }),
                                        d(l).bind("keydown." + U, function (e) {
                                            var t = e.keyCode;
                                            N && E.get("escKey") && 27 === t && (e.preventDefault(), I.close()),
                                                N &&
                                                E.get("arrowKey") &&
                                                b[1] &&
                                                !e.altKey &&
                                                (37 === t ? (e.preventDefault(), a.click()) : 39 === t && (e.preventDefault(), s.click()));
                                        }),
                                        d.isFunction(d.fn.on) ? d(l).on("click." + U, "." + X, i) : d("." + X).live("click." + U, i)),
                                    1) &&
                                (e && (t.onComplete = e),
                                    n
                                        .each(function () {
                                            var e = d.data(this, B) || {};
                                            d.data(this, B, d.extend(e, t));
                                        })
                                        .addClass(X),
                                    new pe(n[0], t).get("open") && we(n[0]))),
                            n
                        );
                        function i(e) {
                            1 < e.which || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey || (e.preventDefault(), we(this));
                        }
                    }).position = function (t, e) {
                        function n() {
                            (g[0].style.width = y[0].style.width = h[0].style.width = parseInt(p[0].style.width, 10) - j + "px"),
                                (h[0].style.height = v[0].style.height = m[0].style.height = parseInt(p[0].style.height, 10) - A + "px");
                        }
                        var i,
                            o,
                            r,
                            s = 0,
                            a = 0,
                            l = p.offset();
                        if (
                            (w.unbind("resize." + U),
                                p.css({ top: -9e4, left: -9e4 }),
                                (o = w.scrollTop()),
                                (r = w.scrollLeft()),
                                E.get("fixed")
                                    ? ((l.top -= o), (l.left -= r), p.css({ position: "fixed" }))
                                    : ((s = o), (a = r), p.css({ position: "absolute" })),
                                (a +=
                                    !1 !== E.get("right")
                                        ? Math.max(w.width() - E.w - D - j - he(E.get("right"), "x"), 0)
                                        : !1 !== E.get("left")
                                            ? he(E.get("left"), "x")
                                            : Math.round(Math.max(w.width() - E.w - D - j, 0) / 2)),
                                (s +=
                                    !1 !== E.get("bottom")
                                        ? Math.max(ue() - E.h - L - A - he(E.get("bottom"), "y"), 0)
                                        : !1 !== E.get("top")
                                            ? he(E.get("top"), "y")
                                            : Math.round(Math.max(ue() - E.h - L - A, 0) / 2)),
                                p.css({ top: l.top, left: l.left, visibility: "visible" }),
                                (f[0].style.width = f[0].style.height = "9999px"),
                                (i = { width: E.w + D + j, height: E.h + L + A, top: s, left: a }),
                                t)
                        ) {
                            var c = 0;
                            d.each(i, function (e) {
                                return i[e] !== ne[e] ? void (c = t) : void 0;
                            }),
                                (t = c);
                        }
                        (ne = i),
                            t || p.css(i),
                            p.dequeue().animate(i, {
                                duration: t || 0,
                                complete: function () {
                                    n(),
                                        (P = !1),
                                        (f[0].style.width = E.w + D + j + "px"),
                                        (f[0].style.height = E.h + L + A + "px"),
                                        E.get("reposition") &&
                                        setTimeout(function () {
                                            w.bind("resize." + U, I.position);
                                        }, 1),
                                        d.isFunction(e) && e();
                                },
                                step: n,
                            });
                    }),
                (I.resize = function (e) {
                    var t;
                    N &&
                        ((e = e || {}).width && (E.w = he(e.width, "x") - D - j),
                            e.innerWidth && (E.w = he(e.innerWidth, "x")),
                            x.css({ width: E.w }),
                            e.height && (E.h = he(e.height, "y") - L - A),
                            e.innerHeight && (E.h = he(e.innerHeight, "y")),
                            e.innerHeight || e.height || ((t = x.scrollTop()), x.css({ height: "auto" }), (E.h = x.height())),
                            x.css({ height: E.h }),
                            t && x.scrollTop(t),
                            I.position("none" === E.get("transition") ? 0 : E.get("speed")));
                }),
                (I.prep = function (e) {
                    if (N) {
                        var t,
                            o = "none" === E.get("transition") ? 0 : E.get("speed");
                        x.remove(),
                            (x = de(ee, "LoadedContent").append(e))
                                .hide()
                                .appendTo(T.show())
                                .css({
                                    width: ((E.w = E.w || x.width()), (E.w = E.mw && E.mw < E.w ? E.mw : E.w), E.w),
                                    overflow: E.get("scrolling") ? "auto" : "hidden",
                                })
                                .css({ height: ((E.h = E.h || x.height()), (E.h = E.mh && E.mh < E.h ? E.mh : E.h), E.h) })
                                .prependTo(h),
                            T.hide(),
                            d(H).css({ cssFloat: "none" }),
                            ye(E.get("className")),
                            (t = function () {
                                function e() {
                                    !1 === d.support.opacity && p[0].style.removeAttribute("filter");
                                }
                                var t,
                                    n,
                                    i = b.length;
                                N &&
                                    ((n = function () {
                                        clearTimeout(M), k.hide(), be(Q), E.get("onComplete");
                                    }),
                                        S.html(E.get("title")).show(),
                                        x.show(),
                                        1 < i
                                            ? ("string" == typeof E.get("current") &&
                                                r
                                                    .html(
                                                        E.get("current")
                                                            .replace("{current}", O + 1)
                                                            .replace("{total}", i)
                                                    )
                                                    .show(),
                                                s[E.get("loop") || O < i - 1 ? "show" : "hide"]().html(E.get("next")),
                                                a[E.get("loop") || O ? "show" : "hide"]().html(E.get("previous")),
                                                ie(),
                                                E.get("preloading") &&
                                                d.each([fe(-1), fe(1)], function () {
                                                    var e = b[this],
                                                        t = new pe(e, d.data(e, B)),
                                                        n = t.get("href");
                                                    n && ge(t, n) && ((n = ve(t, n)), (l.createElement("img").src = n));
                                                }))
                                            : $.hide(),
                                        E.get("iframe")
                                            ? ((t = E.get("createIframe")),
                                                E.get("scrolling") || (t.scrolling = "no"),
                                                d(t)
                                                    .attr({ src: E.get("href"), class: U + "Iframe" })
                                                    .one("load", n)
                                                    .appendTo(x),
                                                J.one(Z, function () {
                                                    t.src = "//about:blank";
                                                }),
                                                E.get("fastIframe") && d(t).trigger("load"))
                                            : n(),
                                        "fade" === E.get("transition") ? p.fadeTo(o, 1, e) : e());
                            }),
                            "fade" === E.get("transition")
                                ? p.fadeTo(o, 0, function () {
                                    I.position(0, t);
                                })
                                : I.position(o, t);
                    }
                }),
                (I.next = function () {
                    !P && b[1] && (E.get("loop") || b[O + 1]) && ((O = fe(1)), we(b[O]));
                }),
                (I.prev = function () {
                    !P && b[1] && (E.get("loop") || O) && ((O = fe(-1)), we(b[O]));
                }),
                (I.close = function () {
                    N &&
                        !q &&
                        ((N = !(q = !0)),
                            be(G),
                            E.get("onCleanup"),
                            w.unbind("." + U),
                            u.fadeTo(E.get("fadeOut") || 0, 0),
                            p.stop().fadeTo(E.get("fadeOut") || 0, 0, function () {
                                p.hide(),
                                    u.hide(),
                                    be(Z),
                                    x.remove(),
                                    setTimeout(function () {
                                        (q = !1), be(K), E.get("onClosed");
                                    }, 1);
                            }));
                }),
                (I.remove = function () {
                    p &&
                        (p.stop(),
                            d[B].close(),
                            p.stop(!1, !0).remove(),
                            u.remove(),
                            (q = !1),
                            (p = null),
                            d("." + X)
                                .removeData(B)
                                .removeClass(X),
                            d(l)
                                .unbind("click." + U)
                                .unbind("keydown." + U));
                }),
                (I.element = function () {
                    return d(E.el);
                }),
                (I.settings = _)),
            (oe = window.jQuery),
            (re = {
                url: !1,
                callback: !1,
                target: !1,
                duration: 120,
                on: "mouseover",
                touch: !0,
                onZoomIn: !1,
                onZoomOut: !1,
                magnify: window.innerWidth < 970 ? 0.5 : 0.6,
            }),
            (oe.zoom = function (e, t, i, n) {
                var o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    d,
                    u = oe(e),
                    p = u.css("position"),
                    f = oe(t);
                return (
                    (e.style.position = /(absolute|fixed)/.test(p) ? p : "relative"),
                    (e.style.overflow = "hidden"),
                    (i.style.width = i.style.height = ""),
                    oe(i)
                        .addClass("zoomImg")
                        .attr("alt", "Zoom image")
                        .css({
                            position: "absolute",
                            top: 0,
                            left: 0,
                            opacity: 0,
                            width: i.width * n,
                            height: i.height * n,
                            border: "none",
                            maxWidth: "none",
                            maxHeight: "none",
                        })
                        .appendTo(e),
                    {
                        init: function () {
                            (r = u.outerWidth()),
                                (o = u.outerHeight()),
                                (s = t === e ? ((a = r), o) : ((a = f.outerWidth()), f.outerHeight())),
                                (l = (i.width - r) / a),
                                (c = (i.height - o) / s),
                                (d = f.offset());
                        },
                        move: function (e) {
                            var t = e.pageX - d.left,
                                n = e.pageY - d.top;
                            (n = Math.max(Math.min(n, s), 0)),
                                (t = Math.max(Math.min(t, a), 0)),
                                (i.style.left = t * -l + "px"),
                                (i.style.top = n * -c + "px");
                        },
                    }
                );
            }),
            (oe.fn.zoom = function (n) {
                return this.each(function () {
                    var o = oe.extend({}, re, n || {}),
                        r = (o.target && oe(o.target)[0]) || this,
                        e = this,
                        s = oe(e),
                        a = document.createElement("img"),
                        l = oe(a),
                        c = "mousemove.zoom",
                        d = !1,
                        u = !1;
                    if (!o.url) {
                        var t = e.querySelector("img");
                        if ((t && (o.url = t.getAttribute("data-src") || t.currentSrc || t.src), !o.url)) return;
                    }
                    s.one(
                        "zoom.destroy",
                        function (e, t) {
                            s.off(".zoom"), (r.style.position = e), (r.style.overflow = t), (a.onload = null), l.remove();
                        }.bind(this, r.style.position, r.style.overflow)
                    ),
                        (a.onload = function () {
                            function t(e) {
                                i.init(),
                                    i.move(e),
                                    l
                                        .stop()
                                        .fadeTo(oe.support.opacity ? o.duration : 0, 1, !!oe.isFunction(o.onZoomIn) && o.onZoomIn.call(a));
                            }
                            function n() {
                                l.stop().fadeTo(o.duration, 0, !!oe.isFunction(o.onZoomOut) && o.onZoomOut.call(a));
                            }
                            var i = oe.zoom(r, e, a, o.magnify);
                            "grab" === o.on
                                ? s.on("mousedown.zoom", function (e) {
                                    1 === e.which &&
                                        (oe(document).one("mouseup.zoom", function () {
                                            n(), oe(document).off(c, i.move);
                                        }),
                                            t(e),
                                            oe(document).on(c, i.move),
                                            e.preventDefault());
                                })
                                : "click" === o.on
                                    ? s.on("click.zoom", function (e) {
                                        return d
                                            ? void 0
                                            : ((d = !0),
                                                t(e),
                                                oe(document).on(c, i.move),
                                                oe(document).one("click.zoom", function () {
                                                    n(), (d = !1), oe(document).off(c, i.move);
                                                }),
                                                !1);
                                    })
                                    : "toggle" === o.on
                                        ? s.on("click.zoom", function (e) {
                                            d ? n() : t(e), (d = !d);
                                        })
                                        : "mouseover" === o.on && (i.init(), s.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(c, i.move)),
                                o.touch &&
                                s
                                    .on("touchstart.zoom", function (e) {
                                        e.preventDefault(),
                                            u
                                                ? ((u = !1), n())
                                                : ((u = !0), t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]));
                                    })
                                    .on("touchmove.zoom", function (e) {
                                        e.preventDefault(), i.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
                                    })
                                    .on("touchend.zoom", function (e) {
                                        e.preventDefault(), u && ((u = !1), n());
                                    }),
                                oe.isFunction(o.callback) && o.callback.call(a);
                        }),
                        (a.src = o.url);
                });
            }),
            (oe.fn.zoom.defaults = re),
            (le = e.event),
            (ce = window.innerWidth),
            (se = le.special.debouncedresize =
            {
                setup: function () {
                    e(this).on("resize", se.handler);
                },
                teardown: function () {
                    e(this).off("resize", se.handler);
                },
                handler: function (e, t) {
                    function n() {
                        (e.type = "debouncedresize"),
                            le.dispatch.apply(i, o),
                            ce !== window.innerWidth &&
                            ((e.type = "debouncedresizewidth"), le.dispatch.apply(i, o), (ce = window.innerWidth));
                    }
                    var i = this,
                        o = arguments;
                    ae && clearTimeout(ae), t ? n() : (ae = setTimeout(n, se.threshold));
                },
                threshold: 150,
            }),
            (function () {
                for (
                    var e = [
                        { base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" },
                        { base: "AA", letters: "Ꜳ" },
                        { base: "AE", letters: "ÆǼǢ" },
                        { base: "AO", letters: "Ꜵ" },
                        { base: "AU", letters: "Ꜷ" },
                        { base: "AV", letters: "ꜸꜺ" },
                        { base: "AY", letters: "Ꜽ" },
                        { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" },
                        { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" },
                        { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹÐ" },
                        { base: "DZ", letters: "ǱǄ" },
                        { base: "Dz", letters: "ǲǅ" },
                        { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" },
                        { base: "F", letters: "FⒻＦḞƑꝻ" },
                        { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" },
                        { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" },
                        { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" },
                        { base: "J", letters: "JⒿＪĴɈ" },
                        { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" },
                        { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" },
                        { base: "LJ", letters: "Ǉ" },
                        { base: "Lj", letters: "ǈ" },
                        { base: "M", letters: "MⓂＭḾṀṂⱮƜ" },
                        { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" },
                        { base: "NJ", letters: "Ǌ" },
                        { base: "Nj", letters: "ǋ" },
                        { base: "O", letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ" },
                        { base: "OI", letters: "Ƣ" },
                        { base: "OO", letters: "Ꝏ" },
                        { base: "OU", letters: "Ȣ" },
                        { base: "OE", letters: "Œ" },
                        { base: "oe", letters: "œ" },
                        { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" },
                        { base: "Q", letters: "QⓆＱꝖꝘɊ" },
                        { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" },
                        { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" },
                        { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" },
                        { base: "TZ", letters: "Ꜩ" },
                        { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" },
                        { base: "V", letters: "VⓋＶṼṾƲꝞɅ" },
                        { base: "VY", letters: "Ꝡ" },
                        { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" },
                        { base: "X", letters: "XⓍＸẊẌ" },
                        { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" },
                        { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" },
                        { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" },
                        { base: "aa", letters: "ꜳ" },
                        { base: "ae", letters: "æǽǣ" },
                        { base: "ao", letters: "ꜵ" },
                        { base: "au", letters: "ꜷ" },
                        { base: "av", letters: "ꜹꜻ" },
                        { base: "ay", letters: "ꜽ" },
                        { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" },
                        { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" },
                        { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" },
                        { base: "dz", letters: "ǳǆ" },
                        { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" },
                        { base: "f", letters: "fⓕｆḟƒꝼ" },
                        { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" },
                        { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" },
                        { base: "hv", letters: "ƕ" },
                        { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" },
                        { base: "j", letters: "jⓙｊĵǰɉ" },
                        { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" },
                        { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" },
                        { base: "lj", letters: "ǉ" },
                        { base: "m", letters: "mⓜｍḿṁṃɱɯ" },
                        { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" },
                        { base: "nj", letters: "ǌ" },
                        { base: "o", letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ" },
                        { base: "oi", letters: "ƣ" },
                        { base: "ou", letters: "ȣ" },
                        { base: "oo", letters: "ꝏ" },
                        { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" },
                        { base: "q", letters: "qⓠｑɋꝗꝙ" },
                        { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" },
                        { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" },
                        { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" },
                        { base: "tz", letters: "ꜩ" },
                        { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" },
                        { base: "v", letters: "vⓥｖṽṿʋꝟʌ" },
                        { base: "vy", letters: "ꝡ" },
                        { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" },
                        { base: "x", letters: "xⓧｘẋẍ" },
                        { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" },
                        { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" },
                    ],
                    t = {},
                    n = 0;
                    n < e.length;
                    n++
                )
                    for (var i = e[n].letters, o = 0; o < i.length; o++) t[i[o]] = e[n].base;
                window.removeDiacritics = function (e) {
                    return "string" != typeof e
                        ? (console.warn("Invalid parameter passed to window.removeDiacritics (".concat(_typeof(e), ")"), e), e)
                        : e.replace(/[^\u0000-\u007E]/g, function (e) {
                            return t[e] || e;
                        });
                };
            })());
    })(theme.jQuery);
</div></script></script|<style|<link>